import React from "react";
import { useCustomNavigate } from "../../hooks";
import * as routesName from "../../routes/routeName";

export const PHNIcon = () => {
	return (
		<svg
			className="absolute top-3 left-4 w-6 h-6 text-gray-400"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
			/>
		</svg>
	);
};

export const UserIcon = () => {
	return (
		<svg
			className="absolute top-3 left-4"
			width="20"
			height="26"
			viewBox="0 0 20 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_46_28-977712)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M14.5161 6.95161C14.5161 9.44581 12.4942 11.4677 10 11.4677C7.50581 11.4677 5.48387 9.44581 5.48387 6.95161C5.48387 4.45742 7.50581 2.43548 10 2.43548C12.4942 2.43548 14.5161 4.45742 14.5161 6.95161ZM16.4516 6.95161C16.4516 10.5147 13.5631 13.4032 10 13.4032C6.43688 13.4032 3.54839 10.5147 3.54839 6.95161C3.54839 3.38849 6.43688 0.5 10 0.5C13.5631 0.5 16.4516 3.38849 16.4516 6.95161ZM1.93548 22.4355C1.93548 20.1195 3.81299 18.2419 6.12903 18.2419H13.871C16.187 18.2419 18.0645 20.1195 18.0645 22.4355V23.7258C18.0645 24.2603 18.4978 24.6935 19.0323 24.6935C19.5667 24.6935 20 24.2603 20 23.7258V22.4355C20 19.0505 17.256 16.3065 13.871 16.3065H6.12903C2.74406 16.3065 0 19.0505 0 22.4355V23.7258C0 24.2603 0.433277 24.6935 0.967742 24.6935C1.50221 24.6935 1.93548 24.2603 1.93548 23.7258V22.4355Z"
					fill="#3A52BB"
				/>
			</g>
			<defs>
				<clipPath id="clip0_46_28-977712">
					<rect
						width="20"
						height="25"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
 
export const DoctorTimelineIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 4.5a2.5 2.5 0 0 0-2.5 2.5v2.5a4.5 4.5 0 0 0 4.5 4.5H10" stroke="#757575" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M12 4.5a2.5 2.5 0 0 1 2.5 2.5v2.5a4.5 4.5 0 0 1-4.5 4.5H9.5" stroke="#757575" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M14.5 14.5v1.25a3.75 3.75 0 1 1-7.5 0V14.5" stroke="#757575" strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="17.5" cy="16.5" r="2" stroke="#757575" strokeWidth="1.6" />
        <path d="M16 18.3 13.8 20.5a2.2 2.2 0 0 1-3.1 0l-.7-.7" stroke="#757575" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const NewUserIcon = ({ style = {} }) => {
	return (
		<div style={style}>
			<svg
				width="20"
				height="26"
				viewBox="0 0 20 26"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_46_28-977712)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M14.5161 6.95161C14.5161 9.44581 12.4942 11.4677 10 11.4677C7.50581 11.4677 5.48387 9.44581 5.48387 6.95161C5.48387 4.45742 7.50581 2.43548 10 2.43548C12.4942 2.43548 14.5161 4.45742 14.5161 6.95161ZM16.4516 6.95161C16.4516 10.5147 13.5631 13.4032 10 13.4032C6.43688 13.4032 3.54839 10.5147 3.54839 6.95161C3.54839 3.38849 6.43688 0.5 10 0.5C13.5631 0.5 16.4516 3.38849 16.4516 6.95161ZM1.93548 22.4355C1.93548 20.1195 3.81299 18.2419 6.12903 18.2419H13.871C16.187 18.2419 18.0645 20.1195 18.0645 22.4355V23.7258C18.0645 24.2603 18.4978 24.6935 19.0323 24.6935C19.5667 24.6935 20 24.2603 20 23.7258V22.4355C20 19.0505 17.256 16.3065 13.871 16.3065H6.12903C2.74406 16.3065 0 19.0505 0 22.4355V23.7258C0 24.2603 0.433277 24.6935 0.967742 24.6935C1.50221 24.6935 1.93548 24.2603 1.93548 23.7258V22.4355Z"
						fill="#3A52BB"
					/>
				</g>
				<defs>
					<clipPath id="clip0_46_28-977712">
						<rect
							width="20"
							height="25"
							fill="white"
							transform="translate(0 0.5)"
						/>
					</clipPath>
				</defs>
			</svg>
		</div>
	);
};

export const CalenderIcon = ({ width = 28, height = 27 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 28 27"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_46_30-708823)">
				<path
					d="M25 2.5H22V1.5C22 1.23478 21.8946 0.98043 21.7071 0.792893C21.5196 0.605357 21.2652 0.5 21 0.5C20.7348 0.5 20.4804 0.605357 20.2929 0.792893C20.1054 0.98043 20 1.23478 20 1.5V2.5H15V1.5C15 1.23478 14.8946 0.98043 14.7071 0.792893C14.5196 0.605357 14.2652 0.5 14 0.5C13.7348 0.5 13.4804 0.605357 13.2929 0.792893C13.1054 0.98043 13 1.23478 13 1.5V2.5H8V1.5C8 1.23478 7.89464 0.98043 7.70711 0.792893C7.51957 0.605357 7.26522 0.5 7 0.5C6.73478 0.5 6.48043 0.605357 6.29289 0.792893C6.10536 0.98043 6 1.23478 6 1.5V2.5H3C2.20435 2.5 1.44129 2.81607 0.87868 3.37868C0.316071 3.94129 0 4.70435 0 5.5V23.5C0 24.2956 0.316071 25.0587 0.87868 25.6213C1.44129 26.1839 2.20435 26.5 3 26.5H25C25.7956 26.5 26.5587 26.1839 27.1213 25.6213C27.6839 25.0587 28 24.2956 28 23.5V5.5C28 4.70435 27.6839 3.94129 27.1213 3.37868C26.5587 2.81607 25.7956 2.5 25 2.5ZM2 5.5C2 5.23478 2.10536 4.98043 2.29289 4.79289C2.48043 4.60536 2.73478 4.5 3 4.5H6V5.5C6 5.76522 6.10536 6.01957 6.29289 6.20711C6.48043 6.39464 6.73478 6.5 7 6.5C7.26522 6.5 7.51957 6.39464 7.70711 6.20711C7.89464 6.01957 8 5.76522 8 5.5V4.5H13V5.5C13 5.76522 13.1054 6.01957 13.2929 6.20711C13.4804 6.39464 13.7348 6.5 14 6.5C14.2652 6.5 14.5196 6.39464 14.7071 6.20711C14.8946 6.01957 15 5.76522 15 5.5V4.5H20V5.5C20 5.76522 20.1054 6.01957 20.2929 6.20711C20.4804 6.39464 20.7348 6.5 21 6.5C21.2652 6.5 21.5196 6.39464 21.7071 6.20711C21.8946 6.01957 22 5.76522 22 5.5V4.5H25C25.2652 4.5 25.5196 4.60536 25.7071 4.79289C25.8946 4.98043 26 5.23478 26 5.5V8.5H2V5.5ZM26 23.5C26 23.7652 25.8946 24.0196 25.7071 24.2071C25.5196 24.3946 25.2652 24.5 25 24.5H3C2.73478 24.5 2.48043 24.3946 2.29289 24.2071C2.10536 24.0196 2 23.7652 2 23.5V10.5H26V23.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M13 14.5H15C15.2652 14.5 15.5196 14.3946 15.7071 14.2071C15.8946 14.0196 16 13.7652 16 13.5C16 13.2348 15.8946 12.9804 15.7071 12.7929C15.5196 12.6054 15.2652 12.5 15 12.5H13C12.7348 12.5 12.4804 12.6054 12.2929 12.7929C12.1054 12.9804 12 13.2348 12 13.5C12 13.7652 12.1054 14.0196 12.2929 14.2071C12.4804 14.3946 12.7348 14.5 13 14.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M6 14.5H8C8.26522 14.5 8.51957 14.3946 8.70711 14.2071C8.89464 14.0196 9 13.7652 9 13.5C9 13.2348 8.89464 12.9804 8.70711 12.7929C8.51957 12.6054 8.26522 12.5 8 12.5H6C5.73478 12.5 5.48043 12.6054 5.29289 12.7929C5.10536 12.9804 5 13.2348 5 13.5C5 13.7652 5.10536 14.0196 5.29289 14.2071C5.48043 14.3946 5.73478 14.5 6 14.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M6 18.5H8C8.26522 18.5 8.51957 18.3946 8.70711 18.2071C8.89464 18.0196 9 17.7652 9 17.5C9 17.2348 8.89464 16.9804 8.70711 16.7929C8.51957 16.6054 8.26522 16.5 8 16.5H6C5.73478 16.5 5.48043 16.6054 5.29289 16.7929C5.10536 16.9804 5 17.2348 5 17.5C5 17.7652 5.10536 18.0196 5.29289 18.2071C5.48043 18.3946 5.73478 18.5 6 18.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M13 18.5H15C15.2652 18.5 15.5196 18.3946 15.7071 18.2071C15.8946 18.0196 16 17.7652 16 17.5C16 17.2348 15.8946 16.9804 15.7071 16.7929C15.5196 16.6054 15.2652 16.5 15 16.5H13C12.7348 16.5 12.4804 16.6054 12.2929 16.7929C12.1054 16.9804 12 17.2348 12 17.5C12 17.7652 12.1054 18.0196 12.2929 18.2071C12.4804 18.3946 12.7348 18.5 13 18.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M20 18.5H22C22.2652 18.5 22.5196 18.3946 22.7071 18.2071C22.8946 18.0196 23 17.7652 23 17.5C23 17.2348 22.8946 16.9804 22.7071 16.7929C22.5196 16.6054 22.2652 16.5 22 16.5H20C19.7348 16.5 19.4804 16.6054 19.2929 16.7929C19.1054 16.9804 19 17.2348 19 17.5C19 17.7652 19.1054 18.0196 19.2929 18.2071C19.4804 18.3946 19.7348 18.5 20 18.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M20 14.5H22C22.2652 14.5 22.5196 14.3946 22.7071 14.2071C22.8946 14.0196 23 13.7652 23 13.5C23 13.2348 22.8946 12.9804 22.7071 12.7929C22.5196 12.6054 22.2652 12.5 22 12.5H20C19.7348 12.5 19.4804 12.6054 19.2929 12.7929C19.1054 12.9804 19 13.2348 19 13.5C19 13.7652 19.1054 14.0196 19.2929 14.2071C19.4804 14.3946 19.7348 14.5 20 14.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M6 22.5H8C8.26522 22.5 8.51957 22.3946 8.70711 22.2071C8.89464 22.0196 9 21.7652 9 21.5C9 21.2348 8.89464 20.9804 8.70711 20.7929C8.51957 20.6054 8.26522 20.5 8 20.5H6C5.73478 20.5 5.48043 20.6054 5.29289 20.7929C5.10536 20.9804 5 21.2348 5 21.5C5 21.7652 5.10536 22.0196 5.29289 22.2071C5.48043 22.3946 5.73478 22.5 6 22.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M13 22.5H15C15.2652 22.5 15.5196 22.3946 15.7071 22.2071C15.8946 22.0196 16 21.7652 16 21.5C16 21.2348 15.8946 20.9804 15.7071 20.7929C15.5196 20.6054 15.2652 20.5 15 20.5H13C12.7348 20.5 12.4804 20.6054 12.2929 20.7929C12.1054 20.9804 12 21.2348 12 21.5C12 21.7652 12.1054 22.0196 12.2929 22.2071C12.4804 22.3946 12.7348 22.5 13 22.5Z"
					fill="#3A52BB"
				/>
				<path
					d="M20 22.5H22C22.2652 22.5 22.5196 22.3946 22.7071 22.2071C22.8946 22.0196 23 21.7652 23 21.5C23 21.2348 22.8946 20.9804 22.7071 20.7929C22.5196 20.6054 22.2652 20.5 22 20.5H20C19.7348 20.5 19.4804 20.6054 19.2929 20.7929C19.1054 20.9804 19 21.2348 19 21.5C19 21.7652 19.1054 22.0196 19.2929 22.2071C19.4804 22.3946 19.7348 22.5 20 22.5Z"
					fill="#3A52BB"
				/>
			</g>
			<defs>
				<clipPath id="clip0_46_30-708823">
					<rect
						width="28"
						height="26"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const ProvinceIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{ color: "#273A90" }}
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="w-6 h-6 absolute top-3 left-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
			/>
		</svg>
	);
};

export const SearchIcon = ({ color = '#273A90', className = 'absolute top-3 left-4 w-6 h-6' }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className={className}
			style={{ color: color }}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
			/>
		</svg>
	);
};

export const ResetIcon = () => {
	return (
		<svg className="font-bold text-white"
			fill="currentColor"
			width="16px"
			height="16px"
			viewBox="0 0 1920 1920"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M960 0v112.941c467.125 0 847.059 379.934 847.059 847.059 0 467.125-379.934 847.059-847.059 847.059-467.125 0-847.059-379.934-847.059-847.059 0-267.106 126.607-515.915 338.824-675.727v393.374h112.94V112.941H0v112.941h342.89C127.058 407.38 0 674.711 0 960c0 529.355 430.645 960 960 960s960-430.645 960-960S1489.355 0 960 0"
				fillRule="evenodd"
			/>
		</svg>
	);
};


export const AddressIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="absolute top-3 left-4 w-6 h-6"
			style={{ color: "#273A90" }}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
			/>
		</svg>
	);
};

export const CityIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{ color: "#273A90" }}
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="w-6 h-6 absolute top-3 left-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
			/>
		</svg>
	);
};

export const LocationIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			style={{ color: "#273A90" }}
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="w-6 h-6 absolute top-3 left-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
			/>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
			/>
		</svg>
	);
};

export const EnvelopIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="absolute top-3 left-4 w-6 h-6"
			style={{ color: "#273A90" }}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
			/>
		</svg>
	);
};

export const ViewIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.0019 12.9807C10.9462 12.9807 11.7481 12.6502 12.4079 11.9893C13.0676 11.3283 13.3974 10.5257 13.3974 9.58142C13.3974 8.63718 13.067 7.8352 12.406 7.17548C11.745 6.51576 10.9424 6.1859 9.99813 6.1859C9.05389 6.1859 8.25191 6.51638 7.59219 7.17735C6.93247 7.83834 6.6026 8.64096 6.6026 9.58521C6.6026 10.5294 6.93309 11.3314 7.59406 11.9911C8.25505 12.6509 9.05767 12.9807 10.0019 12.9807ZM10 11.8333C9.37502 11.8333 8.84377 11.6146 8.40627 11.1771C7.96877 10.7396 7.75002 10.2083 7.75002 9.58331C7.75002 8.95831 7.96877 8.42706 8.40627 7.98956C8.84377 7.55206 9.37502 7.33331 10 7.33331C10.625 7.33331 11.1563 7.55206 11.5938 7.98956C12.0313 8.42706 12.25 8.95831 12.25 9.58331C12.25 10.2083 12.0313 10.7396 11.5938 11.1771C11.1563 11.6146 10.625 11.8333 10 11.8333ZM10.0012 15.4166C8.08482 15.4166 6.33872 14.888 4.76285 13.8309C3.18701 12.7737 2.02676 11.3579 1.2821 9.58331C2.02676 7.80874 3.18663 6.39288 4.76173 5.33573C6.33681 4.27858 8.08253 3.75 9.99888 3.75C11.9152 3.75 13.6613 4.27858 15.2372 5.33573C16.813 6.39288 17.9733 7.80874 18.7179 9.58331C17.9733 11.3579 16.8134 12.7737 15.2383 13.8309C13.6632 14.888 11.9175 15.4166 10.0012 15.4166ZM10 14.1666C11.5695 14.1666 13.0104 13.7535 14.3229 12.9271C15.6354 12.1007 16.6389 10.9861 17.3334 9.58331C16.6389 8.18054 15.6354 7.06595 14.3229 6.23956C13.0104 5.41317 11.5695 4.99998 10 4.99998C8.43058 4.99998 6.9896 5.41317 5.6771 6.23956C4.3646 7.06595 3.36113 8.18054 2.66669 9.58331C3.36113 10.9861 4.3646 12.1007 5.6771 12.9271C6.9896 13.7535 8.43058 14.1666 10 14.1666Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const Note = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 6.72843C18 6.64182 17.9822 6.55612 17.9479 6.4766C17.9136 6.39707 17.8635 6.32538 17.8006 6.26591L12.4095 1.17397C12.2946 1.06527 12.1433 1.00325 11.9851 1H5.3338C4.71484 1 4.12123 1.24588 3.68356 1.68356C3.24588 2.12123 3 2.71484 3 3.3338V16.9123C3 17.5312 3.24588 18.1248 3.68356 18.5625C4.12123 19.0002 4.71484 19.2461 5.3338 19.2461H15.6662C16.2851 19.2461 16.8787 19.0002 17.3164 18.5625C17.7541 18.1248 18 17.5312 18 16.9123V6.72843ZM15.6662 17.9731H5.3338C5.05245 17.9731 4.78264 17.8614 4.58369 17.6624C4.38475 17.4635 4.27299 17.1936 4.27299 16.9123V3.3338C4.27299 3.05245 4.38475 2.78264 4.58369 2.58369C4.78264 2.38475 5.05245 2.27299 5.3338 2.27299H11.3487V6.10254C11.3487 6.44016 11.4828 6.76395 11.7215 7.00268C11.9602 7.24141 12.284 7.37553 12.6216 7.37553H16.727V16.9123C16.727 17.1936 16.6153 17.4635 16.4163 17.6624C16.2174 17.8614 15.9475 17.9731 15.6662 17.9731Z"
				fill="#757575"
			/>
			<path
				d="M14.4823 14.8225H6.46888C6.30008 14.8225 6.13819 14.8895 6.01882 15.0089C5.89945 15.1283 5.83239 15.2902 5.83239 15.459C5.83239 15.6278 5.89945 15.7897 6.01882 15.9091C6.13819 16.0285 6.30008 16.0955 6.46888 16.0955H14.4823C14.6511 16.0955 14.813 16.0285 14.9324 15.9091C15.0518 15.7897 15.1188 15.6278 15.1188 15.459C15.1188 15.2902 15.0518 15.1283 14.9324 15.0089C14.813 14.8895 14.6511 14.8225 14.4823 14.8225Z"
				fill="#757575"
			/>
			<path
				d="M14.4823 12.0706H6.46888C6.30008 12.0706 6.13819 12.1376 6.01882 12.257C5.89945 12.3764 5.83239 12.5383 5.83239 12.7071C5.83239 12.8759 5.89945 13.0378 6.01882 13.1572C6.13819 13.2766 6.30008 13.3436 6.46888 13.3436H14.4823C14.6511 13.3436 14.813 13.2766 14.9324 13.1572C15.0518 13.0378 15.1188 12.8759 15.1188 12.7071C15.1188 12.5383 15.0518 12.3764 14.9324 12.257C14.813 12.1376 14.6511 12.0706 14.4823 12.0706Z"
				fill="#757575"
			/>
			<path
				d="M14.4823 8.85016H6.46888C6.3853 8.85016 6.30253 8.86662 6.22531 8.89861C6.14809 8.93059 6.07792 8.97749 6.01882 9.03658C5.95972 9.09569 5.91283 9.16585 5.88085 9.24308C5.84886 9.3203 5.83239 9.40307 5.83239 9.48665C5.83239 9.57024 5.84886 9.65301 5.88085 9.73022C5.91283 9.80745 5.95972 9.87761 6.01882 9.93672C6.07792 9.99583 6.14809 10.0427 6.22531 10.0747C6.30253 10.1067 6.3853 10.1231 6.46888 10.1231H14.4823C14.6511 10.1231 14.813 10.0561 14.9324 9.93672C15.0518 9.81735 15.1188 9.65546 15.1188 9.48665C15.1188 9.31784 15.0518 9.15595 14.9324 9.03658C14.813 8.91722 14.6511 8.85016 14.4823 8.85016Z"
				fill="#757575"
			/>
			<path
				d="M6.46888 7.15279H9.43918C9.60799 7.15279 9.76988 7.08574 9.88925 6.96637C10.0086 6.847 10.0757 6.68511 10.0757 6.5163C10.0757 6.34749 10.0086 6.1856 9.88925 6.06623C9.76988 5.94687 9.60799 5.87981 9.43918 5.87981H6.46888C6.30008 5.87981 6.13819 5.94687 6.01882 6.06623C5.89945 6.1856 5.83239 6.34749 5.83239 6.5163C5.83239 6.68511 5.89945 6.847 6.01882 6.96637C6.13819 7.08574 6.30008 7.15279 6.46888 7.15279Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const PrintIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.43266 9.81465C2.19352 9.81465 2 10.0049 2 10.2396V11.3062C2 12.806 3.24432 14.0263 4.77342 14.0263H5.57198V16.7786C5.57198 17.4522 6.12971 18 6.81504 18H13.185C13.8703 18 14.428 17.4522 14.428 16.7786V14.0263H15.2266C16.7557 14.0263 18 12.806 18 11.3062V7.0436C18 5.54365 16.7557 4.32344 15.2266 4.32344H14.428V2.10878C14.428 1.49743 13.9218 1 13.2994 1H6.70054C6.07817 1 5.57199 1.49743 5.57199 2.10878V4.32344H4.77343C3.24433 4.32344 2 5.54365 2 7.0436V7.68961C2 7.92432 2.19352 8.11461 2.43266 8.11461C2.67181 8.11461 2.86533 7.92432 2.86533 7.68961V7.0436C2.86533 6.01243 3.72135 5.17344 4.77343 5.17344H15.2266C16.2786 5.17344 17.1347 6.01243 17.1347 7.0436V11.3062C17.1347 12.3374 16.2786 13.1762 15.2266 13.1762H14.428V10.1632C14.428 9.92852 14.2345 9.73827 13.9954 9.73827H6.00464C5.7655 9.73827 5.57198 9.92852 5.57198 10.1632V13.1762H4.77342C3.72134 13.1762 2.86532 12.3374 2.86532 11.3062V10.2396C2.86532 10.0049 2.6718 9.81465 2.43266 9.81465ZM6.4373 2.10878C6.4373 1.96601 6.55518 1.85001 6.70054 1.85001H13.2994C13.4448 1.85001 13.5627 1.96601 13.5627 2.10878V4.32282H6.4373V2.10878ZM6.4373 10.5882H13.5627V16.7786C13.5627 16.9834 13.3933 17.15 13.185 17.15H6.81503C6.60673 17.15 6.4373 16.9834 6.4373 16.7786L6.4373 10.5882Z"
				fill="#757575"
			/>
			<path
				d="M14.9505 8.08165C15.2494 8.08165 15.4913 7.8395 15.4913 7.54083C15.4913 7.24216 15.2494 7 14.9505 7H13.5408C13.2419 7 13 7.24216 13 7.54083C13 7.8395 13.2419 8.08165 13.5408 8.08165H14.9505Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const RemoveIcon = ({ color = "#757575" }) => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.03787 6.30008C5.05357 6.29512 5.06986 6.29126 5.08615 6.28796L10.1684 4.9978C10.1841 4.99284 10.2004 4.98843 10.2167 4.98567L16.6018 3.36484L16.4057 2.67099C16.3517 2.47975 16.2208 2.32709 16.0533 2.2356L16.0521 2.23506L16.0516 2.2356C15.8834 2.14357 15.6788 2.11216 15.4769 2.16341L11.637 3.13834L11.6341 3.13944L11.6317 3.13999L8.29614 3.98705L8.29324 3.98815L8.29091 3.98871L4.45043 4.96363C4.24919 5.01488 4.08865 5.13943 3.99094 5.29926L3.97989 5.31634C3.89149 5.47231 3.8624 5.65913 3.91475 5.84376L4.11076 6.53706L5.03787 6.30174V6.30008ZM10.9205 8.81757C10.9205 8.58448 11.12 8.39545 11.366 8.39545C11.612 8.39545 11.8109 8.58448 11.8109 8.81757V11.9904C11.8109 12.2235 11.6114 12.4119 11.366 12.4119C11.12 12.4119 10.9205 12.2229 10.9205 11.9904V8.81757ZM10.9205 14.4207C10.9205 14.1876 11.12 13.9992 11.366 13.9992C11.612 13.9992 11.8109 14.1882 11.8109 14.4207V15.1593C11.8109 15.3924 11.6114 15.5814 11.366 15.5814C11.12 15.5814 10.9205 15.3924 10.9205 15.1593V14.4207ZM14.1334 8.81757C14.1334 8.58448 14.3329 8.39545 14.5783 8.39545C14.8244 8.39545 15.0233 8.58448 15.0233 8.81757V11.9904C15.0233 12.2235 14.8238 12.4119 14.5783 12.4119C14.3323 12.4119 14.1334 12.2229 14.1334 11.9904V8.81757ZM14.1334 14.4207C14.1334 14.1876 14.3329 13.9992 14.5783 13.9992C14.8244 13.9992 15.0233 14.1882 15.0233 14.4207V15.1593C15.0233 15.3924 14.8238 15.5814 14.5783 15.5814C14.3323 15.5814 14.1334 15.3924 14.1334 15.1593V14.4207ZM7.70754 8.81757C7.70754 8.58448 7.90703 8.39545 8.15306 8.39545C8.39851 8.39545 8.59801 8.58448 8.59801 8.81757V11.9904C8.59801 12.2235 8.39851 12.4119 8.15306 12.4119C7.90703 12.4119 7.70754 12.2229 7.70754 11.9904V8.81757ZM7.70754 14.4207C7.70754 14.1876 7.90703 13.9992 8.15306 13.9992C8.39851 13.9992 8.59801 14.1882 8.59801 14.4207V15.1593C8.59801 15.3924 8.39851 15.5814 8.15306 15.5814C7.90703 15.5814 7.70754 15.3924 7.70754 15.1593V14.4207ZM7.65926 3.27501C7.61098 2.83467 7.71626 2.40094 7.94135 2.03224L7.94193 2.03114L7.94135 2.03059C8.21937 1.57372 8.68118 1.21659 9.25932 1.07C9.83687 0.923401 10.4249 1.01378 10.9082 1.27832L10.9344 1.2943C11.3113 1.50758 11.6213 1.82723 11.8074 2.22238L15.2471 1.34886C15.6845 1.23754 16.1306 1.30643 16.4965 1.50648L16.496 1.50703C16.8617 1.70764 17.1473 2.03886 17.2642 2.45275L17.5754 3.55332C17.6388 3.77818 17.498 4.0091 17.2607 4.06917L13.6873 4.97631H17.555C17.8011 4.97631 18 5.16533 18 5.39791V16.0328C18 16.849 17.6475 17.5908 17.0804 18.1287C16.5133 18.666 15.7305 19 14.8691 19H7.86283C7.00144 19 6.21857 18.666 5.65149 18.1287C5.0844 17.5908 4.73194 16.849 4.73194 16.0328V7.24965L3.91126 7.45798C3.67396 7.51805 3.43026 7.38468 3.36686 7.15983L3.05569 6.05925C2.94169 5.65583 3.008 5.2447 3.20633 4.90356L3.22203 4.87545C3.43316 4.52935 3.78272 4.25875 4.22069 4.14798L7.65985 3.27446L7.65926 3.27501ZM10.9304 2.44448C10.8204 2.26647 10.6651 2.12098 10.4842 2.01792L10.4627 2.00689C10.1777 1.85093 9.83047 1.79747 9.48906 1.88455C9.14822 1.97107 8.87544 2.1827 8.71026 2.45275L8.70968 2.4522C8.60033 2.63241 8.53868 2.83908 8.53752 3.05236L10.9304 2.44448ZM5.62183 7.0237V16.0328C5.62183 16.6164 5.87367 17.1471 6.28022 17.5318C6.68678 17.9165 7.24689 18.1557 7.86225 18.1557H14.8685C15.4845 18.1557 16.0446 17.9165 16.4506 17.5318C16.8565 17.1471 17.1089 16.6164 17.1089 16.0328V5.82006H10.3632L5.62183 7.0237Z"
				fill={color}
			/>
		</svg>
	);
};

export const EditIcon = () => {
	return (
		<svg
			width="16"
			height="4"
			viewBox="0 0 16 4"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_100_8-333535)">
				<path
					d="M16 2C16 3.10457 15.0962 4 13.9812 4C12.8663 4 11.9624 3.10457 11.9624 2C11.9624 0.89543 12.8663 -4.87367e-08 13.9812 0C15.0962 4.87364e-08 16 0.895431 16 2Z"
					fill="#757575"
				/>
				<path
					d="M10.0188 2C10.0188 3.10457 9.11499 4 8.00002 4C6.88506 4 5.9812 3.10457 5.9812 2C5.9812 0.89543 6.88506 -4.87367e-08 8.00002 0C9.11499 4.87364e-08 10.0188 0.895431 10.0188 2Z"
					fill="#757575"
				/>
				<path
					d="M4.03765 2C4.03765 3.10457 3.13379 4 2.01882 4C0.903858 4 -4.82822e-08 3.10457 0 2C4.82823e-08 0.89543 0.903858 -4.87367e-08 2.01882 0C3.13379 4.87364e-08 4.03765 0.895431 4.03765 2Z"
					fill="#757575"
				/>
			</g>
			<defs>
				<clipPath id="clip0_100_8-333535">
					<rect width="16" height="4" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const EditMode = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 28 28"
			strokeWidth={1.5}
			stroke="currentColor"
			className="w-6 h-6"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
			/>
		</svg>
	);
};

export const Visible = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 28 28"
			strokeWidth={1.5}
			stroke="currentColor"
			className="w-6 h-6 pt-1"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
			/>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
			/>
		</svg>
	);
};

export const LinkClinicIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.20837 16.6474V6.06409H6.20837V3.06409H13.2917V9.06409H16.7917V16.6474H11.2084V13.6474H8.79167V16.6474H3.20837ZM4.29167 15.5641H6.20837V13.6474H4.29167V15.5641ZM4.29167 12.3141H6.20837V10.3974H4.29167V12.3141ZM4.29167 9.06409H6.20837V7.1474H4.29167V9.06409ZM7.29167 12.3141H9.20837V10.3974H7.29167V12.3141ZM7.29167 9.06409H9.20837V7.1474H7.29167V9.06409ZM7.29167 6.06409H9.20837V4.1474H7.29167V6.06409ZM10.2917 12.3141H12.2084V10.3974H10.2917V12.3141ZM10.2917 9.06409H12.2084V7.1474H10.2917V9.06409ZM10.2917 6.06409H12.2084V4.1474H10.2917V6.06409ZM13.7917 15.5641H15.7084V13.6474H13.7917V15.5641ZM13.7917 12.3141H15.7084V10.3974H13.7917V12.3141Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const ClinicIcon = () => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.20837 16.6474V6.06409H6.20837V3.06409H13.2917V9.06409H16.7917V16.6474H11.2084V13.6474H8.79167V16.6474H3.20837ZM4.29167 15.5641H6.20837V13.6474H4.29167V15.5641ZM4.29167 12.3141H6.20837V10.3974H4.29167V12.3141ZM4.29167 9.06409H6.20837V7.1474H4.29167V9.06409ZM7.29167 12.3141H9.20837V10.3974H7.29167V12.3141ZM7.29167 9.06409H9.20837V7.1474H7.29167V9.06409ZM7.29167 6.06409H9.20837V4.1474H7.29167V6.06409ZM10.2917 12.3141H12.2084V10.3974H10.2917V12.3141ZM10.2917 9.06409H12.2084V7.1474H10.2917V9.06409ZM10.2917 6.06409H12.2084V4.1474H10.2917V6.06409ZM13.7917 15.5641H15.7084V13.6474H13.7917V15.5641ZM13.7917 12.3141H15.7084V10.3974H13.7917V12.3141Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const ModalCloseIcon = ({ className = "w-3 h-3" }) => {
	return (
		<svg
			className={className}
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 14 14"
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
			/>
		</svg>
	);
};

export const TopSearchIcon = () => {
	return (
		<svg
			width="20"
			height="21"
			className="absolute left-3 top-3"
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_2_54-538021)">
				<path
					d="M19.6681 18.1192L16.0787 14.5544C18.8814 10.965 18.5864 5.85126 15.3657 2.63061C13.6693 0.934235 11.4075 0 8.99816 0C6.58881 0 4.32698 0.934235 2.63061 2.63061C0.934235 4.32698 0 6.58881 0 8.99816C0 11.4075 0.934235 13.6693 2.63061 15.3657C4.32698 17.0621 6.58881 17.9963 8.99816 17.9963C10.9896 17.9963 12.9564 17.3325 14.5298 16.0787L18.0947 19.6927C18.3159 19.914 18.5864 20.0123 18.8814 20.0123C19.1764 20.0123 19.4468 19.8894 19.6681 19.6927C20.1106 19.2747 20.1106 18.5618 19.6681 18.1192ZM15.7837 8.99816C15.7837 10.8175 15.0707 12.5138 13.7923 13.7923C12.5138 15.0707 10.7929 15.7837 8.99816 15.7837C7.20344 15.7837 5.48248 15.0707 4.20406 13.7923C2.92563 12.5138 2.21266 10.7929 2.21266 8.99816C2.21266 7.17886 2.92563 5.48248 4.20406 4.20406C5.48248 2.92563 7.20344 2.21266 8.99816 2.21266C10.8175 2.21266 12.5138 2.92563 13.7923 4.20406C15.0707 5.48248 15.7837 7.17886 15.7837 8.99816Z"
					fill="#757575"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2_54-538021">
					<rect width="20" height="21" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const TaskAssignIcon = () => {
	return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="19" height="23" viewBox="0 0 22 26" strokeWidth={1.5} stroke="currentColor" className="text-white">
		<path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
			fill="white"
		/>
	</svg>
	);
};

export const BellIcon = () => {
	return (
		<svg
			width="19"
			height="23"
			viewBox="0 0 22 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.9375 3.00978C5.37922 3.92519 2.75 7.154 2.75 10.9997V16.4992C2.75 17.0059 2.3383 17.4167 1.83429 17.4167C0.821239 17.4167 0 18.2395 0 19.25C0 20.2625 0.822274 21.0833 1.83787 21.0833H20.1621C21.1772 21.0833 22 20.2605 22 19.25C22 18.2375 21.1749 17.4167 20.1657 17.4167C19.66 17.4167 19.25 17.0091 19.25 16.4992V10.9997C19.25 7.15553 16.6213 3.9255 13.0625 3.00981V2.06289C13.0625 0.920906 12.1391 0 11 0C9.86323 0 8.9375 0.923588 8.9375 2.06289V3.00978ZM7.79167 22H14.2083C14.2083 23.7719 12.7719 25.2083 11 25.2083C9.22809 25.2083 7.79167 23.7719 7.79167 22Z"
				fill="white"
			/>
		</svg>
	);
};

export const ProfileIcon = () => {
	return (
		<svg
			width="18"
			height="19"
			viewBox="0 0 18 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_73_8-278254)">
				<path
					d="M0 18.108C0 18.6135 0.374926 19 0.865213 19C1.3555 19 1.73043 18.6135 1.73043 18.108V17.216C1.73043 14.0939 3.63389 11.2692 6.4891 10.2285C6.54678 10.1987 6.60446 10.169 6.66214 10.1393C7.35431 10.4961 8.133 10.7042 8.94053 10.7042C9.74806 10.7042 10.5268 10.4961 11.2189 10.1393C11.2766 10.169 11.3343 10.1987 11.392 10.2285C14.2472 11.2692 16.1506 14.0939 16.1506 17.216V18.108C16.1506 18.6135 16.5256 19 17.0159 19C17.5061 19 17.8811 18.6135 17.8811 18.108V17.216C17.8811 13.6479 15.8622 10.4366 12.8051 8.92019C13.6415 7.9687 14.1318 6.71987 14.1318 5.35211C14.1318 2.40845 11.7957 0 8.94053 0C6.08533 0 3.74926 2.40845 3.74926 5.35211C3.74926 6.71987 4.26838 7.9687 5.07591 8.92019C2.01883 10.4069 0 13.6479 0 17.216V18.108ZM8.94053 1.7543C10.844 1.7543 12.4014 3.35994 12.4014 5.32238C12.4014 7.28482 10.844 8.89045 8.94053 8.89045C7.03706 8.89045 5.47968 7.28482 5.47968 5.32238C5.47968 3.35994 7.03706 1.7543 8.94053 1.7543Z"
					fill="#757575"
				/>
			</g>
			<defs>
				<clipPath id="clip0_73_8-278254">
					<rect width="18" height="19" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const TimeSheetIcon = () => {
	return (
		<span>
			<svg
				width="18"
				height="19"
				viewBox="0 0 22 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M17.6456 3.32912C17.6456 1.48797 16.1576 0 14.3165 0H4.32912C2.48797 0 1 1.48804 1 3.32912V17.3266C1 18.2093 1.35311 19.0416 1.98362 19.6721C2.61414 20.3025 3.44646 20.6557 4.32914 20.6557C4.32914 21.5384 4.68225 22.3707 5.31277 23.0012C5.94328 23.6317 6.7756 23.9848 7.65828 23.9848H15.3254C16.2081 23.9848 17.0404 23.6317 17.6709 23.0012L20.0164 20.6557C20.6469 20.0252 21 19.1929 21 18.3102L20.9998 6.63304C20.9746 4.81711 19.4867 3.32912 17.6456 3.32912ZM4.32912 6.63302V19.5207C3.7238 19.5207 3.19419 19.2937 2.76548 18.865C2.33678 18.4363 2.10977 17.8814 2.10977 17.3014V3.32918C2.10977 2.09335 3.11859 1.10977 4.32918 1.10977H14.3166C15.5524 1.10977 16.536 2.09339 16.536 3.32918H7.6583C5.81716 3.32918 4.32912 4.81716 4.32912 6.63302ZM7.65824 22.8499C7.05292 22.8499 6.49811 22.6229 6.0946 22.1942C5.6659 21.7654 5.43889 21.2105 5.43889 20.6305L5.43881 6.63308C5.43881 5.42245 6.42243 4.41367 7.65822 4.41367H17.6456C18.8562 4.41367 19.865 5.39729 19.865 6.63308V17.9319L16.9394 17.9318C15.8549 17.9318 14.9722 18.8146 14.9722 19.8991V22.8247L7.65824 22.8499ZM16.8638 22.1942C16.6368 22.4212 16.3594 22.5977 16.0568 22.6986V19.9243C16.0568 19.4451 16.4351 19.0668 16.9143 19.0668H19.6886C19.5877 19.3694 19.4112 19.6469 19.1842 19.8738L16.8638 22.1942Z"
					fill="#757575"
				/>
				<path
					d="M9.20252 12.0048H16.7939C17.0965 12.0048 17.3487 11.7526 17.3487 11.45C17.3487 11.1474 17.0965 10.8952 16.7939 10.8952L9.20252 10.8951C8.89991 10.8951 8.64771 11.1473 8.64771 11.45C8.64771 11.7526 8.89991 12.0048 9.20252 12.0048Z"
					fill="#757575"
				/>
				<path
					d="M16.7939 15.561C17.0965 15.561 17.3487 15.3088 17.3487 15.0062C17.3487 14.7036 17.0965 14.4514 16.7939 14.4514H9.20252C8.89991 14.4514 8.64771 14.7036 8.64771 15.0062C8.64771 15.3088 8.89991 15.561 9.20252 15.561H16.7939Z"
					fill="#757575"
				/>
				<path
					d="M9.20252 8.47408H16.7939C17.0965 8.47408 17.3487 8.22188 17.3487 7.91927C17.3487 7.61667 17.0965 7.36446 16.7939 7.36446L9.20252 7.36438C8.89991 7.36438 8.64771 7.61659 8.64771 7.91919C8.64771 8.22188 8.89991 8.47408 9.20252 8.47408Z"
					fill="#757575"
				/>
			</svg>
		</span>
	);
};

export const SettingIcon = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_72_15-586481)">
				<path
					d="M17.7804 7.68604L16.1676 7.0164C16.0056 6.42959 15.7716 5.86802 15.4692 5.33522L16.1388 3.71883C16.1928 3.58198 16.164 3.43081 16.0596 3.3264L14.6736 1.94041C14.5728 1.83604 14.418 1.80721 14.2812 1.86122L12.6684 2.53081C12.1392 2.23198 11.574 1.99441 10.9836 1.83243L10.3176 0.219595C10.26 0.0863965 10.1304 0 9.98282 0H8.02441C7.88041 0 7.74721 0.0863965 7.6932 0.219595L7.0236 1.83243C6.4332 1.99441 5.868 2.23198 5.33881 2.53081L3.72601 1.86122C3.59282 1.80721 3.438 1.83604 3.3336 1.94041L1.94761 3.3264C1.8468 3.43081 1.81441 3.58198 1.872 3.71883L2.538 5.33522C2.23561 5.86802 2.0016 6.42959 1.8432 7.0164L0.223198 7.68604C0.09 7.74 0 7.8732 0 8.01721V9.97559C0 10.1196 0.09 10.2528 0.223198 10.3068L1.8432 10.9764C2.0052 11.5776 2.23921 12.1428 2.538 12.6612L1.872 14.274C1.81441 14.4072 1.8468 14.562 1.94761 14.6664L3.3336 16.0524C3.438 16.1532 3.59282 16.1856 3.72601 16.1316L5.3352 15.4656C5.8752 15.7752 6.44401 16.0092 7.02721 16.1712L7.6932 17.7768C7.74721 17.91 7.88041 18 8.02441 18H9.98282C10.1304 18 10.26 17.91 10.3176 17.7768L10.98 16.164C11.5596 16.0092 12.1284 15.7752 12.6756 15.4656L14.2812 16.1316C14.418 16.1856 14.5728 16.1532 14.6736 16.0524L16.0596 14.6664C16.164 14.562 16.1928 14.4072 16.1388 14.274L15.4692 12.6612C15.768 12.1428 16.002 11.5776 16.1676 10.9764L17.7804 10.3068C17.9136 10.2528 18 10.1196 18 9.97559V8.01721C18 7.8732 17.9136 7.74 17.7804 7.68604ZM9 12.582C7.0236 12.582 5.418 10.9764 5.418 9C5.418 7.0236 7.0236 5.41441 9 5.41441C10.9764 5.41441 12.5856 7.0236 12.5856 9C12.5856 10.9764 10.9764 12.582 9 12.582Z"
					fill="#757575"
				/>
			</g>
			<defs>
				<clipPath id="clip0_72_15-586481">
					<rect width="18" height="18" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const LogOutIcon = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_72_17-474858)">
				<path
					d="M13.1094 9.97941C12.7435 9.95876 12.4284 10.2389 12.4074 10.6058C12.3752 11.1703 12.3395 11.6097 12.3062 11.8464C12.2257 12.4346 11.9256 13.0109 11.4606 13.47C11.0856 13.8401 10.6304 14.1065 10.1518 14.2417L10.185 13.7729C10.185 13.7683 10.1857 13.7638 10.1857 13.7592C10.2288 12.9014 10.2551 11.9357 10.2617 10.9672C10.274 9.36036 10.2274 7.69683 10.1409 6.62645C10.0761 5.82042 9.81843 4.97693 9.41507 4.25073C8.99735 3.49968 8.44167 2.90758 7.85098 2.58335L7.83558 2.57495C7.40105 2.3372 7.0257 2.13202 6.37653 1.85821C6.37233 1.85646 6.36813 1.85471 6.36358 1.85295C6.33591 1.8421 5.678 1.58299 4.8268 1.43699C4.79949 1.43243 4.77288 1.42858 4.74557 1.42438C5.41539 1.36205 6.15139 1.33054 6.94201 1.33054C7.99629 1.33054 8.95323 1.38656 9.78377 1.49651C10.3958 1.58054 10.9911 1.88202 11.4603 2.34561C11.9249 2.80464 12.2253 3.38098 12.3062 3.97167C12.3391 4.20556 12.3748 4.64534 12.407 5.20942C12.428 5.57637 12.7435 5.85649 13.1091 5.83583C13.476 5.81482 13.7565 5.50074 13.7355 5.13379C13.7113 4.70942 13.6725 4.13098 13.6241 3.78854C13.504 2.91144 13.0678 2.06269 12.3955 1.39882C11.7232 0.734949 10.8601 0.301473 9.96199 0.177872C9.07088 0.0598744 8.05476 0 6.94236 0C5.82961 0 4.81349 0.0598744 3.91958 0.178223C3.02462 0.301123 2.16151 0.734599 1.48924 1.39847C0.817317 2.06269 0.381039 2.91144 0.26129 3.78609C0.152396 4.55886 0.0592582 6.7609 0.0666112 7.90762C0.0659109 8.02142 0.066261 8.14572 0.0673114 8.27807C0.0554066 9.77388 0.13664 11.3341 0.280548 12.3677C0.348476 12.8593 0.518645 13.3369 0.786854 13.7879C0.854082 13.9255 0.925511 14.0586 0.998691 14.1832C1.42972 14.9189 1.98994 15.5134 2.57818 15.8583L2.65241 15.9017C3.2382 16.2438 3.74416 16.539 4.98156 17.0674C6.25573 17.6062 6.75609 17.7249 7.33522 17.8622L7.36849 17.8699C7.51835 17.9049 7.66821 17.922 7.81562 17.922C8.35799 17.922 8.8727 17.6892 9.27326 17.2519C9.64196 16.8485 9.90422 16.2795 10.0271 15.6269C10.9 15.4928 11.739 15.0649 12.3958 14.4161C13.0681 13.7522 13.5044 12.9035 13.6241 12.0288C13.6728 11.6836 13.7117 11.1055 13.7358 10.6808C13.7568 10.3138 13.476 10.0004 13.1094 9.97941ZM5.86777 3.08756C6.45006 3.33336 6.77989 3.51368 7.19621 3.74162L7.21197 3.75038C7.58032 3.95241 7.95988 4.37083 8.25295 4.89744C8.56597 5.46047 8.76555 6.11244 8.81562 6.73359C8.89931 7.76826 8.94413 9.38662 8.93222 10.9577C8.92592 11.8919 8.89931 12.8604 8.85799 13.686L8.7533 15.164C8.69518 15.6636 8.52711 16.0975 8.29181 16.3548C8.10659 16.5572 7.90315 16.6293 7.67171 16.5754L7.643 16.5687C7.10063 16.4399 6.67205 16.3384 5.50257 15.8436C4.3436 15.3489 3.89367 15.0859 3.32364 14.7533L3.25046 14.7105C2.8625 14.4829 2.46054 14.046 2.14716 13.511C2.08693 13.408 2.02776 13.2974 1.97209 13.1818C1.96298 13.1629 1.95318 13.1447 1.94233 13.1268C1.75885 12.824 1.64365 12.5078 1.59919 12.186C1.46088 11.1923 1.3842 9.66779 1.39925 8.20559C1.41081 6.749 1.5141 5.22203 1.66956 4.21957C1.7459 3.72412 2.11284 3.1933 2.56208 2.92859C2.88491 2.73847 3.30018 2.66879 3.7319 2.66879C4.57085 2.66879 5.47071 2.93279 5.86847 3.08861L5.86777 3.08756Z"
					fill="#757575"
				/>
				<path
					d="M17.6943 7.09879L15.5994 4.9048C15.3455 4.63904 14.9246 4.62924 14.6589 4.88309C14.3931 5.13695 14.3833 5.55782 14.6372 5.82358L15.946 7.19438H11.426C11.0587 7.19438 10.7607 7.49236 10.7607 7.85966C10.7607 8.22695 11.0587 8.52493 11.426 8.52493H15.946L14.6372 9.89573C14.3833 10.1615 14.3931 10.5827 14.6589 10.8362C14.7877 10.9591 14.953 11.0204 15.1183 11.0204C15.2937 11.0204 15.4688 10.9514 15.5997 10.8145L17.6946 8.62051C18.1018 8.19404 18.1015 7.52562 17.6943 7.09879Z"
					fill="#757575"
				/>
			</g>
			<defs>
				<clipPath id="clip0_72_17-474858">
					<rect width="18" height="18" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const OrignialPrescriptionIcon = () => {
	return (
		<svg
			className="w-7 h-7 text-gray-500 dark:text-gray-400 mb-3 mx-auto"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 20"
		>
			<path d="M18 5h-.7c.229-.467.349-.98.351-1.5a3.5 3.5 0 0 0-3.5-3.5c-1.717 0-3.215 1.2-4.331 2.481C8.4.842 6.949 0 5.5 0A3.5 3.5 0 0 0 2 3.5c.003.52.123 1.033.351 1.5H2a2 2 0 0 0-2 2v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a2 2 0 0 0-2-2ZM8.058 5H5.5a1.5 1.5 0 0 1 0-3c.9 0 2 .754 3.092 2.122-.219.337-.392.635-.534.878Zm6.1 0h-3.742c.933-1.368 2.371-3 3.739-3a1.5 1.5 0 0 1 0 3h.003ZM11 13H9v7h2v-7Zm-4 0H2v5a2 2 0 0 0 2 2h3v-7Zm6 0v7h3a2 2 0 0 0 2-2v-5h-5Z" />
		</svg>
	);
};

export const FaxedPrescripitionIcon = () => {
	return (
		<svg
			className="w-7 h-7 text-gray-500 dark:text-gray-400 mb-3 mx-auto"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 20"
		>
			<path d="M18 5h-.7c.229-.467.349-.98.351-1.5a3.5 3.5 0 0 0-3.5-3.5c-1.717 0-3.215 1.2-4.331 2.481C8.4.842 6.949 0 5.5 0A3.5 3.5 0 0 0 2 3.5c.003.52.123 1.033.351 1.5H2a2 2 0 0 0-2 2v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a2 2 0 0 0-2-2ZM8.058 5H5.5a1.5 1.5 0 0 1 0-3c.9 0 2 .754 3.092 2.122-.219.337-.392.635-.534.878Zm6.1 0h-3.742c.933-1.368 2.371-3 3.739-3a1.5 1.5 0 0 1 0 3h.003ZM11 13H9v7h2v-7Zm-4 0H2v5a2 2 0 0 0 2 2h3v-7Zm6 0v7h3a2 2 0 0 0 2-2v-5h-5Z" />
		</svg>
	);
};

export const VerbalPrescriptionIcon = () => {
	return (
		<svg
			className="w-7 h-7 text-gray-500 dark:text-gray-400 mb-3 mx-auto"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 20"
		>
			<path d="M18 5h-.7c.229-.467.349-.98.351-1.5a3.5 3.5 0 0 0-3.5-3.5c-1.717 0-3.215 1.2-4.331 2.481C8.4.842 6.949 0 5.5 0A3.5 3.5 0 0 0 2 3.5c.003.52.123 1.033.351 1.5H2a2 2 0 0 0-2 2v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a2 2 0 0 0-2-2ZM8.058 5H5.5a1.5 1.5 0 0 1 0-3c.9 0 2 .754 3.092 2.122-.219.337-.392.635-.534.878Zm6.1 0h-3.742c.933-1.368 2.371-3 3.739-3a1.5 1.5 0 0 1 0 3h.003ZM11 13H9v7h2v-7Zm-4 0H2v5a2 2 0 0 0 2 2h3v-7Zm6 0v7h3a2 2 0 0 0 2-2v-5h-5Z" />
		</svg>
	);
};

export const TransferPrescriptionIcon = () => {
	return (
		<svg
			className="w-7 h-7 text-gray-500 dark:text-gray-400 mb-3 mx-auto"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 20"
		>
			<path d="M18 5h-.7c.229-.467.349-.98.351-1.5a3.5 3.5 0 0 0-3.5-3.5c-1.717 0-3.215 1.2-4.331 2.481C8.4.842 6.949 0 5.5 0A3.5 3.5 0 0 0 2 3.5c.003.52.123 1.033.351 1.5H2a2 2 0 0 0-2 2v3a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a2 2 0 0 0-2-2ZM8.058 5H5.5a1.5 1.5 0 0 1 0-3c.9 0 2 .754 3.092 2.122-.219.337-.392.635-.534.878Zm6.1 0h-3.742c.933-1.368 2.371-3 3.739-3a1.5 1.5 0 0 1 0 3h.003ZM11 13H9v7h2v-7Zm-4 0H2v5a2 2 0 0 0 2 2h3v-7Zm6 0v7h3a2 2 0 0 0 2-2v-5h-5Z" />
		</svg>
	);
};

export const TimeOffTypeIcon = () => {
	return (
		<svg
			className="absolute top-3 left-4"
			width="25"
			height="26"
			viewBox="0 0 25 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_46_20-526494)">
				<path
					d="M24.4963 17.8336C24.3885 18.1731 24.2086 18.4854 23.969 18.7491C23.7294 19.0128 23.4358 19.2218 23.1081 19.3617L9.60553 25.1355L9.30629 24.9932C3.22586 22.1063 2.41154 21.6697 2.22758 21.5275L3.28473 20.4507C4.11376 20.8824 7.39558 22.4571 9.63742 23.5216L22.5317 18.0077C22.6649 17.9509 22.7844 17.8659 22.8818 17.7587C22.9792 17.6514 23.0523 17.5244 23.0961 17.3863C23.1399 17.2482 23.1533 17.1023 23.1355 16.9585C23.1176 16.8147 23.069 16.6765 22.9928 16.5532C22.8678 16.3493 22.674 16.1967 22.4465 16.123C22.219 16.0492 21.9726 16.0592 21.7517 16.151L11.9332 20.1907L7.24105 17.7992L7.90821 16.4894L11.9994 18.5743L13.6992 17.8728C13.4324 17.3323 13.0841 16.836 12.6666 16.4011C9.87288 13.502 4.60677 13.2959 1.50402 15.9302L0.113281 15.2434C0.186867 15.1337 0.277061 15.0361 0.380634 14.954C4.0132 11.6992 10.3732 11.9028 13.7262 15.3783C14.2723 15.9469 14.7236 16.5995 15.063 17.3111L21.19 14.7897C21.6264 14.6097 22.1052 14.5582 22.57 14.6411C23.0347 14.724 23.4661 14.9379 23.8134 15.2577C24.1608 15.5774 24.4095 15.9897 24.5305 16.446C24.6515 16.9024 24.6396 17.3838 24.4963 17.8336Z"
					fill="#3A52BB"
				/>
				<path
					d="M11.5485 12.1038L8.61475 9.17003L9.65521 8.12956L11.5485 10.0229L15.0454 6.52618L16.0859 7.56665L11.5485 12.1038Z"
					fill="#3A52BB"
				/>
				<path
					d="M21.0581 9.31502C21.0607 11.0037 20.5687 12.6563 19.6428 14.0685H17.8032C18.5713 13.1874 19.1146 12.1334 19.3864 10.9965C19.6582 9.85966 19.6505 8.67388 19.3639 7.54066C19.0774 6.40743 18.5205 5.36051 17.741 4.48948C16.9615 3.61846 15.9826 2.94927 14.888 2.53919C13.7934 2.12911 12.6157 1.99036 11.4558 2.1348C10.2959 2.27924 9.18822 2.70258 8.22762 3.36858C7.26702 4.03459 6.4821 4.92342 5.94002 5.95902C5.39795 6.99461 5.11486 8.14613 5.115 9.31502C5.11394 10.0966 5.24156 10.8731 5.49272 11.6133H3.95238C3.74563 10.8647 3.64166 10.0916 3.64333 9.31502C3.64333 7.00569 4.56071 4.79094 6.19366 3.15799C7.8266 1.52505 10.0414 0.607666 12.3507 0.607666C14.66 0.607666 16.8748 1.52505 18.5077 3.15799C20.1407 4.79094 21.0581 7.00569 21.0581 9.31502Z"
					fill="#3A52BB"
				/>
			</g>
			<defs>
				<clipPath id="clip0_46_20-526494">
					<rect
						width="25"
						height="25"
						fill="white"
						transform="translate(0 0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export const ClockIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			style={{ color: "#3A52BB" }}
			fill="none"
			strokeWidth={1.5}
			stroke="currentColor"
			className="absolute top-3 left-4"
			width="20"
			height="26"
			viewBox="0 0 24 26"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
			/>
		</svg>
	);
};

export const ProfileCoverIcon = () => {
	return (
		<svg
			className="mx-auto"
			width="30"
			height="15"
			viewBox="0 0 52 37"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_107_17-025926)">
				<path
					d="M42.9951 1.60986H45.3376C46.0276 1.60986 46.5868 2.16811 46.5868 2.85662V6.85462H41.7457V2.8548C41.7468 2.16702 42.3058 1.60986 42.9951 1.60986Z"
					fill="#575B6D"
				></path>
				<path
					d="M33.2172 1.16614e-07H18.7827C18.0899 -0.000121507 17.4536 0.38129 17.1283 0.991717L14.002 6.85481H37.9981L34.8711 0.989162C34.545 0.380073 33.9091 -0.00024313 33.2172 1.16614e-07Z"
					fill="#DBD8DD"
				></path>
				<path
					d="M3.12315 5.05176H48.8769C50.6017 5.05176 52 6.44726 52 8.16872V33.8831C52 35.6045 50.6017 37 48.8769 37H3.12315C1.39827 37.0001 0 35.6046 0 33.8832V8.16872C0 6.44726 1.39827 5.05176 3.12315 5.05176Z"
					fill="#DBD8DD"
				></path>
				<path d="M0 12.5586H52V29.4942H0V12.5586Z" fill="#575B6D"></path>
				<path
					d="M26 33.7405C33.0361 33.7405 38.74 28.0479 38.74 21.0258C38.74 14.0036 33.0361 8.31104 26 8.31104C18.9639 8.31104 13.26 14.0036 13.26 21.0258C13.26 28.0479 18.9639 33.7405 26 33.7405Z"
					fill="#686D82"
				></path>
				<path
					d="M35.6162 21.0266C35.6265 26.3396 31.3193 30.6549 25.9958 30.6651C20.6723 30.6755 16.3484 26.3768 16.3382 21.0638C16.3278 15.7508 20.635 11.4355 25.9585 11.4253C27.9171 11.4215 29.8303 12.0132 31.4435 13.1218C34.0522 14.9116 35.6123 17.8672 35.6162 21.0266Z"
					fill="#419BE9"
				></path>
				<path
					d="M33.1239 18.5392C33.1316 23.8335 28.8373 28.1317 23.5324 28.1394C21.5794 28.1422 19.6719 27.5507 18.0642 26.4439C15.0596 22.0775 16.1706 16.1071 20.5456 13.1084C23.8295 10.8577 28.1645 10.8623 31.4435 13.1204C32.5391 14.7158 33.1249 16.605 33.1239 18.5392Z"
					fill="#69B0EE"
				></path>
				<path
					d="M24.754 17.9224C25.8176 17.9224 26.6799 17.0618 26.6799 16.0003C26.6799 14.9387 25.8176 14.0781 24.754 14.0781C23.6903 14.0781 22.828 14.9387 22.828 16.0003C22.828 17.0618 23.6903 17.9224 24.754 17.9224Z"
					fill="#EEEFEE"
				></path>
				<path
					d="M21.5756 20.6399C22.0498 20.6399 22.4342 20.2563 22.4342 19.783C22.4342 19.3097 22.0498 18.926 21.5756 18.926C21.1014 18.926 20.7169 19.3097 20.7169 19.783C20.7169 20.2563 21.1014 20.6399 21.5756 20.6399Z"
					fill="#EEEFEE"
				></path>
				<path
					d="M6.65081 10.8488C7.55369 10.8488 8.28562 10.1184 8.28562 9.21727C8.28562 8.31618 7.55369 7.58569 6.65081 7.58569C5.74792 7.58569 5.01599 8.31618 5.01599 9.21727C5.01599 10.1184 5.74792 10.8488 6.65081 10.8488Z"
					fill="#EF5261"
				></path>
				<path
					d="M39.7305 22.014C39.7341 24.7032 38.8789 27.3235 37.2891 29.4948H35.5009C39.8216 24.6728 39.8216 17.3806 35.5009 12.5586C38.1961 14.965 39.7349 18.4047 39.7305 22.014Z"
					fill="#464956"
				></path>
				<path
					d="M37.2877 29.4948C33.1514 35.171 25.1877 36.4262 19.5 32.298C18.7646 31.7642 18.0885 31.1533 17.4833 30.4756C22.7041 35.1713 30.7506 34.754 35.4555 29.5435C35.4701 29.5272 35.4848 29.5109 35.4994 29.4946L37.2877 29.4948Z"
					fill="#BBBBCD"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_107_17-025926">
					<rect width="52" height="37" fill="white"></rect>
				</clipPath>
			</defs>
		</svg>
	);
};

export const ProfileCameraIcon = ({ width = '30', height = '10' }) => {
	return (
		<svg
			className="relative mx-auto"
			width={width}
			height={height}
			viewBox="0 0 52 37"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_107_17-025926)">
				<path
					d="M42.9951 1.60986H45.3376C46.0276 1.60986 46.5868 2.16811 46.5868 2.85662V6.85462H41.7457V2.8548C41.7468 2.16702 42.3058 1.60986 42.9951 1.60986Z"
					fill="#575B6D"
				></path>
				<path
					d="M33.2172 1.16614e-07H18.7827C18.0899 -0.000121507 17.4536 0.38129 17.1283 0.991717L14.002 6.85481H37.9981L34.8711 0.989162C34.545 0.380073 33.9091 -0.00024313 33.2172 1.16614e-07Z"
					fill="#DBD8DD"
				></path>
				<path
					d="M3.12315 5.05176H48.8769C50.6017 5.05176 52 6.44726 52 8.16872V33.8831C52 35.6045 50.6017 37 48.8769 37H3.12315C1.39827 37.0001 0 35.6046 0 33.8832V8.16872C0 6.44726 1.39827 5.05176 3.12315 5.05176Z"
					fill="#DBD8DD"
				></path>
				<path d="M0 12.5586H52V29.4942H0V12.5586Z" fill="#575B6D"></path>
				<path
					d="M26 33.7405C33.0361 33.7405 38.74 28.0479 38.74 21.0258C38.74 14.0036 33.0361 8.31104 26 8.31104C18.9639 8.31104 13.26 14.0036 13.26 21.0258C13.26 28.0479 18.9639 33.7405 26 33.7405Z"
					fill="#686D82"
				></path>
				<path
					d="M35.6162 21.0266C35.6265 26.3396 31.3193 30.6549 25.9958 30.6651C20.6723 30.6755 16.3484 26.3768 16.3382 21.0638C16.3278 15.7508 20.635 11.4355 25.9585 11.4253C27.9171 11.4215 29.8303 12.0132 31.4435 13.1218C34.0522 14.9116 35.6123 17.8672 35.6162 21.0266Z"
					fill="#419BE9"
				></path>
				<path
					d="M33.1239 18.5392C33.1316 23.8335 28.8373 28.1317 23.5324 28.1394C21.5794 28.1422 19.6719 27.5507 18.0642 26.4439C15.0596 22.0775 16.1706 16.1071 20.5456 13.1084C23.8295 10.8577 28.1645 10.8623 31.4435 13.1204C32.5391 14.7158 33.1249 16.605 33.1239 18.5392Z"
					fill="#69B0EE"
				></path>
				<path
					d="M24.754 17.9224C25.8176 17.9224 26.6799 17.0618 26.6799 16.0003C26.6799 14.9387 25.8176 14.0781 24.754 14.0781C23.6903 14.0781 22.828 14.9387 22.828 16.0003C22.828 17.0618 23.6903 17.9224 24.754 17.9224Z"
					fill="#EEEFEE"
				></path>
				<path
					d="M21.5756 20.6399C22.0498 20.6399 22.4342 20.2563 22.4342 19.783C22.4342 19.3097 22.0498 18.926 21.5756 18.926C21.1014 18.926 20.7169 19.3097 20.7169 19.783C20.7169 20.2563 21.1014 20.6399 21.5756 20.6399Z"
					fill="#EEEFEE"
				></path>
				<path
					d="M6.65081 10.8488C7.55369 10.8488 8.28562 10.1184 8.28562 9.21727C8.28562 8.31618 7.55369 7.58569 6.65081 7.58569C5.74792 7.58569 5.01599 8.31618 5.01599 9.21727C5.01599 10.1184 5.74792 10.8488 6.65081 10.8488Z"
					fill="#EF5261"
				></path>
				<path
					d="M39.7305 22.014C39.7341 24.7032 38.8789 27.3235 37.2891 29.4948H35.5009C39.8216 24.6728 39.8216 17.3806 35.5009 12.5586C38.1961 14.965 39.7349 18.4047 39.7305 22.014Z"
					fill="#464956"
				></path>
				<path
					d="M37.2877 29.4948C33.1514 35.171 25.1877 36.4262 19.5 32.298C18.7646 31.7642 18.0885 31.1533 17.4833 30.4756C22.7041 35.1713 30.7506 34.754 35.4555 29.5435C35.4701 29.5272 35.4848 29.5109 35.4994 29.4946L37.2877 29.4948Z"
					fill="#BBBBCD"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_107_17-025926">
					<rect width="52" height="37" fill="white"></rect>
				</clipPath>
			</defs>
		</svg>
	);
};

export const DashBoardSidebarIcon = () => {
	return (
		<>
			<span>
				<svg
					width="21"
					height="22"
					viewBox="0 0 21 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_1_38-133386)">
						<path
							d="M18.9782 5.50099L11.7276 0.386293C11.3686 0.134719 10.9428 0 10.5068 0C10.0707 0 9.64494 0.134719 9.28593 0.386293L2.0421 5.50099C1.56915 5.83359 1.18205 6.27717 0.913607 6.79415C0.645163 7.31113 0.503287 7.88626 0.5 8.47081V18.3702C0.501792 19.3335 0.879544 20.2568 1.55035 20.9373C2.22115 21.6178 3.13019 22 4.07795 22H16.9288C17.8754 21.9982 18.7827 21.6152 19.452 20.9349C20.1214 20.2545 20.4982 19.3323 20.5 18.3702V8.47081C20.499 7.88807 20.3602 7.31412 20.0954 6.79728C19.8305 6.28045 19.4474 5.83587 18.9782 5.50099ZM19.0932 18.384C19.0932 18.9619 18.8673 19.5162 18.4652 19.9249C18.0631 20.3336 17.5177 20.5632 16.9491 20.5632H11.2339V17.6071C11.8451 17.7011 12.4691 17.6615 13.0642 17.491C13.6592 17.3205 14.2117 17.023 14.6847 16.6184C15.1577 16.2137 15.5404 15.7112 15.8072 15.1444C16.074 14.5775 16.2189 13.9594 16.2322 13.3311V11.8462C16.234 11.7482 16.2164 11.6508 16.1803 11.5599C16.1442 11.469 16.0905 11.3864 16.0223 11.3171C15.9541 11.2478 15.8728 11.1931 15.7834 11.1565C15.6939 11.1198 15.5981 11.1019 15.5017 11.1038H14.0407C13.3338 11.1219 12.6421 11.3163 12.0265 11.67C11.4108 12.0236 10.8901 12.5256 10.5101 13.1318C10.1264 12.5297 9.60329 12.0325 8.98658 11.6838C8.36986 11.335 7.67839 11.1453 6.97278 11.1313H5.51184C5.41508 11.1268 5.31851 11.1435 5.22866 11.1803C5.1388 11.2171 5.05777 11.273 4.99104 11.3444C4.92253 11.4135 4.8686 11.4961 4.83255 11.5871C4.7965 11.6781 4.77909 11.7756 4.78137 11.8737V13.3586C4.7951 13.9907 4.94248 14.6124 5.21352 15.1815C5.48456 15.7505 5.8729 16.2537 6.35218 16.6567C6.83145 17.0597 7.39044 17.3532 7.99118 17.5172C8.59192 17.6812 9.22034 17.7118 9.83378 17.6071V20.5426H4.07795C3.50931 20.5426 2.96396 20.313 2.56187 19.9043C2.15978 19.4956 1.93389 18.9413 1.93389 18.3633V8.47081C1.93382 8.11782 2.01812 7.77009 2.17953 7.45755C2.34094 7.145 2.57463 6.87698 2.8605 6.67654L10.1043 1.58247C10.2238 1.49911 10.3653 1.4545 10.5101 1.4545C10.655 1.4545 10.7965 1.49911 10.916 1.58247L18.1666 6.68342C18.4524 6.88385 18.6861 7.15187 18.8475 7.46442C19.0089 7.77697 19.0932 8.12469 19.0932 8.47768V18.384Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_1_38-133386">
							<rect
								width="20"
								height="22"
								fill="white"
								transform="translate(0.5)"
							/>
						</clipPath>
					</defs>
				</svg>
			</span>
			{/* Dashboard < span className="ml-auto" > */}
			<span style={{ textDecoration: "underline" }}>D</span>
			<span className="absolute left-16" style={{ marginLeft: "2px" }}>
				ashboard
			</span>
			<span className="ml-auto">
				<svg
					width="6"
					height="10"
					viewBox="0 0 6 10"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_12_6-577312)">
						<path
							d="M5.99497 4.92779C5.97787 4.81692 5.92396 4.7139 5.84088 4.63336L1.28929 0.189307C1.23928 0.133782 1.17769 0.0884199 1.10831 0.0560056C1.03893 0.0235912 0.963215 0.00480791 0.885809 0.000808488C0.808403 -0.00319093 0.730933 0.0076778 0.65817 0.0327477C0.585407 0.0578177 0.518878 0.0965603 0.462663 0.146597C0.406449 0.196635 0.36174 0.256911 0.331272 0.323728C0.300804 0.390545 0.285217 0.462493 0.28548 0.535157C0.285744 0.607821 0.301847 0.679668 0.3328 0.746289C0.363753 0.81291 0.408911 0.872899 0.465488 0.922576L4.64371 5L0.465487 9.07742C0.40891 9.1271 0.363753 9.18709 0.3328 9.25371C0.301846 9.32033 0.285745 9.39218 0.28548 9.46484C0.285216 9.5375 0.300804 9.60945 0.331272 9.67627C0.36174 9.74309 0.406448 9.80337 0.462663 9.8534C0.518878 9.90344 0.585406 9.94218 0.658169 9.96725C0.730933 9.99232 0.808402 10.0032 0.885809 9.99919C0.963215 9.99519 1.03893 9.97641 1.10831 9.94399C1.17769 9.91158 1.23928 9.86622 1.28929 9.81069L5.84088 5.36663C5.90002 5.30899 5.94456 5.23963 5.97124 5.16366C5.99791 5.0877 6.00603 5.00709 5.99497 4.92779Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_12_6-577312">
							<rect width="6" height="10" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
		</>
	);
};

export const TimeOffRequestIcon = () => {
	return (
		<>
			<span>
				<svg
					width="20"
					height="21"
					viewBox="0 0 20 21"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_29_2-963499)">
						<path
							d="M18.8008 18.2062H18.5623V15.7785C18.5623 14.2264 17.9546 12.7626 16.8535 11.655C16.2457 11.0537 15.5269 10.5963 14.7394 10.3055C16.9972 9.47231 18.5623 7.29293 18.5623 4.82928V2.3983H18.8008C19.4609 2.3983 20 1.86244 20 1.19915C20 0.53586 19.4641 0 18.8008 0H6.65578C5.99575 0 5.45662 0.539128 5.45662 1.19915C5.45662 1.85917 5.99575 2.3983 6.65578 2.3983H6.8943V4.38817C6.59696 4.34243 6.29309 4.31302 5.98595 4.31302C2.68584 4.31302 0 6.99886 0 10.299C0 13.5991 2.68584 16.2849 5.98595 16.2849C6.29636 16.2849 6.59696 16.2555 6.8943 16.2098V18.2062H6.65578C5.99575 18.2062 5.45662 18.7453 5.45662 19.4053C5.45662 20.0653 5.99575 20.6045 6.65578 20.6045H18.7976C19.4576 20.6045 19.9967 20.0653 19.9967 19.4053C19.9967 18.7453 19.4609 18.2062 18.8008 18.2062ZM1.35925 13.256L1.97027 12.9031C2.08789 12.8345 2.1271 12.6842 2.05849 12.5698C1.98987 12.4522 1.83957 12.413 1.72521 12.4816L1.11093 12.8312C0.751511 12.1418 0.53586 11.3674 0.499918 10.544H1.20569C1.33965 10.544 1.45074 10.4329 1.45074 10.299C1.45074 10.165 1.33965 10.0539 1.20569 10.0539H0.499918C0.53586 9.23379 0.751511 8.45613 1.11093 7.7667L1.72194 8.11959C1.76115 8.14246 1.80363 8.15226 1.84284 8.15226C1.92779 8.15226 2.00948 8.10979 2.05522 8.0281C2.12384 7.91047 2.08136 7.76017 1.967 7.69482L1.35599 7.34194C1.78729 6.66885 2.35582 6.10031 3.02892 5.66901L3.3818 6.28002C3.42754 6.35844 3.50923 6.40418 3.59418 6.40418C3.63666 6.40418 3.67914 6.39438 3.71508 6.37151C3.83271 6.30289 3.87192 6.15259 3.8033 6.03823L3.45042 5.42722C4.13985 5.0678 4.91423 4.85215 5.73762 4.81621V5.52197C5.73762 5.65594 5.84872 5.76703 5.98268 5.76703C6.11665 5.76703 6.22774 5.65594 6.22774 5.52197V4.81621C7.04787 4.85215 7.82552 5.0678 8.51495 5.42722L8.16206 6.03823C8.09345 6.15586 8.13593 6.30616 8.25029 6.37151C8.2895 6.39438 8.33197 6.40418 8.37118 6.40418C8.45613 6.40418 8.53782 6.36171 8.58356 6.28002L8.93645 5.66901C9.60954 6.10031 10.1781 6.66885 10.6094 7.34194L9.99837 7.69482C9.88074 7.76344 9.84153 7.91374 9.91014 8.0281C9.95589 8.10652 10.0376 8.15226 10.1225 8.15226C10.165 8.15226 10.2075 8.14246 10.2434 8.11959L10.8544 7.7667C11.2139 8.45613 11.4295 9.23052 11.4654 10.0539H10.7597C10.6257 10.0539 10.5146 10.165 10.5146 10.299C10.5146 10.4329 10.6257 10.544 10.7597 10.544H11.4654C11.4295 11.3642 11.2139 12.1418 10.8544 12.8312L10.2434 12.4784C10.1258 12.4097 9.97549 12.4522 9.91014 12.5666C9.84153 12.6842 9.88401 12.8345 9.99837 12.8999L10.6094 13.2527C10.1781 13.9258 9.60954 14.4944 8.93645 14.9257L8.58356 14.3147C8.51495 14.197 8.36791 14.1578 8.25029 14.2264C8.13266 14.295 8.09345 14.4454 8.16206 14.5597L8.51495 15.1707C7.82552 15.5301 7.05114 15.7458 6.22774 15.7817V15.076C6.22774 14.942 6.11665 14.8309 5.98268 14.8309C5.84872 14.8309 5.73762 14.942 5.73762 15.076V15.7817C4.9175 15.7458 4.13985 15.5301 3.45042 15.1707L3.8033 14.5597C3.87192 14.4421 3.82944 14.2918 3.71508 14.2264C3.59745 14.1578 3.44715 14.2003 3.3818 14.3147L3.02892 14.9257C2.35909 14.4976 1.78729 13.9258 1.35925 13.256ZM11.9719 10.299C11.9719 7.47917 10.0114 5.11681 7.38441 4.48293V2.3983H18.0722V4.82601C18.0722 7.35827 16.2719 9.56053 13.7951 10.0637C13.6808 10.0866 13.5991 10.1879 13.5991 10.3055C13.5991 10.4231 13.6808 10.5212 13.7951 10.5473C14.8211 10.7564 15.7589 11.2596 16.5071 12.0013C17.5167 13.0142 18.0722 14.3571 18.0722 15.7785V18.2062H7.38441V16.1183C10.0114 15.4811 11.9719 13.1188 11.9719 10.299Z"
							fill="#757575"
						/>
						<path
							d="M5.98587 11.2203C6.3845 11.2203 6.72105 10.9622 6.84848 10.6061H8.12278C8.25674 10.6061 8.36784 10.495 8.36784 10.361C8.36784 10.227 8.25674 10.116 8.12278 10.116H6.88442C6.82234 9.80555 6.60015 9.55722 6.31262 9.44613V7.43012C6.31262 7.29615 6.20152 7.18506 6.06756 7.18506C5.93359 7.18506 5.8225 7.29615 5.8225 7.43012V9.39712C5.39446 9.47553 5.06445 9.84802 5.06445 10.2989C5.06772 10.8054 5.47942 11.2203 5.98587 11.2203ZM5.98587 9.87089C6.22113 9.87089 6.41391 10.0637 6.41391 10.2989C6.41391 10.5342 6.22113 10.727 5.98587 10.727C5.75062 10.727 5.55784 10.5342 5.55784 10.2989C5.55784 10.0637 5.74735 9.87089 5.98587 9.87089Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_29_2-963499">
							<rect width="20" height="21" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
			{/* Time off Request  */}
			<span>T</span>
			<span className="absolute left-14" style={{ marginLeft: "6px" }}>
				i<span style={{ textDecoration: "underline" }}>m</span>e off Request
			</span>

			<span className="ml-auto">
				<svg
					width="6"
					height="10"
					viewBox="0 0 6 10"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_12_6-577312)">
						<path
							d="M5.99497 4.92779C5.97787 4.81692 5.92396 4.7139 5.84088 4.63336L1.28929 0.189307C1.23928 0.133782 1.17769 0.0884199 1.10831 0.0560056C1.03893 0.0235912 0.963215 0.00480791 0.885809 0.000808488C0.808403 -0.00319093 0.730933 0.0076778 0.65817 0.0327477C0.585407 0.0578177 0.518878 0.0965603 0.462663 0.146597C0.406449 0.196635 0.36174 0.256911 0.331272 0.323728C0.300804 0.390545 0.285217 0.462493 0.28548 0.535157C0.285744 0.607821 0.301847 0.679668 0.3328 0.746289C0.363753 0.81291 0.408911 0.872899 0.465488 0.922576L4.64371 5L0.465487 9.07742C0.40891 9.1271 0.363753 9.18709 0.3328 9.25371C0.301846 9.32033 0.285745 9.39218 0.28548 9.46484C0.285216 9.5375 0.300804 9.60945 0.331272 9.67627C0.36174 9.74309 0.406448 9.80337 0.462663 9.8534C0.518878 9.90344 0.585406 9.94218 0.658169 9.96725C0.730933 9.99232 0.808402 10.0032 0.885809 9.99919C0.963215 9.99519 1.03893 9.97641 1.10831 9.94399C1.17769 9.91158 1.23928 9.86622 1.28929 9.81069L5.84088 5.36663C5.90002 5.30899 5.94456 5.23963 5.97124 5.16366C5.99791 5.0877 6.00603 5.00709 5.99497 4.92779Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_12_6-577312">
							<rect width="6" height="10" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
		</>
	);
};

export const AppreciationsIcons = () => {
	return (
		<>
			<span>
				<svg
					width="17"
					height="24"
					viewBox="0 0 17 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_1_46-622877)">
						<path
							d="M11.5139 8.27921L14.0456 5.62353C14.081 5.58385 14.1096 5.5384 14.1303 5.48906C14.133 5.47317 14.133 5.45692 14.1303 5.44104C14.1447 5.40074 14.1541 5.35881 14.1586 5.31618C14.1586 5.31618 14.1586 5.31618 14.1586 5.28736V0.480233C14.1586 0.352867 14.109 0.230718 14.0207 0.140657C13.9325 0.0505959 13.8128 0 13.688 0H3.35858C3.23377 0 3.11407 0.0505959 3.02582 0.140657C2.93757 0.230718 2.88799 0.352867 2.88799 0.480233V5.28256C2.88799 5.28256 2.88799 5.28256 2.88799 5.31137C2.89289 5.35549 2.90236 5.39895 2.91623 5.44104V5.48426C2.9356 5.5303 2.96267 5.57255 2.99623 5.60912L5.62681 8.21678C3.88785 8.8997 2.43702 10.1806 1.52466 11.8386C0.612309 13.4965 0.295659 15.4274 0.629352 17.2981C0.963045 19.1688 1.92615 20.862 3.35248 22.0855C4.77881 23.309 6.5789 23.986 8.44212 23.9998C10.3054 24.0135 12.1148 23.3632 13.5584 22.1609C15.0019 20.9586 15.9889 19.2798 16.3491 17.4142C16.7093 15.5486 16.42 13.6132 15.5313 11.942C14.6425 10.2707 13.21 8.96852 11.4809 8.26L11.5139 8.27921ZM6.65269 7.91904V5.76279H10.4174V7.91904C9.18142 7.60448 7.88866 7.60448 6.65269 7.91904ZM11.3586 7.06422V5.76279H12.5962L11.3586 7.06422ZM13.2409 4.80233H11.3586V0.960466H13.2409V4.80233ZM10.4174 0.960466V4.80233H6.65269V0.960466H10.4174ZM3.82917 0.960466H5.71152V4.80233H3.82917V0.960466ZM5.71152 5.76279V6.94897L4.51622 5.76279H5.71152ZM8.53504 23.0512C7.13894 23.0512 5.77419 22.6287 4.61337 21.8372C3.45256 21.0456 2.54781 19.9206 2.01355 18.6043C1.47928 17.2881 1.3395 15.8397 1.61186 14.4424C1.88423 13.045 2.55651 11.7615 3.54371 10.754C4.5309 9.74662 5.78866 9.06055 7.15793 8.7826C8.52721 8.50466 9.9465 8.64731 11.2363 9.19252C12.5262 9.73774 13.6286 10.661 14.4042 11.8456C15.1799 13.0302 15.5939 14.423 15.5939 15.8477C15.5939 17.7582 14.8502 19.5904 13.5264 20.9413C12.2026 22.2922 10.4072 23.0512 8.53504 23.0512ZM11.6927 13.8931L10.455 13.7106C10.4039 13.703 10.3554 13.6828 10.3137 13.6519C10.2719 13.6209 10.238 13.5801 10.215 13.533L9.66445 12.39C9.55999 12.1755 9.39893 11.995 9.1994 11.8688C8.99986 11.7426 8.76978 11.6757 8.53504 11.6757C8.3003 11.6757 8.07022 11.7426 7.87069 11.8688C7.67115 11.995 7.51009 12.1755 7.40563 12.39L6.85504 13.533C6.83205 13.5801 6.79822 13.6209 6.75643 13.6519C6.71463 13.6828 6.66613 13.703 6.61504 13.7106L5.3774 13.8931C5.14482 13.9271 4.92623 14.027 4.74647 14.1814C4.56671 14.3358 4.43296 14.5385 4.36043 14.7666C4.2879 14.9946 4.27948 15.2389 4.33613 15.4716C4.39279 15.7043 4.51224 15.9161 4.68093 16.083L5.57504 16.9762C5.61172 17.0124 5.6394 17.057 5.65577 17.1063C5.67214 17.1555 5.67673 17.2081 5.66916 17.2596L5.4574 18.5178C5.42581 18.7021 5.43413 18.8912 5.48176 19.0718C5.52939 19.2525 5.61518 19.4203 5.73312 19.5635C5.85105 19.7068 5.99827 19.8219 6.16444 19.9009C6.33062 19.98 6.51172 20.0209 6.69504 20.0209C6.89861 20.0212 7.09909 19.9701 7.27857 19.872L8.38916 19.2765C8.43431 19.2529 8.48431 19.2406 8.53504 19.2406C8.58577 19.2406 8.63577 19.2529 8.68092 19.2765L9.79151 19.872C9.99917 19.9831 10.2331 20.0326 10.4669 20.015C10.7007 19.9974 10.9251 19.9134 11.1145 19.7725C11.304 19.6316 11.4511 19.4394 11.5391 19.2177C11.6271 18.996 11.6526 18.7535 11.6127 18.5178L11.4009 17.2596C11.3933 17.2081 11.3979 17.1555 11.4143 17.1063C11.4307 17.057 11.4584 17.0124 11.495 16.9762L12.3892 16.083C12.5578 15.9161 12.6773 15.7043 12.7339 15.4716C12.7906 15.2389 12.7822 14.9946 12.7096 14.7666C12.6371 14.5385 12.5034 14.3358 12.3236 14.1814C12.1438 14.027 11.9253 13.9271 11.6927 13.8931ZM11.7303 15.3963L10.8362 16.2895C10.6897 16.4339 10.5801 16.6126 10.5169 16.8102C10.4538 17.0078 10.439 17.2181 10.4739 17.4228L10.6856 18.6811C10.6979 18.7422 10.6926 18.8057 10.6701 18.8638C10.6477 18.9219 10.6092 18.972 10.5593 19.0082C10.5094 19.0443 10.4503 19.0649 10.3892 19.0673C10.3281 19.0698 10.2676 19.0541 10.215 19.022L9.10445 18.4265C8.92467 18.3294 8.72434 18.2786 8.52092 18.2786C8.3175 18.2786 8.11717 18.3294 7.93739 18.4265L6.84093 19.022C6.78841 19.0541 6.7279 19.0698 6.66677 19.0673C6.60564 19.0649 6.54653 19.0443 6.49664 19.0082C6.44676 18.972 6.40826 18.9219 6.38583 18.8638C6.3634 18.8057 6.35802 18.7422 6.37034 18.6811L6.5821 17.4228C6.61697 17.2181 6.60218 17.0078 6.53901 16.8102C6.47585 16.6126 6.36623 16.4339 6.21975 16.2895L5.32563 15.3963C5.28426 15.3538 5.25514 15.3005 5.24144 15.2423C5.22775 15.184 5.23001 15.1231 5.24799 15.0661C5.26596 15.009 5.29896 14.9582 5.34336 14.919C5.38776 14.8798 5.44187 14.8539 5.49975 14.844L6.7374 14.6615C6.9381 14.6309 7.12854 14.5511 7.29245 14.429C7.45635 14.3069 7.58884 14.1461 7.67857 13.9604L8.23386 12.8126C8.25998 12.759 8.30025 12.7139 8.35013 12.6823C8.40001 12.6508 8.45753 12.634 8.51622 12.634C8.5749 12.634 8.63242 12.6508 8.68231 12.6823C8.73219 12.7139 8.77245 12.759 8.79857 12.8126L9.35386 13.9604C9.4436 14.1461 9.57608 14.3069 9.73998 14.429C9.90389 14.5511 10.0943 14.6309 10.295 14.6615L11.5327 14.844C11.5906 14.8539 11.6447 14.8798 11.6891 14.919C11.7335 14.9582 11.7665 15.009 11.7844 15.0661C11.8024 15.1231 11.8047 15.184 11.791 15.2423C11.7773 15.3005 11.7482 15.3538 11.7068 15.3963H11.7303Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_1_46-622877">
							<rect
								width="16"
								height="24"
								fill="white"
								transform="translate(0.5)"
							/>
						</clipPath>
					</defs>
				</svg>
			</span>
			{/* Appreciations  */}
			<span>App</span>
			<span
				className="relative"
				style={{
					textDecoration: "underline",
					marginRight: "-15px",
					marginLeft: "-16px",
				}}
			>
				r
			</span>
			<span>eciations</span>
			<span className="ml-auto">
				{" "}
				<svg
					width="6"
					height="10"
					viewBox="0 0 6 10"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_12_6-577312)">
						<path
							d="M5.99497 4.92779C5.97787 4.81692 5.92396 4.7139 5.84088 4.63336L1.28929 0.189307C1.23928 0.133782 1.17769 0.0884199 1.10831 0.0560056C1.03893 0.0235912 0.963215 0.00480791 0.885809 0.000808488C0.808403 -0.00319093 0.730933 0.0076778 0.65817 0.0327477C0.585407 0.0578177 0.518878 0.0965603 0.462663 0.146597C0.406449 0.196635 0.36174 0.256911 0.331272 0.323728C0.300804 0.390545 0.285217 0.462493 0.28548 0.535157C0.285744 0.607821 0.301847 0.679668 0.3328 0.746289C0.363753 0.81291 0.408911 0.872899 0.465488 0.922576L4.64371 5L0.465487 9.07742C0.40891 9.1271 0.363753 9.18709 0.3328 9.25371C0.301846 9.32033 0.285745 9.39218 0.28548 9.46484C0.285216 9.5375 0.300804 9.60945 0.331272 9.67627C0.36174 9.74309 0.406448 9.80337 0.462663 9.8534C0.518878 9.90344 0.585406 9.94218 0.658169 9.96725C0.730933 9.99232 0.808402 10.0032 0.885809 9.99919C0.963215 9.99519 1.03893 9.97641 1.10831 9.94399C1.17769 9.91158 1.23928 9.86622 1.28929 9.81069L5.84088 5.36663C5.90002 5.30899 5.94456 5.23963 5.97124 5.16366C5.99791 5.0877 6.00603 5.00709 5.99497 4.92779Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_12_6-577312">
							<rect width="6" height="10" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
		</>
	);
};

export const TeamsIcons = () => {
	return (
		<>
			<span>
				<svg
					width="21"
					height="22"
					viewBox="0 0 21 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M5.0618 4.81026C4.38764 4.81026 3.82584 5.40855 3.82584 6.1265C3.82584 6.84444 4.38764 7.44273 5.0618 7.44273C5.73596 7.44273 6.29775 6.84444 6.29775 6.1265C6.29775 5.40855 5.71348 4.81026 5.0618 4.81026ZM5.0618 8.30427C3.9382 8.30427 3.03933 7.32308 3.03933 6.1265C3.03933 4.92991 3.96067 3.94872 5.0618 3.94872C6.18539 3.94872 7.08427 4.92991 7.08427 6.1265C7.08427 7.32308 6.16292 8.30427 5.0618 8.30427ZM15.9382 4.97778C15.264 4.97778 14.7022 5.57607 14.7022 6.29402C14.7022 7.01197 15.264 7.61026 15.9382 7.61026C16.6124 7.61026 17.1742 7.01197 17.1742 6.29402C17.1742 5.57607 16.6124 4.97778 15.9382 4.97778ZM15.9382 8.4718C14.8146 8.4718 13.9157 7.4906 13.9157 6.29402C13.9157 5.09744 14.8371 4.11624 15.9382 4.11624C17.0618 4.11624 17.9607 5.09744 17.9607 6.29402C17.9831 7.4906 17.0618 8.4718 15.9382 8.4718ZM1.55618 11.5111V14.9094L3.66854 16.2256V12.0855C3.66854 11.3915 4.09551 10.7692 4.83708 10.2427C2.67977 10.3385 1.55618 11.1521 1.55618 11.5111ZM10.1854 20.4137L15.7135 17.0872V12.0855C15.7135 11.3675 13.8258 10.0274 10.2303 10.0274C6.63483 10.0274 4.74719 11.3675 4.74719 12.0855V16.8479L10.1854 20.4137ZM19.4438 14.9812V11.5829C19.4438 11.2 18.2079 10.3145 15.8034 10.3145C15.7584 10.3145 15.7135 10.3145 15.691 10.3145C16.3652 10.8171 16.7697 11.4154 16.7697 12.0855V16.4889L19.4438 14.9812ZM20.5 11.5829V15.6513L16.118 18.1162L10.7247 21.3949C10.5449 21.4906 10.3652 21.5385 10.1854 21.5385C10.0056 21.5385 9.80337 21.4906 9.64607 21.3949L4.88202 18.2838L0.5 15.5556V11.4872C0.5 10.1231 2.52247 9.09402 5.19663 9.09402C5.96067 9.09402 6.90449 9.09402 7.3764 9.18974V9.21368C8.23034 9.02222 9.19663 8.90256 10.2303 8.90256C11.5562 8.90256 12.7921 9.09402 13.8258 9.40513C14.4101 9.28547 15.2191 9.18974 15.8258 9.18974C18.4775 9.18974 20.5 10.2188 20.5 11.5829ZM10.5 7.37094C8.54494 7.37094 6.97191 5.71966 6.97191 3.68547C6.97191 1.65128 8.54494 0 10.5 0C12.4551 0 14.0281 1.65128 14.0281 3.68547C14.0281 5.71966 12.4551 7.37094 10.5 7.37094ZM10.5 1.12479C11.8708 1.12479 12.9719 2.2735 12.9719 3.68547C12.9719 5.09744 11.8483 6.24615 10.5 6.24615C9.12921 6.24615 8.02809 5.09744 8.02809 3.68547C8.02809 2.2735 9.12921 1.12479 10.5 1.12479Z"
						fill="#757575"
					/>
				</svg>
			</span>
			{/* Teams  */}
			<span className="absolute left-12">Teams</span>

			<span className="ml-auto">
				{" "}
				<svg
					width="6"
					height="10"
					viewBox="0 0 6 10"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_12_6-577312)">
						<path
							d="M5.99497 4.92779C5.97787 4.81692 5.92396 4.7139 5.84088 4.63336L1.28929 0.189307C1.23928 0.133782 1.17769 0.0884199 1.10831 0.0560056C1.03893 0.0235912 0.963215 0.00480791 0.885809 0.000808488C0.808403 -0.00319093 0.730933 0.0076778 0.65817 0.0327477C0.585407 0.0578177 0.518878 0.0965603 0.462663 0.146597C0.406449 0.196635 0.36174 0.256911 0.331272 0.323728C0.300804 0.390545 0.285217 0.462493 0.28548 0.535157C0.285744 0.607821 0.301847 0.679668 0.3328 0.746289C0.363753 0.81291 0.408911 0.872899 0.465488 0.922576L4.64371 5L0.465487 9.07742C0.40891 9.1271 0.363753 9.18709 0.3328 9.25371C0.301846 9.32033 0.285745 9.39218 0.28548 9.46484C0.285216 9.5375 0.300804 9.60945 0.331272 9.67627C0.36174 9.74309 0.406448 9.80337 0.462663 9.8534C0.518878 9.90344 0.585406 9.94218 0.658169 9.96725C0.730933 9.99232 0.808402 10.0032 0.885809 9.99919C0.963215 9.99519 1.03893 9.97641 1.10831 9.94399C1.17769 9.91158 1.23928 9.86622 1.28929 9.81069L5.84088 5.36663C5.90002 5.30899 5.94456 5.23963 5.97124 5.16366C5.99791 5.0877 6.00603 5.00709 5.99497 4.92779Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_12_6-577312">
							<rect width="6" height="10" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
		</>
	);
};

export const SettingIcons = () => {
	return (
		<>
			<span>
				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_12_2-568005)">
						<path
							d="M12.7996 11.199C13.4086 9.97214 13.0023 8.08237 11.445 7.33172C11.0576 7.14478 10.6085 7.04626 10.1474 7.04626C9.00615 7.04626 7.66078 7.67439 7.22611 9.07876C6.69245 10.8029 7.76733 12.0347 8.62061 12.4413C9.09804 12.6691 9.62957 12.7896 10.1592 12.7896C11.3343 12.7894 12.2972 12.2095 12.7996 11.199ZM11.5792 10.6514C11.2277 11.3588 10.6126 11.5071 10.1592 11.5071C9.84384 11.5071 9.51217 11.4322 9.22632 11.2957C9.21498 11.2903 8.12262 10.7277 8.52045 9.44029C8.75857 8.6719 9.50909 8.3281 10.1474 8.3281C10.3976 8.3281 10.635 8.3786 10.8344 8.47419C11.7198 8.90147 11.8693 10.0677 11.5792 10.6514Z"
							fill="#757575"
						/>
						<path
							d="M8.37648 13.8525C8.92833 14.0264 9.55294 14.0484 10.182 13.9154C10.5449 13.8397 10.9061 14.0563 10.9871 14.4017C11.0684 14.747 10.8392 15.0897 10.4757 15.1669C9.60798 15.3507 8.7358 15.3168 7.95031 15.0686C5.08666 14.164 4.16368 10.9753 4.76254 9.08782C4.85042 8.81045 5.11831 8.63159 5.40841 8.63159C5.4729 8.63159 5.53811 8.64057 5.60354 8.65897C5.95979 8.76108 6.16224 9.11856 6.05475 9.45787C5.62386 10.8144 6.31414 13.2008 8.37648 13.8525Z"
							fill="#757575"
						/>
						<path
							d="M19.9978 6.82256C19.9526 6.32975 18.4667 3.62267 17.5418 3.41016C17.4341 3.38525 17.3089 3.37313 17.1589 3.37313C16.6359 3.37313 15.755 3.53156 15.1211 3.67765C14.7117 3.36438 14.2702 3.09329 13.8048 2.86888C13.6574 2.79774 13.5036 2.73064 13.3437 2.66735C13.171 1.95732 12.7382 0.460044 12.0971 0.17549C11.8334 0.0587958 11.2695 0 10.4196 0C8.24832 0 7.89161 0.355917 7.75719 0.48989C7.34023 0.9055 6.91123 2.19026 6.72413 2.84644C6.16732 3.08723 5.64665 3.38121 5.17064 3.72254C4.40476 3.55692 2.95167 3.30177 2.61102 3.30177C2.24273 3.30648 1.99161 3.52999 1.77333 3.77011C1.40504 4.17473 -0.100733 6.26714 0.00533743 7.02565C0.0816417 7.57187 1.36157 8.67104 2.01358 9.19818C1.95145 9.71702 1.93987 10.23 1.98027 10.7296C1.40126 11.2962 0.348352 12.4537 0.183932 12.7336C0.0124245 13.0242 0.0901462 13.341 0.199523 13.6404C0.384496 14.1453 1.5378 16.4314 2.28431 16.7245C2.39368 16.7676 2.51511 16.7882 2.65661 16.7882C3.16122 16.7882 4.45036 16.4345 5.1541 16.2146C5.45932 16.4319 5.77186 16.6186 6.07141 16.7615C6.25662 16.8502 6.4534 16.9357 6.65893 17.0171C6.8902 17.7689 7.4085 19.162 7.57741 19.4318C7.71089 19.6439 7.93389 20 10.2792 20C11.8549 20 12.1332 19.7969 12.266 19.6995C12.7141 19.3725 13.0732 17.9534 13.2268 17.2512C13.8351 17.0364 14.403 16.7528 14.9218 16.4038C15.5123 16.5696 16.566 16.8187 17.1946 16.8187C17.3826 16.8187 17.6583 16.8012 17.8891 16.6477C18.316 16.3632 20.0412 13.7869 19.7717 12.9205C19.5997 12.3633 18.6403 11.3745 18.1601 10.9127C18.2087 10.3573 18.2021 9.79377 18.1407 9.2287C18.7958 8.67193 20.0604 7.49893 19.9978 6.82256ZM18.6191 6.85689C18.35 7.25567 17.3288 8.22244 17.0212 8.46929C16.8289 8.6082 16.7266 8.83732 16.7606 9.06869C16.861 9.74484 16.8688 10.4205 16.7859 11.077C16.7597 11.2836 16.8405 11.4892 17.0023 11.629C17.4405 12.0058 18.2586 12.9014 18.4502 13.2331C18.3479 13.692 17.5362 15.0998 17.1636 15.5358C16.6082 15.5237 15.3295 15.1978 15.0349 15.0921C14.8145 15.0129 14.5657 15.0499 14.3798 15.1884C13.8093 15.6148 13.1552 15.9393 12.4377 16.1525C12.1885 16.2263 12.0071 16.4298 11.9707 16.6747C11.9097 17.0858 11.5956 18.2399 11.4111 18.6567C11.2166 18.6865 10.8342 18.7177 10.2788 18.7177C9.54053 18.7177 8.94002 18.6641 8.65961 18.6127C8.43684 18.0968 7.95941 16.7157 7.88357 16.4265C7.84247 16.2063 7.6823 16.0196 7.45788 15.9386C7.17841 15.8385 6.91571 15.7301 6.67712 15.6159C6.36859 15.4687 6.03668 15.2568 5.71729 15.0044C5.52428 14.8509 5.2597 14.8145 5.03126 14.9029C4.69982 15.0176 3.32989 15.4162 2.79741 15.4927C2.42392 15.0679 1.65308 13.7472 1.46906 13.2165C1.83522 12.7681 2.89876 11.6519 3.10286 11.469C3.28429 11.3317 3.37973 11.1144 3.35233 10.8932C3.27839 10.298 3.29374 9.67348 3.39769 9.03727C3.43737 8.79401 3.32658 8.55165 3.11633 8.41296C2.84938 8.21481 1.73128 7.23637 1.38472 6.83041C1.58647 6.30933 2.40526 5.01537 2.79623 4.59976C3.37737 4.67337 4.88786 4.97027 5.14111 5.03063C5.35443 5.09167 5.5876 5.04836 5.76336 4.91102C6.29087 4.49743 6.89304 4.15834 7.55284 3.90252C7.76215 3.82195 7.91476 3.64691 7.95988 3.43641C8.07067 2.91735 8.49117 1.7549 8.70213 1.4221C8.92372 1.35814 9.5377 1.28184 10.4198 1.28184C10.932 1.28184 11.2788 1.30922 11.4512 1.33188C11.6567 1.68533 11.9915 2.73804 12.0978 3.26182C12.1429 3.48399 12.3087 3.66711 12.5327 3.74341C12.7666 3.8233 12.9901 3.91374 13.1951 4.01225C13.664 4.23868 14.1051 4.52414 14.5046 4.86053C14.6758 5.0055 14.913 5.05711 15.1337 4.99921C15.7519 4.83517 16.7358 4.6525 17.1686 4.65497C17.5352 4.97116 18.4043 6.32818 18.6191 6.85689Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_12_2-568005">
							<rect width="20" height="20" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
			{/* Settings  */}
			<span style={{ textDecoration: "underline" }}>S</span>
			<span className="absolute left-14" style={{ marginLeft: "6px" }}>
				ettings
			</span>
			<span className="ml-auto">
				<svg
					width="6"
					height="10"
					viewBox="0 0 6 10"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_12_6-577312)">
						<path
							d="M5.99497 4.92779C5.97787 4.81692 5.92396 4.7139 5.84088 4.63336L1.28929 0.189307C1.23928 0.133782 1.17769 0.0884199 1.10831 0.0560056C1.03893 0.0235912 0.963215 0.00480791 0.885809 0.000808488C0.808403 -0.00319093 0.730933 0.0076778 0.65817 0.0327477C0.585407 0.0578177 0.518878 0.0965603 0.462663 0.146597C0.406449 0.196635 0.36174 0.256911 0.331272 0.323728C0.300804 0.390545 0.285217 0.462493 0.28548 0.535157C0.285744 0.607821 0.301847 0.679668 0.3328 0.746289C0.363753 0.81291 0.408911 0.872899 0.465488 0.922576L4.64371 5L0.465487 9.07742C0.40891 9.1271 0.363753 9.18709 0.3328 9.25371C0.301846 9.32033 0.285745 9.39218 0.28548 9.46484C0.285216 9.5375 0.300804 9.60945 0.331272 9.67627C0.36174 9.74309 0.406448 9.80337 0.462663 9.8534C0.518878 9.90344 0.585406 9.94218 0.658169 9.96725C0.730933 9.99232 0.808402 10.0032 0.885809 9.99919C0.963215 9.99519 1.03893 9.97641 1.10831 9.94399C1.17769 9.91158 1.23928 9.86622 1.28929 9.81069L5.84088 5.36663C5.90002 5.30899 5.94456 5.23963 5.97124 5.16366C5.99791 5.0877 6.00603 5.00709 5.99497 4.92779Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_12_6-577312">
							<rect width="6" height="10" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
		</>
	);
};

export const SendCpLinkIcon = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.21522 14.6222C2.17753 14.4347 2.14644 14.2358 2.12079 14.0239C2 13.0261 2 11.7402 2 10C2 6.6669 2 5.00035 2.84882 3.83207C3.12295 3.45475 3.45475 3.12295 3.83207 2.84882C5.00035 2 6.6669 2 10 2C13.3331 2 14.9997 2 16.1679 2.84882C16.5453 3.12295 16.877 3.45475 17.1512 3.83207C18 5.00035 18 6.6669 18 10C18 11.765 18 13.0628 17.8739 14.0666C17.8494 14.2626 17.8199 14.4474 17.7848 14.6222C17.66 15.2431 17.4627 15.7391 17.1512 16.1679C16.877 16.5453 16.5453 16.877 16.1679 17.1512C14.9997 18 13.3331 18 10 18C6.6669 18 5.00035 18 3.83207 17.1512C3.45475 16.877 3.12295 16.5453 2.84882 16.1679C2.53724 15.7391 2.34004 15.2431 2.21522 14.6222ZM17.0602 13.1956C17.1094 12.379 17.1111 11.3506 17.1111 10C17.1111 8.31366 17.1099 7.12029 17.0102 6.19998C16.9122 5.2963 16.728 4.7619 16.4321 4.35454C16.2127 4.0527 15.9473 3.78726 15.6454 3.56794C15.2381 3.27197 14.7037 3.08774 13.8 2.98982C12.8797 2.89011 11.6863 2.88889 10 2.88889C8.31366 2.88889 7.12029 2.89011 6.19998 2.98982C5.2963 3.08774 4.7619 3.27197 4.35454 3.56794C4.0527 3.78726 3.78726 4.0527 3.56794 4.35454C3.27197 4.7619 3.08774 5.2963 2.98982 6.19998C2.89011 7.12029 2.88889 8.31366 2.88889 10C2.88889 11.244 2.89033 12.2146 2.92898 12.9982L4.30681 11.2495C4.76393 10.6694 5.13026 10.2044 5.46035 9.8701C5.79934 9.52678 6.14336 9.27497 6.56992 9.17854C6.84918 9.11542 7.13801 9.10685 7.42054 9.1533C7.85206 9.22429 8.2104 9.45526 8.56914 9.77789C8.91847 10.0921 9.31174 10.5345 9.80243 11.0866L9.9864 11.2935C10.1265 11.4511 10.217 11.5526 10.2915 11.6258C10.3632 11.6962 10.3973 11.7171 10.4151 11.7258C10.5212 11.7778 10.6437 11.7853 10.7554 11.7468C10.7741 11.7403 10.8105 11.7238 10.8902 11.6627C10.9732 11.5993 11.0755 11.5096 11.2339 11.3704L11.2455 11.3602C11.5366 11.1044 11.7717 10.8978 11.9746 10.7422C12.1835 10.5821 12.3826 10.4565 12.6078 10.3774C13.1559 10.1846 13.7578 10.2142 14.2843 10.4599C14.5006 10.5608 14.6864 10.7054 14.8786 10.8853C15.0652 11.0601 15.2789 11.2887 15.5434 11.5719L17.0602 13.1956ZM12.5778 6.8C12.5778 7.24183 12.9359 7.6 13.3778 7.6C13.8196 7.6 14.1778 7.24183 14.1778 6.8C14.1778 6.35817 13.8196 6 13.3778 6C12.9359 6 12.5778 6.35817 12.5778 6.8ZM13.3778 8.48889C12.445 8.48889 11.6889 7.73274 11.6889 6.8C11.6889 5.86726 12.445 5.11111 13.3778 5.11111C14.3106 5.11111 15.0666 5.86726 15.0666 6.8C15.0666 7.73274 14.3106 8.48889 13.3778 8.48889Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const EditIcons = ({ color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 30	 30	"
			strokeWidth={1.5}
			stroke="currentColor"
			className="btnnn w-6 h-6"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				stroke={color}
				d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
			/>
		</svg>
	);
};

export const Edit = ({ color = "black" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 30	 30	"
			strokeWidth={1.5}
			stroke="currentColor"
			className="btnnn w-5 h-5 text-blue-900"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				stroke={color}
				d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
			/>
		</svg>
	);
};

export const WorkSpaceSidebarIcon = () => {
	return (
		<>
			<span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					strokeWidth={1.5}
					stroke="currentColor"
					className="w-6 h-6"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
					/>
				</svg>
			</span>
			{/* Work Space  */}
			<span style={{ textDecoration: "underline" }}>W</span>
			<span className="absolute left-16" style={{ marginLeft: "8px" }}>
				orkSpace
			</span>

			<span className="ml-auto">
				<svg
					width="6"
					height="10"
					viewBox="0 0 6 10"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_12_6-577312)">
						<path
							d="M5.99497 4.92779C5.97787 4.81692 5.92396 4.7139 5.84088 4.63336L1.28929 0.189307C1.23928 0.133782 1.17769 0.0884199 1.10831 0.0560056C1.03893 0.0235912 0.963215 0.00480791 0.885809 0.000808488C0.808403 -0.00319093 0.730933 0.0076778 0.65817 0.0327477C0.585407 0.0578177 0.518878 0.0965603 0.462663 0.146597C0.406449 0.196635 0.36174 0.256911 0.331272 0.323728C0.300804 0.390545 0.285217 0.462493 0.28548 0.535157C0.285744 0.607821 0.301847 0.679668 0.3328 0.746289C0.363753 0.81291 0.408911 0.872899 0.465488 0.922576L4.64371 5L0.465487 9.07742C0.40891 9.1271 0.363753 9.18709 0.3328 9.25371C0.301846 9.32033 0.285745 9.39218 0.28548 9.46484C0.285216 9.5375 0.300804 9.60945 0.331272 9.67627C0.36174 9.74309 0.406448 9.80337 0.462663 9.8534C0.518878 9.90344 0.585406 9.94218 0.658169 9.96725C0.730933 9.99232 0.808402 10.0032 0.885809 9.99919C0.963215 9.99519 1.03893 9.97641 1.10831 9.94399C1.17769 9.91158 1.23928 9.86622 1.28929 9.81069L5.84088 5.36663C5.90002 5.30899 5.94456 5.23963 5.97124 5.16366C5.99791 5.0877 6.00603 5.00709 5.99497 4.92779Z"
							fill="#757575"
						/>
					</g>
					<defs>
						<clipPath id="clip0_12_6-577312">
							<rect width="6" height="10" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
		</>
	);
};

export const FormIcons = () => {
	return (
		<svg
			width="30"
			height="28"
			viewBox="0 0 60 60"
			className=""
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.5833 2.08337C15.7339 2.08337 16.6667 3.01612 16.6667 4.16671V8.33337C16.6667 9.48396 15.7339 10.4167 14.5833 10.4167C13.4327 10.4167 12.5 9.48396 12.5 8.33337V4.16671C12.5 3.01612 13.4327 2.08337 14.5833 2.08337ZM25 2.08337C26.1506 2.08337 27.0833 3.01612 27.0833 4.16671V8.33337C27.0833 9.48396 26.1506 10.4167 25 10.4167C23.8494 10.4167 22.9167 9.48396 22.9167 8.33337V4.16671C22.9167 3.01612 23.8494 2.08337 25 2.08337ZM35.4167 2.08337C36.5673 2.08337 37.5 3.01612 37.5 4.16671V8.33337C37.5 9.48396 36.5673 10.4167 35.4167 10.4167C34.266 10.4167 33.3333 9.48396 33.3333 8.33337V4.16671C33.3333 3.01612 34.266 2.08337 35.4167 2.08337Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M30.3227 4.6875C33.1718 4.68746 35.4683 4.68744 37.2745 4.93027C39.1498 5.18238 40.7285 5.72175 41.9827 6.97573C43.2366 8.22973 43.776 9.80863 44.0281 11.6839C44.2708 13.49 44.2708 15.7865 44.2708 18.6357V25.1196C44.2708 26.5354 44.2708 27.8613 44.2608 29.1021C44.1193 30.0417 43.7598 31.0271 43.0708 31.8371C42.1798 32.8842 40.5543 33.8542 37.4985 33.8542C37.2785 33.8542 37.0395 33.8446 36.762 33.8317L36.6598 33.8269C36.4181 33.8154 36.1491 33.8029 35.881 33.7973C35.2768 33.7848 34.5393 33.8023 33.8158 33.9962C32.3779 34.3815 31.2548 35.5046 30.8695 36.9425C30.6758 37.6658 30.6581 38.4033 30.6706 39.0075C30.6762 39.2756 30.6889 39.5444 30.7002 39.786L30.705 39.8885C30.7179 40.1662 30.7277 40.4052 30.7277 40.625C30.7277 42.0219 30.5881 43.7456 29.8256 45.0881C29.4614 45.7292 28.9577 46.2777 28.2383 46.6765C27.5125 47.0785 26.482 47.375 25 47.375C24.92 47.375 24.8412 47.381 24.7643 47.3927C23.885 47.3958 22.966 47.3958 22.0052 47.3958H21.9945H19.6773C16.8282 47.3958 14.5317 47.3958 12.7255 47.1531C10.8503 46.901 9.27136 46.3617 8.01736 45.1077C6.76338 43.8535 6.224 42.2748 5.9719 40.3996C5.72906 38.5933 5.72909 36.2969 5.72913 33.4477V18.6357C5.72909 15.7866 5.72906 13.49 5.9719 11.6839C6.224 9.80863 6.76338 8.22973 8.01736 6.97573C9.27136 5.72175 10.8503 5.18238 12.7255 4.93027C14.5316 4.68744 16.8281 4.68746 19.6772 4.6875H30.3227ZM37.4985 36.9792C40.316 36.9792 42.4635 36.2915 44.0364 35.1627C43.9918 35.6762 43.9387 36.1677 43.8756 36.6381C43.4708 39.6479 42.6264 42.0231 40.7623 43.8873C38.8981 45.7515 36.5229 46.5958 33.5131 47.0006C33.1002 47.056 32.6708 47.1037 32.2245 47.1448C32.3383 46.9765 32.4441 46.8052 32.5427 46.6317C33.7325 44.5371 33.8527 42.1046 33.8527 40.625C33.8527 40.3248 33.8395 40.0202 33.8266 39.7437L33.8216 39.6371C33.8102 39.3919 33.7995 39.1669 33.795 38.9427C33.7841 38.4206 33.8108 38.0394 33.8881 37.7513C33.9843 37.3917 34.2652 37.111 34.6245 37.0146C34.9127 36.9375 35.2941 36.9108 35.816 36.9217C36.0402 36.9263 36.2652 36.9367 36.5104 36.9483L36.6173 36.9533C36.8937 36.966 37.1981 36.9792 37.4985 36.9792ZM16.6666 19.2708C15.8037 19.2708 15.1041 19.9704 15.1041 20.8333C15.1041 21.6963 15.8037 22.3958 16.6666 22.3958H33.3333C34.1962 22.3958 34.8958 21.6963 34.8958 20.8333C34.8958 19.9704 34.1962 19.2708 33.3333 19.2708H16.6666ZM16.6666 29.6875C15.8037 29.6875 15.1041 30.3871 15.1041 31.25C15.1041 32.1129 15.8037 32.8125 16.6666 32.8125H25C25.8629 32.8125 26.5625 32.1129 26.5625 31.25C26.5625 30.3871 25.8629 29.6875 25 29.6875H16.6666Z"
				fill="white"
			/>
		</svg>
	);
};

export const BackIcon = ({ className = 'btnnn w-6 h-6 relative top-2 mr-4' }) => {
	const navigate = useCustomNavigate();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className={className}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
			/>
		</svg>
	);
};

export const ChatBoxCloseIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_100_28-792658)">
				<path
					d="M0.433164 15.5946C0.703892 15.8649 1.05584 16 1.38071 16C1.70558 16 2.0846 15.8649 2.32826 15.5946L8.01354 9.91892L13.6988 15.5946C13.9695 15.8649 14.3215 16 14.6464 16C14.9712 16 15.3503 15.8649 15.5939 15.5946C16.1354 15.0541 16.1354 14.2162 15.5939 13.6757L9.90863 8L15.5939 2.32432C16.1354 1.78378 16.1354 0.945946 15.5939 0.405405C15.0525 -0.135135 14.2132 -0.135135 13.6717 0.405405L7.98646 6.08108L2.32826 0.45946C1.7868 -0.0810809 0.947546 -0.0810809 0.406091 0.45946C-0.135364 1 -0.135364 1.83784 0.406091 2.37838L6.09137 8.05405L0.433164 13.7027C-0.108291 14.2162 -0.108291 15.0811 0.433164 15.5946Z"
					fill="#757575"
				/>
			</g>
			<defs>
				<clipPath id="clip0_100_28-792658">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ChatSendIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			width="20" // You can adjust the width and height if needed
			height="20"
			viewBox="0 0 24 24"
			fillRule="evenodd"
			xmlSpace="preserve"
			className=""
			style={{ enableBackground: 'new 0 0 512 512' }}
		>
			<g>
				<path
					d="M1.305 3.542A1.844 1.844 0 0 1 3.92 1.445l17.81 8.905a1.844 1.844 0 0 1 0 3.3L3.92 22.555a1.844 1.844 0 0 1-2.615-2.097L3.17 13 14 12 3.17 11 1.305 3.542z"
					fill="#2626e0"
					opacity="1"
					data-original="#000000"
					className=""
				/>
			</g>
		</svg>
	);
};

export const ChatImagePicker = () => {
	return (
		<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
			<g id="Layer_2" data-name="Layer 2">
				<path
					d="m22.75 6v12a4.754 4.754 0 0 1 -4.75 4.75h-12a4.669 4.669 0 0 1 -1.55-.26 4.751 4.751 0 0 1 -3.2-4.49v-12a4.754 4.754 0 0 1 4.75-4.75h12a4.754 4.754 0 0 1 4.75 4.75z"
					fill="#e1f5fe"
				/>
				<path
					d="m14.75 19v3.75h-8.75a4.669 4.669 0 0 1 -1.55-.26 4.751 4.751 0 0 1 -3.2-4.49v-2.73l3.16-2.11a2.736 2.736 0 0 1 3.17.09l3.49 2.62 3.38 2.53a.739.739 0 0 1 .3.6z"
					fill="#62d8b6"
				/>
				<circle cx="8.625" cy="6.625" fill="#ffde76" r="2.5" />
				<path
					d="m22.75 13.04v4.96a4.754 4.754 0 0 1 -4.75 4.75h-12a4.669 4.669 0 0 1 -1.55-.26l11-11a2.739 2.739 0 0 1 3.17-.52z"
					fill="#4cc19d"
				/>
			</g>
		</svg>
	);
};

export const ChatPdfPicker = () => {
	return (
		<svg height="24" viewBox="0 0 64 64" width="24" xmlns="http://www.w3.org/2000/svg">
			<g id="Layer_28" data-name="Layer 28">
				<path d="m20 18h42v40h-42z" fill="#e2e7f6" />
				<path d="m56 53.781a2 2 0 0 0 2-2v-33.781h-38v35.781z" fill="#eff2f9" />
				<path d="m20 18v-16h32l10 10v6z" fill="#d23f34" />
				<path d="m57.831 13.007v-5.176l-5.831-5.831h-32v13.007h35.831a2 2 0 0 0 2-2z" fill="#e24f4b" />
				<path d="m32.72 58-20.261 4-10.459-52.977 18-3.417v52.394z" fill="#a72b25" />
				<path d="m52 2v10h10" fill="#a72b25" />
				<g fill="#eff2f9">
					<path d="m29 5h-3a1 1 0 0 0 -1 1v9h2v-4h2a3 3 0 0 0 0-6zm0 4h-2v-2h2a1 1 0 0 1 0 2z" />
					<path d="m37 5h-3a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h3a3 3 0 0 0 3-3v-4a3 3 0 0 0 -3-3zm1 7a1 1 0 0 1 -1 1h-2v-6h2a1 1 0 0 1 1 1z" />
					<path d="m47 7v-2h-5a1 1 0 0 0 -1 1v9h2v-4h4v-2h-4v-2z" />
				</g>
				<path d="m53 38v-15h-24v10h9l5 5z" fill="#f29b99" />
				<path d="m56 40v11a2 2 0 0 1 -2 2h-26a2 2 0 0 1 -2-2v-16a2 2 0 0 1 2-2h10l5 5h11a2 2 0 0 1 2 2z" fill="#a72b25" />
				<path d="m32 26h18v2h-18z" fill="#f8ced7" />
				<path d="m32 29h18v2h-18z" fill="#f8ced7" />
				<path d="m53 47v-9h-10l-5-5h-10a2 2 0 0 0 -2 2v14h25a2 2 0 0 0 2-2z" fill="#d23f34" />
			</g>
		</svg>
	);
};

export const ChatEmojiPicker = () => {
	return (
		<svg
			version="1.1"
			width='25'
			height='25'
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 295.996 295.996"
			style={{ enableBackground: 'new 0 0 295.996 295.996' }}
			xmlSpace="preserve"
		>
			<g>
				<path
					style={{ fill: '#FFCE00' }}
					d="M270.996,123.998c0-11.334-1.363-22.348-3.907-32.9c-7.269-15.152-17.35-28.708-29.558-39.996
            c-22.391-13.376-48.766-20.666-76.772-19.645C83.492,34.274,23.139,99.196,25.955,176.463c0.413,11.304,2.17,22.239,5.087,32.673
            c6.303,12.01,14.397,22.938,23.934,32.42c21.892,14.189,47.99,22.44,76.023,22.44C208.316,263.996,270.996,201.316,270.996,123.998
            z M198.584,98.4c17.423,0,31.597,13.597,31.597,31.597h-16c0-9-6.997-15.597-15.597-15.597s-15.597,6.597-15.597,15.597h-16
            C166.987,111.997,181.161,98.4,198.584,98.4z M97.41,98.4c17.423,0,31.597,13.597,31.597,31.597h-16
            c0-9-6.997-15.597-15.597-15.597s-15.597,6.597-15.597,15.597h-16C65.813,111.997,79.987,98.4,97.41,98.4z M70.677,187.882
            l13.438-8.684c12.224,18.915,32.811,31.74,55.072,34.308c28.56,3.297,57.098-10.173,72.693-34.308l13.439,8.684
            c-16.984,26.283-46.649,42.113-77.604,42.113c-3.445,0-6.9-0.195-10.362-0.595C110.393,226.291,85.467,210.771,70.677,187.882z"
				/>
				<path
					style={{ fill: '#FFB100' }}
					d="M267.089,91.098c2.544,10.553,3.907,21.566,3.907,32.9c0,77.318-62.68,139.998-139.998,139.998
            c-28.032,0-54.131-8.251-76.023-22.44c23.88,23.744,56.766,38.44,93.023,38.44c72.784,0,131.998-59.214,131.998-131.998
            C279.996,127.636,275.358,108.337,267.089,91.098z"
				/>
				<path
					style={{ fill: '#FFE454' }}
					d="M160.76,31.457c28.006-1.021,54.381,6.268,76.772,19.645C213.985,29.328,182.521,16,147.998,16
            C75.214,16,16,75.214,16,147.998c0,22.049,5.442,42.849,15.042,61.138c-2.917-10.434-4.674-21.369-5.087-32.673
            C23.139,99.196,83.492,34.274,160.76,31.457z"
				/>
				<path
					d="M147.998,0C66.392,0,0,66.392,0,147.998s66.392,147.998,147.998,147.998s147.998-66.392,147.998-147.998
            S229.605,0,147.998,0z M147.998,279.996c-36.257,0-69.143-14.696-93.023-38.44c-9.536-9.482-17.631-20.41-23.934-32.42
            C21.442,190.847,16,170.047,16,147.998C16,75.214,75.214,16,147.998,16c34.523,0,65.987,13.328,89.533,35.102
            c12.208,11.288,22.289,24.844,29.558,39.996c8.27,17.239,12.907,36.538,12.907,56.9
            C279.996,220.782,220.782,279.996,147.998,279.996z"
				/>
				<path d="M97.41,114.4c8.6,0,15.597,6.597,15.597,15.597h16c0-18-14.174-31.597-31.597-31.597s-31.597,13.597-31.597,31.597h16 C81.813,120.997,88.811,114.4,97.41,114.4z" />
				<path d="M198.584,114.4c8.6,0,15.597,6.597,15.597,15.597h16c0-18-14.174-31.597-31.597-31.597s-31.597,13.597-31.597,31.597h16 C182.987,120.997,189.984,114.4,198.584,114.4z" />
				<path
					d="M147.715,229.995c30.954,0,60.619-15.83,77.604-42.113l-13.439-8.684c-15.596,24.135-44.134,37.605-72.693,34.308
            c-22.262-2.567-42.849-15.393-55.072-34.308l-13.438,8.684c14.79,22.889,39.716,38.409,66.676,41.518
            C140.814,229.8,144.27,229.995,147.715,229.995z"
				/>
			</g>
		</svg>
	);
};

export const ChatPressSend = () => {
	return (
		<svg
			width="16"
			height="4"
			viewBox="0 0 16 4"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_100_8-025266)">
				<path
					d="M16 2C16 3.10457 15.0962 4 13.9812 4C12.8663 4 11.9624 3.10457 11.9624 2C11.9624 0.89543 12.8663 -4.87367e-08 13.9812 0C15.0962 4.87364e-08 16 0.895431 16 2Z"
					fill="#757575"
				/>
				<path
					d="M10.0188 2C10.0188 3.10457 9.11499 4 8.00002 4C6.88506 4 5.9812 3.10457 5.9812 2C5.9812 0.89543 6.88506 -4.87367e-08 8.00002 0C9.11499 4.87364e-08 10.0188 0.895431 10.0188 2Z"
					fill="#757575"
				/>
				<path
					d="M4.03765 2C4.03765 3.10457 3.13379 4 2.01882 4C0.903858 4 -4.82822e-08 3.10457 0 2C4.82823e-08 0.89543 0.903858 -4.87367e-08 2.01882 0C3.13379 4.87364e-08 4.03765 0.895431 4.03765 2Z"
					fill="#757575"
				/>
			</g>
			<defs>
				<clipPath id="clip0_100_8-025266">
					<rect width="16" height="4" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const HeaderSettingIcons = () => {
	return (
		<>
			<span>
				<svg
					width="22"
					height="22"
					viewBox="0 0 22 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M18.7233 9.31635C19.0617 9.04482 20.185 7.98137 20.481 7.54271C20.2447 6.96113 19.2887 5.46841 18.8855 5.1206C18.4094 5.11788 17.3271 5.31882 16.6471 5.49926C16.4043 5.56295 16.1434 5.50618 15.9551 5.34671C15.5156 4.97669 15.0304 4.66268 14.5146 4.41361C14.2891 4.30525 14.0433 4.20576 13.786 4.11788C13.5396 4.03395 13.3572 3.83252 13.3076 3.58813C13.1907 3.01198 12.8224 1.854 12.5963 1.4652C12.4067 1.44027 12.0252 1.41016 11.4618 1.41016C10.6376 1.41016 10.0263 1.4707 9.71141 1.53206C9.6513 1.56057 9.59373 1.59 9.5391 1.62027C9.29867 2.04606 8.87216 3.23534 8.75587 3.78018C8.70624 4.01173 8.53837 4.20428 8.30813 4.2929C7.58235 4.57431 6.91996 4.94731 6.3397 5.40225C6.14636 5.55333 5.88987 5.60097 5.65522 5.53383C5.37665 5.46743 3.71511 5.14084 3.07585 5.05987C2.64579 5.51704 1.74512 6.9404 1.52319 7.51358C1.90441 7.96014 3.13432 9.03642 3.42796 9.25439C3.65924 9.40695 3.78111 9.67354 3.73746 9.94113C3.62312 10.641 3.60623 11.3279 3.68756 11.9827C3.7177 12.226 3.61272 12.465 3.41315 12.616C3.18864 12.8172 2.01874 14.045 1.61597 14.5383C1.81839 15.1221 2.66631 16.5748 3.07715 17.0421C3.66288 16.958 5.1698 16.5195 5.53439 16.3933C5.78567 16.2961 6.07671 16.3361 6.28902 16.505C6.64035 16.7826 7.00545 17.0157 7.34483 17.1776C7.60728 17.3032 7.89625 17.4225 8.20367 17.5326C8.45053 17.6217 8.62672 17.8271 8.67193 18.0693C8.75535 18.3874 9.28053 19.9066 9.52557 20.4741C9.83402 20.5306 10.4946 20.5896 11.3067 20.5896C11.9176 20.5896 12.3383 20.5553 12.5522 20.5225C12.7552 20.064 13.1007 18.7945 13.1678 18.3423C13.2078 18.0729 13.4074 17.8491 13.6815 17.7679C14.4707 17.5334 15.1902 17.1764 15.8178 16.7074C16.0223 16.555 16.296 16.5143 16.5384 16.6014C16.8625 16.7177 18.269 17.0762 18.88 17.0895C19.2898 16.6099 20.1827 15.0613 20.2952 14.5565C20.0845 14.1917 19.1846 13.2065 18.7025 12.792C18.5246 12.6383 18.4357 12.4121 18.4645 12.1848C18.5557 11.4627 18.5471 10.7195 18.4367 9.97569C18.3993 9.72118 18.5118 9.46915 18.7233 9.31635ZM14.0797 12.3191C14.7496 10.9696 14.3027 8.89083 12.5896 8.06511C12.1635 7.85948 11.6695 7.75111 11.1623 7.75111C9.90691 7.75111 8.427 8.44205 7.94887 9.98686C7.36184 11.8834 8.54421 13.2384 9.48282 13.6857C10.008 13.9362 10.5927 14.0688 11.1753 14.0688C12.4679 14.0686 13.5271 13.4307 14.0797 12.3191ZM12.7373 11.7168C12.3506 12.4949 11.674 12.658 11.1753 12.658C10.8284 12.658 10.4635 12.5756 10.1491 12.4255C10.1366 12.4196 8.93503 11.8007 9.37264 10.3845C9.63457 9.53931 10.4601 9.16113 11.1623 9.16113C11.4375 9.16113 11.6986 9.21668 11.918 9.32183C12.8919 9.79184 13.0564 11.0747 12.7373 11.7168ZM11.2003 15.307C10.5083 15.4533 9.82127 15.4291 9.21423 15.2378C6.94566 14.5209 6.18635 11.8959 6.66033 10.4037C6.77857 10.0304 6.55587 9.6372 6.164 9.52488C6.09202 9.50464 6.02029 9.49476 5.94935 9.49476C5.63024 9.49476 5.33556 9.69151 5.2389 9.99661C4.58015 12.0728 5.59543 15.5804 8.74544 16.5755C9.60948 16.8485 10.5689 16.8858 11.5234 16.6836C11.9232 16.5987 12.1753 16.2217 12.0859 15.8419C11.9968 15.4619 11.5995 15.2237 11.2003 15.307Z"
						fill="white"
					/>
					<path
						d="M21.9976 7.50482C21.9479 6.96273 20.3134 3.98494 19.296 3.75118C19.1775 3.72378 19.0398 3.71044 18.8748 3.71044C18.2995 3.71044 17.3305 3.88472 16.6332 4.04541C16.1829 3.70082 15.6972 3.40262 15.1853 3.15577C15.0231 3.07751 14.854 3.0037 14.6781 2.93409C14.4881 2.15305 14.012 0.506048 13.3068 0.193039C13.0167 0.0646754 12.3964 0 11.4616 0C9.07315 0 8.68077 0.391509 8.53291 0.538879C8.07425 0.99605 7.60235 2.40929 7.39654 3.13108C6.78405 3.39595 6.21132 3.71933 5.6877 4.09479C4.84524 3.91261 3.24684 3.63195 2.87212 3.63195C2.467 3.63713 2.19077 3.88299 1.95066 4.14712C1.54554 4.5922 -0.110806 6.89385 0.00587118 7.72822C0.0898059 8.32906 1.49773 9.53814 2.21494 10.118C2.1466 10.6887 2.13386 11.253 2.1783 11.8026C1.54139 12.4258 0.383187 13.6991 0.202325 14.007C0.013667 14.3266 0.0991608 14.6751 0.219475 15.0044C0.422946 15.5598 1.69158 18.0745 2.51274 18.397C2.63305 18.4444 2.76662 18.467 2.92227 18.467C3.47734 18.467 4.8954 18.0779 5.66951 17.8361C6.00525 18.0751 6.34905 18.2805 6.67855 18.4377C6.88228 18.5352 7.09874 18.6293 7.32482 18.7188C7.57922 19.5458 8.14935 21.0782 8.33515 21.375C8.48198 21.6083 8.72728 22 11.3071 22C13.0404 22 13.3465 21.7766 13.4926 21.6694C13.9855 21.3097 14.3805 19.7487 14.5495 18.9763C15.2186 18.74 15.8433 18.4281 16.414 18.0442C17.0635 18.2266 18.2226 18.5006 18.9141 18.5006C19.1209 18.5006 19.4241 18.4813 19.678 18.3125C20.1476 17.9995 22.0453 15.1656 21.7489 14.2126C21.5597 13.5996 20.5043 12.512 19.9761 12.004C20.0296 11.393 20.0223 10.7731 19.9548 10.1516C20.6754 9.53912 22.0664 8.24882 21.9976 7.50482ZM20.481 7.54258C20.185 7.98124 19.0617 9.04468 18.7233 9.31622C18.5118 9.46902 18.3993 9.72105 18.4367 9.97556C18.5471 10.7193 18.5557 11.4626 18.4645 12.1847C18.4357 12.412 18.5245 12.6381 18.7025 12.7919C19.1845 13.2064 20.0845 14.1915 20.2952 14.5564C20.1827 15.0612 19.2898 16.6098 18.88 17.0894C18.269 17.0761 16.8624 16.7176 16.5384 16.6013C16.2959 16.5142 16.0223 16.5549 15.8178 16.7072C15.1902 17.1763 14.4707 17.5332 13.6815 17.7677C13.4074 17.8489 13.2078 18.0728 13.1678 18.3422C13.1007 18.7944 12.7552 20.0639 12.5522 20.5224C12.3383 20.5552 11.9176 20.5895 11.3067 20.5895C10.4946 20.5895 9.83402 20.5305 9.52557 20.474C9.28052 19.9065 8.75535 18.3873 8.67193 18.0692C8.62672 17.8269 8.45053 17.6216 8.20367 17.5325C7.89625 17.4223 7.60728 17.3031 7.34483 17.1775C7.00545 17.0156 6.64035 16.7825 6.28902 16.5048C6.07671 16.336 5.78567 16.296 5.53439 16.3932C5.1698 16.5194 3.66288 16.9578 3.07715 17.042C2.66631 16.5747 1.81839 15.1219 1.61597 14.5382C2.01874 14.0449 3.18864 12.8171 3.41315 12.6159C3.61272 12.4649 3.7177 12.2258 3.68756 11.9825C3.60623 11.3278 3.62311 10.6408 3.73746 9.941C3.78111 9.67341 3.65924 9.40682 3.42796 9.25426C3.13432 9.03629 1.90441 7.96001 1.52319 7.51345C1.74512 6.94026 2.64579 5.51691 3.07585 5.05974C3.71511 5.14071 5.37665 5.4673 5.65522 5.53369C5.88987 5.60084 6.14636 5.5532 6.3397 5.40212C6.91996 4.94717 7.58234 4.57417 8.30812 4.29277C8.53837 4.20414 8.70624 4.0116 8.75587 3.78005C8.87774 3.20908 9.34029 1.93039 9.57234 1.56431C9.81609 1.49395 10.4915 1.41002 11.4618 1.41002C12.0252 1.41002 12.4067 1.44014 12.5963 1.46507C12.8224 1.85386 13.1907 3.01184 13.3076 3.588C13.3572 3.83239 13.5396 4.03382 13.786 4.11775C14.0433 4.20563 14.2891 4.30511 14.5146 4.41348C15.0304 4.66255 15.5156 4.97655 15.9551 5.34658C16.1434 5.50605 16.4043 5.56282 16.6471 5.49913C17.3271 5.31869 18.4094 5.11775 18.8855 5.12047C19.2887 5.46828 20.2447 6.961 20.481 7.54258Z"
						fill="white"
					/>
				</svg>
			</span>
		</>
	);
};

export const HeaderTeamsIcon = () => {
	return (
		<>
			<span>
				<svg
					width="22"
					height="22"
					viewBox="0 0 22 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M5.5618 8.30427C4.4382 8.30427 3.53933 7.32308 3.53933 6.1265C3.53933 4.92991 4.46067 3.94872 5.5618 3.94872C6.68539 3.94872 7.58427 4.92991 7.58427 6.1265C7.58427 7.32308 6.66292 8.30427 5.5618 8.30427ZM16.4382 8.4718C15.3146 8.4718 14.4157 7.4906 14.4157 6.29402C14.4157 5.09744 15.3371 4.11624 16.4382 4.11624C17.5618 4.11624 18.4607 5.09744 18.4607 6.29402C18.4831 7.4906 17.5618 8.4718 16.4382 8.4718ZM21 11.5829V15.6513L16.618 18.1162L11.2247 21.3949C11.0449 21.4906 10.8652 21.5385 10.6854 21.5385C10.5056 21.5385 10.3034 21.4906 10.1461 21.3949L5.38202 18.2838L1 15.5556V11.4872C1 10.1231 3.02247 9.09402 5.69663 9.09402C6.46067 9.09402 7.40449 9.09402 7.8764 9.18974V9.21368C8.73034 9.02222 9.69663 8.90256 10.7303 8.90256C12.0562 8.90256 13.2921 9.09402 14.3258 9.40513C14.9101 9.28547 15.7191 9.18974 16.3258 9.18974C18.9775 9.18974 21 10.2188 21 11.5829ZM11 7.37094C9.04494 7.37094 7.47191 5.71966 7.47191 3.68547C7.47191 1.65128 9.04494 0 11 0C12.9551 0 14.5281 1.65128 14.5281 3.68547C14.5281 5.71966 12.9551 7.37094 11 7.37094Z"
						fill="white"
					/>
				</svg>
			</span>
		</>
	);
};

export const HeaderAppreciationsIcons = () => {
	return (
		<>
			<span>
				<svg
					width="22"
					height="22"
					viewBox="0 0 22 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clipPath="url(#clip0_224_9-031855)">
						<mask
							id="mask0_224_9-374183"
							maskUnits="userSpaceOnUse"
							x="3"
							y="0"
							width="16"
							height="22"
						>
							<path d="M18.3334 0H3.66675V22H18.3334V0Z" fill="white" />
						</mask>
						<g mask="url(#mask0_224_9-374183)">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M7.43724 20.0174C8.50132 20.743 9.75235 21.1303 11.0321 21.1303C11.7603 21.1303 12.4758 21.005 13.151 20.7662L14.0651 20.3599C14.628 20.0551 15.1487 19.6644 15.6075 19.1962C16.7758 18.0039 17.4513 16.4027 17.4999 14.7222V14.332C17.4641 13.0942 17.0878 11.8902 16.4122 10.8585C15.7012 9.77257 14.6907 8.92625 13.5083 8.42647C12.3259 7.92669 11.0249 7.79593 9.76975 8.05071C9.49075 8.10734 9.21679 8.18246 8.94949 8.27519L7.46727 9.0163C7.10526 9.26017 6.76646 9.54174 6.45672 9.85782C5.55178 10.7814 4.93553 11.9579 4.68585 13.2389C4.43619 14.5197 4.56432 15.8474 5.05407 17.0539C5.54381 18.2605 6.37316 19.2918 7.43724 20.0174ZM12.7921 12.568L13.9266 12.7353C14.1398 12.7665 14.3401 12.8581 14.505 12.9996C14.6698 13.1411 14.7923 13.3269 14.8588 13.536C14.9253 13.745 14.933 13.969 14.8811 14.1823C14.8292 14.3956 14.7196 14.5897 14.5651 14.7427L13.7454 15.5615C13.7119 15.5947 13.6865 15.6356 13.6714 15.6808C13.6564 15.7259 13.6522 15.7741 13.6591 15.8213L13.8533 16.9746C13.8899 17.1907 13.8665 17.413 13.7858 17.6162C13.7052 17.8194 13.5703 17.9956 13.3966 18.1248C13.223 18.2539 13.0173 18.3309 12.803 18.3471C12.5887 18.3632 12.3742 18.3178 12.1839 18.216L11.1658 17.6701C11.1244 17.6485 11.0786 17.6372 11.0321 17.6372C10.9856 17.6372 10.9398 17.6485 10.8984 17.6701L9.88034 18.216C9.71582 18.3059 9.53204 18.3528 9.34544 18.3525C9.17739 18.3525 9.01139 18.315 8.85905 18.2425C8.70673 18.1701 8.57178 18.0646 8.46368 17.9332C8.35556 17.8019 8.27692 17.6481 8.23326 17.4825C8.1896 17.3169 8.18198 17.1436 8.21093 16.9746L8.40505 15.8213C8.41199 15.7741 8.40778 15.7259 8.39277 15.6808C8.37777 15.6356 8.35239 15.5947 8.31877 15.5615L7.49917 14.7427C7.34454 14.5897 7.23504 14.3956 7.1831 14.1823C7.13117 13.969 7.13889 13.745 7.20538 13.536C7.27186 13.3269 7.39447 13.1411 7.55925 12.9996C7.72403 12.8581 7.9244 12.7665 8.1376 12.7353L9.2721 12.568C9.31894 12.5611 9.36339 12.5426 9.40171 12.5142C9.44002 12.4858 9.47103 12.4484 9.4921 12.4052L9.99681 11.3575C10.0926 11.1609 10.2402 10.9954 10.4231 10.8797C10.606 10.764 10.8169 10.7027 11.0321 10.7027C11.2473 10.7027 11.4582 10.764 11.6411 10.8797C11.824 10.9954 11.9716 11.1609 12.0674 11.3575L12.5721 12.4052C12.5932 12.4484 12.6242 12.4858 12.6625 12.5142C12.7008 12.5426 12.7452 12.5611 12.7921 12.568ZM13.1415 14.932L13.9611 14.1133H13.9396C13.9775 14.0743 14.0042 14.0254 14.0167 13.9721C14.0293 13.9187 14.0272 13.8628 14.0107 13.8106C13.9943 13.7582 13.964 13.7117 13.9233 13.6757C13.8826 13.6398 13.833 13.6161 13.78 13.607L12.6454 13.4397C12.4614 13.4116 12.2869 13.3385 12.1366 13.2266C11.9864 13.1146 11.865 12.9672 11.7827 12.797L11.2737 11.7449C11.2497 11.6957 11.2128 11.6544 11.1671 11.6254C11.1214 11.5966 11.0686 11.5812 11.0149 11.5812C10.9611 11.5812 10.9083 11.5966 10.8626 11.6254C10.8169 11.6544 10.78 11.6957 10.756 11.7449L10.247 12.797C10.1648 12.9672 10.0433 13.1146 9.89306 13.2266C9.74281 13.3385 9.56824 13.4116 9.38427 13.4397L8.24975 13.607C8.1967 13.6161 8.1471 13.6398 8.1064 13.6757C8.0657 13.7117 8.03545 13.7582 8.01897 13.8106C8.00249 13.8628 8.00042 13.9187 8.01297 13.9721C8.02553 14.0254 8.05222 14.0743 8.09014 14.1133L8.90975 14.932C9.04403 15.0644 9.14451 15.2282 9.20241 15.4093C9.26032 15.5905 9.27387 15.7832 9.24191 15.9709L9.04779 17.1243C9.0365 17.1803 9.04143 17.2385 9.06199 17.2918C9.08256 17.3451 9.11785 17.391 9.16357 17.4242C9.2093 17.4573 9.26349 17.4761 9.31952 17.4783C9.37556 17.4806 9.43103 17.4662 9.47917 17.4368L10.4843 16.8909C10.6491 16.8019 10.8327 16.7554 11.0192 16.7554C11.2056 16.7554 11.3893 16.8019 11.5541 16.8909L12.5721 17.4368C12.6203 17.4662 12.6757 17.4806 12.7318 17.4783C12.7878 17.4761 12.8419 17.4573 12.8877 17.4242C12.9334 17.391 12.9687 17.3451 12.9892 17.2918C13.0099 17.2385 13.0147 17.1803 13.0035 17.1243L12.8094 15.9709C12.7774 15.7832 12.791 15.5905 12.8488 15.4093C12.9067 15.2282 13.0072 15.0644 13.1415 14.932Z"
								fill="white"
							/>
							<path d="M15.5 5V0.5H6.5V4.5L8.5 7.5H13.5L15.5 5Z" fill="white" />
						</g>
					</g>
					<defs>
						<clipPath id="clip0_224_9-031855">
							<rect width="22" height="22" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</span>
		</>
	);
};

export const HeaderTimeOffRequestIcon = () => {
	return (
		<>
			<span>
				<svg
					width="22"
					height="22"
					viewBox="0 0 22 22"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<mask
						id="mask0_224_2-939433"
						maskUnits="userSpaceOnUse"
						x="0"
						y="0"
						width="20"
						height="21"
					>
						<path d="M20 0H0V21H20V0Z" fill="white" />
					</mask>
					<g mask="url(#mask0_224_2-939433)">
						<mask id="path-2-inside-1_224_2-533113" fill="white">
							<path d="M18.8008 18.2062H18.5623V15.7785C18.5623 14.2264 17.9546 12.7626 16.8535 11.655C16.2457 11.0537 15.5269 10.5963 14.7394 10.3055C16.9972 9.47231 18.5623 7.29293 18.5623 4.82928V2.3983H18.8008C19.4609 2.3983 20 1.86244 20 1.19915C20 0.53586 19.4641 0 18.8008 0H6.65578C5.99575 0 5.45662 0.539128 5.45662 1.19915C5.45662 1.85917 5.99575 2.3983 6.65578 2.3983H6.8943V4.38817C6.59696 4.34243 6.29309 4.31302 5.98595 4.31302C2.68584 4.31302 0 6.99886 0 10.299C0 13.5991 2.68584 16.2849 5.98595 16.2849C6.29636 16.2849 6.59696 16.2555 6.8943 16.2098V18.2062H6.65578C5.99575 18.2062 5.45662 18.7453 5.45662 19.4053C5.45662 20.0653 5.99575 20.6045 6.65578 20.6045H18.7976C19.4576 20.6045 19.9967 20.0653 19.9967 19.4053C19.9967 18.7453 19.4609 18.2062 18.8008 18.2062ZM1.35925 13.256L1.97027 12.9031C2.08789 12.8345 2.1271 12.6842 2.05849 12.5698C1.98987 12.4522 1.83957 12.413 1.72521 12.4816L1.11093 12.8312C0.751511 12.1418 0.53586 11.3674 0.499918 10.544H1.20569C1.33965 10.544 1.45074 10.4329 1.45074 10.299C1.45074 10.165 1.33965 10.0539 1.20569 10.0539H0.499918C0.53586 9.23379 0.751511 8.45613 1.11093 7.7667L1.72194 8.11959C1.76115 8.14246 1.80363 8.15226 1.84284 8.15226C1.92779 8.15226 2.00948 8.10979 2.05522 8.0281C2.12384 7.91047 2.08136 7.76017 1.967 7.69482L1.35599 7.34194C1.78729 6.66885 2.35582 6.10031 3.02892 5.66901L3.3818 6.28002C3.42754 6.35844 3.50923 6.40418 3.59418 6.40418C3.63666 6.40418 3.67914 6.39438 3.71508 6.37151C3.83271 6.30289 3.87192 6.15259 3.8033 6.03823L3.45042 5.42722C4.13985 5.0678 4.91423 4.85215 5.73762 4.81621V5.52197C5.73762 5.65594 5.84872 5.76703 5.98268 5.76703C6.11665 5.76703 6.22774 5.65594 6.22774 5.52197V4.81621C7.04787 4.85215 7.82552 5.0678 8.51495 5.42722L8.16206 6.03823C8.09345 6.15586 8.13593 6.30616 8.25029 6.37151C8.2895 6.39438 8.33197 6.40418 8.37118 6.40418C8.45613 6.40418 8.53782 6.36171 8.58356 6.28002L8.93645 5.66901C9.60954 6.10031 10.1781 6.66885 10.6094 7.34194L9.99837 7.69482C9.88074 7.76344 9.84153 7.91374 9.91014 8.0281C9.95589 8.10652 10.0376 8.15226 10.1225 8.15226C10.165 8.15226 10.2075 8.14246 10.2434 8.11959L10.8544 7.7667C11.2139 8.45613 11.4295 9.23052 11.4654 10.0539H10.7597C10.6257 10.0539 10.5146 10.165 10.5146 10.299C10.5146 10.4329 10.6257 10.544 10.7597 10.544H11.4654C11.4295 11.3642 11.2139 12.1418 10.8544 12.8312L10.2434 12.4784C10.1258 12.4097 9.97549 12.4522 9.91014 12.5666C9.84153 12.6842 9.88401 12.8345 9.99837 12.8999L10.6094 13.2527C10.1781 13.9258 9.60954 14.4944 8.93645 14.9257L8.58356 14.3147C8.51495 14.197 8.36791 14.1578 8.25029 14.2264C8.13266 14.295 8.09345 14.4454 8.16206 14.5597L8.51495 15.1707C7.82552 15.5301 7.05114 15.7458 6.22774 15.7817V15.076C6.22774 14.942 6.11665 14.8309 5.98268 14.8309C5.84872 14.8309 5.73762 14.942 5.73762 15.076V15.7817C4.9175 15.7458 4.13985 15.5301 3.45042 15.1707L3.8033 14.5597C3.87192 14.4421 3.82944 14.2918 3.71508 14.2264C3.59745 14.1578 3.44715 14.2003 3.3818 14.3147L3.02892 14.9257C2.35909 14.4976 1.78729 13.9258 1.35925 13.256ZM11.9719 10.299C11.9719 7.47917 10.0114 5.11681 7.38441 4.48293V2.3983H18.0722V4.82601C18.0722 7.35827 16.2719 9.56053 13.7951 10.0637C13.6808 10.0866 13.5991 10.1879 13.5991 10.3055C13.5991 10.4231 13.6808 10.5212 13.7951 10.5473C14.8211 10.7564 15.7589 11.2596 16.5071 12.0013C17.5167 13.0142 18.0722 14.3571 18.0722 15.7785V18.2062H7.38441V16.1183C10.0114 15.4811 11.9719 13.1188 11.9719 10.299Z" />
						</mask>
						<path
							d="M18.8008 18.2062H18.5623V15.7785C18.5623 14.2264 17.9546 12.7626 16.8535 11.655C16.2457 11.0537 15.5269 10.5963 14.7394 10.3055C16.9972 9.47231 18.5623 7.29293 18.5623 4.82928V2.3983H18.8008C19.4609 2.3983 20 1.86244 20 1.19915C20 0.53586 19.4641 0 18.8008 0H6.65578C5.99575 0 5.45662 0.539128 5.45662 1.19915C5.45662 1.85917 5.99575 2.3983 6.65578 2.3983H6.8943V4.38817C6.59696 4.34243 6.29309 4.31302 5.98595 4.31302C2.68584 4.31302 0 6.99886 0 10.299C0 13.5991 2.68584 16.2849 5.98595 16.2849C6.29636 16.2849 6.59696 16.2555 6.8943 16.2098V18.2062H6.65578C5.99575 18.2062 5.45662 18.7453 5.45662 19.4053C5.45662 20.0653 5.99575 20.6045 6.65578 20.6045H18.7976C19.4576 20.6045 19.9967 20.0653 19.9967 19.4053C19.9967 18.7453 19.4609 18.2062 18.8008 18.2062ZM1.35925 13.256L1.97027 12.9031C2.08789 12.8345 2.1271 12.6842 2.05849 12.5698C1.98987 12.4522 1.83957 12.413 1.72521 12.4816L1.11093 12.8312C0.751511 12.1418 0.53586 11.3674 0.499918 10.544H1.20569C1.33965 10.544 1.45074 10.4329 1.45074 10.299C1.45074 10.165 1.33965 10.0539 1.20569 10.0539H0.499918C0.53586 9.23379 0.751511 8.45613 1.11093 7.7667L1.72194 8.11959C1.76115 8.14246 1.80363 8.15226 1.84284 8.15226C1.92779 8.15226 2.00948 8.10979 2.05522 8.0281C2.12384 7.91047 2.08136 7.76017 1.967 7.69482L1.35599 7.34194C1.78729 6.66885 2.35582 6.10031 3.02892 5.66901L3.3818 6.28002C3.42754 6.35844 3.50923 6.40418 3.59418 6.40418C3.63666 6.40418 3.67914 6.39438 3.71508 6.37151C3.83271 6.30289 3.87192 6.15259 3.8033 6.03823L3.45042 5.42722C4.13985 5.0678 4.91423 4.85215 5.73762 4.81621V5.52197C5.73762 5.65594 5.84872 5.76703 5.98268 5.76703C6.11665 5.76703 6.22774 5.65594 6.22774 5.52197V4.81621C7.04787 4.85215 7.82552 5.0678 8.51495 5.42722L8.16206 6.03823C8.09345 6.15586 8.13593 6.30616 8.25029 6.37151C8.2895 6.39438 8.33197 6.40418 8.37118 6.40418C8.45613 6.40418 8.53782 6.36171 8.58356 6.28002L8.93645 5.66901C9.60954 6.10031 10.1781 6.66885 10.6094 7.34194L9.99837 7.69482C9.88074 7.76344 9.84153 7.91374 9.91014 8.0281C9.95589 8.10652 10.0376 8.15226 10.1225 8.15226C10.165 8.15226 10.2075 8.14246 10.2434 8.11959L10.8544 7.7667C11.2139 8.45613 11.4295 9.23052 11.4654 10.0539H10.7597C10.6257 10.0539 10.5146 10.165 10.5146 10.299C10.5146 10.4329 10.6257 10.544 10.7597 10.544H11.4654C11.4295 11.3642 11.2139 12.1418 10.8544 12.8312L10.2434 12.4784C10.1258 12.4097 9.97549 12.4522 9.91014 12.5666C9.84153 12.6842 9.88401 12.8345 9.99837 12.8999L10.6094 13.2527C10.1781 13.9258 9.60954 14.4944 8.93645 14.9257L8.58356 14.3147C8.51495 14.197 8.36791 14.1578 8.25029 14.2264C8.13266 14.295 8.09345 14.4454 8.16206 14.5597L8.51495 15.1707C7.82552 15.5301 7.05114 15.7458 6.22774 15.7817V15.076C6.22774 14.942 6.11665 14.8309 5.98268 14.8309C5.84872 14.8309 5.73762 14.942 5.73762 15.076V15.7817C4.9175 15.7458 4.13985 15.5301 3.45042 15.1707L3.8033 14.5597C3.87192 14.4421 3.82944 14.2918 3.71508 14.2264C3.59745 14.1578 3.44715 14.2003 3.3818 14.3147L3.02892 14.9257C2.35909 14.4976 1.78729 13.9258 1.35925 13.256ZM11.9719 10.299C11.9719 7.47917 10.0114 5.11681 7.38441 4.48293V2.3983H18.0722V4.82601C18.0722 7.35827 16.2719 9.56053 13.7951 10.0637C13.6808 10.0866 13.5991 10.1879 13.5991 10.3055C13.5991 10.4231 13.6808 10.5212 13.7951 10.5473C14.8211 10.7564 15.7589 11.2596 16.5071 12.0013C17.5167 13.0142 18.0722 14.3571 18.0722 15.7785V18.2062H7.38441V16.1183C10.0114 15.4811 11.9719 13.1188 11.9719 10.299Z"
							fill="white"
						/>
						<path
							d="M18.5623 18.2062H-20.4377V57.2062H18.5623V18.2062ZM16.8535 11.655L44.5117 -15.8409L44.3973 -15.9559L44.282 -16.07L16.8535 11.655ZM14.7394 10.3055L1.23736 -26.2827L-97.8777 10.2935L1.22955 46.8908L14.7394 10.3055ZM18.5623 2.3983V-36.6017H-20.4377V2.3983H18.5623ZM6.8943 2.3983H45.8943V-36.6017H6.8943V2.3983ZM6.8943 4.38817L0.964654 42.9348L45.8943 49.8463V4.38817H6.8943ZM6.8943 16.2098H45.8943V-29.2423L0.96972 -22.3376L6.8943 16.2098ZM6.8943 18.2062V57.2062H45.8943V18.2062H6.8943ZM1.35925 13.256L-18.146 -20.516L-53.469 -0.114863L-31.5034 34.2571L1.35925 13.256ZM1.97027 12.9031L21.4755 46.6751L21.5472 46.6336L21.6187 46.5919L1.97027 12.9031ZM2.05849 12.5698L-31.6264 32.225L-31.5082 32.4276L-31.3876 32.6287L2.05849 12.5698ZM1.72521 12.4816L21.0156 46.3767L21.404 46.1557L21.7871 45.9259L1.72521 12.4816ZM1.11093 12.8312L-33.4714 30.8607L-14.7654 66.7405L20.4014 46.7263L1.11093 12.8312ZM0.499918 10.544V-28.456H-40.2396L-38.463 12.2448L0.499918 10.544ZM0.499918 10.0539L-38.4627 8.34633L-40.2467 49.0539H0.499918V10.0539ZM1.11093 7.7667L20.616 -26.0053L-14.6469 -46.3715L-33.4717 -10.2622L1.11093 7.7667ZM1.72194 8.11959L21.3713 -25.5687L21.2993 -25.6107L21.227 -25.6525L1.72194 8.11959ZM2.05522 8.0281L-31.6318 -11.6234L-31.8054 -11.3259L-31.9737 -11.0254L2.05522 8.0281ZM1.967 7.69482L-17.5377 41.4671L-17.4603 41.5118L-17.3827 41.5561L1.967 7.69482ZM1.35599 7.34194L-31.481 -13.6992L-53.5158 20.6884L-18.1487 41.1142L1.35599 7.34194ZM3.02892 5.66901L36.8012 -13.8357L16.3756 -49.2026L-18.012 -27.1681L3.02892 5.66901ZM3.3818 6.28002L-30.3905 25.7847L-30.3487 25.8571L-30.3065 25.9294L3.3818 6.28002ZM3.71508 6.37151L-15.9364 -27.3156L-16.587 -26.936L-17.2225 -26.5317L3.71508 6.37151ZM3.8033 6.03823L-29.969 25.5429L-29.806 25.8251L-29.6384 26.1044L3.8033 6.03823ZM3.45042 5.42722L-14.5785 -29.1554L-50.6873 -10.3308L-30.3219 24.9319L3.45042 5.42722ZM5.73762 4.81621H44.7376V-35.9232L4.03694 -34.1467L5.73762 4.81621ZM6.22774 4.81621L7.93517 -34.1464L-32.7723 -35.9303V4.81621H6.22774ZM8.51495 5.42722L42.287 24.9323L62.6532 -10.3306L26.5439 -29.1554L8.51495 5.42722ZM8.16206 6.03823L41.8504 25.6876L41.8924 25.6156L41.9341 25.5433L8.16206 6.03823ZM8.25029 6.37151L27.8997 -27.3168L27.7502 -27.404L27.6 -27.4898L8.25029 6.37151ZM8.58356 6.28002L-25.1885 -13.2251L-25.3184 -13.0001L-25.4453 -12.7735L8.58356 6.28002ZM8.93645 5.66901L29.9776 -27.168L-4.40964 -49.2025L-24.8356 -13.8361L8.93645 5.66901ZM10.6094 7.34194L30.1136 41.1145L65.4815 20.6889L43.4464 -13.6992L10.6094 7.34194ZM9.99837 7.69482L-9.50585 -26.0777L-9.57959 -26.0351L-9.65313 -25.9922L9.99837 7.69482ZM9.91014 8.0281L43.5966 -11.6245L43.4761 -11.831L43.3531 -12.0359L9.91014 8.0281ZM10.2434 8.11959L-9.26195 -25.6523L-9.9959 -25.2284L-10.7107 -24.773L10.2434 8.11959ZM10.8544 7.7667L45.4354 -10.2654L26.6088 -46.3699L-8.65095 -26.0052L10.8544 7.7667ZM11.4654 10.0539V49.0539H52.2029L50.4284 8.35508L11.4654 10.0539ZM11.4654 10.544L50.4281 12.2494L52.2098 -28.456H11.4654V10.544ZM10.8544 12.8312L-8.64719 46.6053L26.6103 66.9634L45.4351 30.8639L10.8544 12.8312ZM10.2434 12.4784L-9.42893 46.1533L-9.34369 46.2031L-9.25819 46.2525L10.2434 12.4784ZM9.91014 12.5666L43.5963 32.2197L43.686 32.0659L43.7744 31.9112L9.91014 12.5666ZM9.99837 12.8999L29.4993 -20.8746L29.4293 -20.9149L29.3593 -20.955L9.99837 12.8999ZM10.6094 13.2527L43.4465 34.2936L65.4835 -0.0978325L30.1103 -20.5218L10.6094 13.2527ZM8.93645 14.9257L-24.8355 34.431L-4.40939 69.7971L29.9776 47.7627L8.93645 14.9257ZM8.58356 14.3147L42.3555 -5.19065L42.3163 -5.25837L42.277 -5.32594L8.58356 14.3147ZM8.25029 14.2264L27.8975 47.916L27.8988 47.9152L8.25029 14.2264ZM8.16206 14.5597L41.934 -4.94565L41.7696 -5.23027L41.6004 -5.51209L8.16206 14.5597ZM8.51495 15.1707L26.5431 49.7537L62.6539 30.9292L42.2869 -4.33465L8.51495 15.1707ZM6.22774 15.7817H-32.7723V56.5191L7.92651 54.7447L6.22774 15.7817ZM5.73762 15.7817L4.03206 54.7444L44.7376 56.5262V15.7817H5.73762ZM3.45042 15.1707L-30.3217 -4.33423L-50.6881 30.9294L-14.5777 49.7537L3.45042 15.1707ZM3.8033 14.5597L-29.8816 -5.09554L-29.9254 -5.02048L-29.9688 -4.94523L3.8033 14.5597ZM3.71508 14.2264L-15.9322 47.916L-15.7893 47.9992L-15.6458 48.0813L3.71508 14.2264ZM3.3818 14.3147L37.1539 33.8196L37.2002 33.7396L37.246 33.6593L3.3818 14.3147ZM3.02892 14.9257L-17.9736 47.7874L16.3992 69.7557L36.8011 34.4306L3.02892 14.9257ZM7.38441 4.48293H-31.6156V35.1917L-1.76356 42.3949L7.38441 4.48293ZM7.38441 2.3983V-36.6017H-31.6156V2.3983H7.38441ZM18.0722 2.3983H57.0722V-36.6017H18.0722V2.3983ZM13.7951 10.0637L21.4565 48.3038L21.508 48.2935L21.5595 48.283L13.7951 10.0637ZM13.7951 10.5473L5.11306 48.5686L5.55887 48.6704L6.00695 48.7618L13.7951 10.5473ZM16.5071 12.0013L44.1292 -15.5308L44.0467 -15.6136L43.9637 -15.6959L16.5071 12.0013ZM18.0722 18.2062V57.2062H57.0722V18.2062H18.0722ZM7.38441 18.2062H-31.6156V57.2062H7.38441V18.2062ZM7.38441 16.1183L-1.80881 -21.7827L-31.6156 -14.5528L-31.6156 16.1183H7.38441ZM18.8008 -20.7938H18.5623V57.2062H18.8008V-20.7938ZM57.5623 18.2062V15.7785H-20.4377V18.2062H57.5623ZM57.5623 15.7785C57.5623 3.82159 52.8055 -7.49812 44.5117 -15.8409L-10.8047 39.1509C-16.8963 33.0233 -20.4377 24.6312 -20.4377 15.7785H57.5623ZM44.282 -16.07C39.7534 -20.5502 34.2994 -24.0456 28.2492 -26.2798L1.22955 46.8908C-3.24562 45.2383 -7.26197 42.6576 -10.575 39.38L44.282 -16.07ZM28.2414 46.8937C45.5446 40.5083 57.5623 23.9175 57.5623 4.82928H-20.4377C-20.4377 -9.33168 -11.5502 -21.5637 1.23736 -26.2827L28.2414 46.8937ZM57.5623 4.82928V2.3983H-20.4377V4.82928H57.5623ZM18.5623 41.3983H18.8008V-36.6017H18.5623V41.3983ZM18.8008 41.3983C40.9303 41.3983 59 23.4712 59 1.19915H-19C-19 -19.7463 -2.00853 -36.6017 18.8008 -36.6017V41.3983ZM59 1.19915C59 -21.0051 41.0013 -39 18.8008 -39V39C-2.07311 39 -19 22.0769 -19 1.19915H59ZM18.8008 -39H6.65578V39H18.8008V-39ZM6.65578 -39C-15.5431 -39 -33.5434 -21.0002 -33.5434 1.19915H44.4566C44.4566 22.0785 27.5346 39 6.65578 39V-39ZM-33.5434 1.19915C-33.5434 23.3985 -15.5432 41.3983 6.65578 41.3983V-36.6017C27.5347 -36.6017 44.4566 -19.6801 44.4566 1.19915H-33.5434ZM6.65578 41.3983H6.8943V-36.6017H6.65578V41.3983ZM-32.1057 2.3983V4.38817H45.8943V2.3983H-32.1057ZM12.8239 -34.1584C11.0976 -34.424 8.75318 -34.687 5.98595 -34.687V43.313C3.833 43.313 2.09634 43.1088 0.964654 42.9348L12.8239 -34.1584ZM5.98595 -34.687C-18.8534 -34.687 -39 -14.5401 -39 10.299H39C39 28.5378 24.2251 43.313 5.98595 43.313V-34.687ZM-39 10.299C-39 35.1386 -18.8529 55.2849 5.98595 55.2849V-22.7151C24.2246 -22.7151 39 -7.94038 39 10.299H-39ZM5.98595 55.2849C8.766 55.2849 11.1087 55.02 12.8189 54.7572L0.96972 -22.3376C2.08525 -22.509 3.82672 -22.7151 5.98595 -22.7151V55.2849ZM-32.1057 16.2098V18.2062H45.8943V16.2098H-32.1057ZM6.8943 -20.7938H6.65578V57.2062H6.8943V-20.7938ZM6.65578 -20.7938C-15.5415 -20.7938 -33.5434 -2.79567 -33.5434 19.4053H44.4566C44.4566 40.2863 27.533 57.2062 6.65578 57.2062V-20.7938ZM-33.5434 19.4053C-33.5434 41.6021 -15.5457 59.6045 6.65578 59.6045V-18.3955C27.5372 -18.3955 44.4566 -1.47148 44.4566 19.4053H-33.5434ZM6.65578 59.6045H18.7976V-18.3955H6.65578V59.6045ZM18.7976 59.6045C41.0009 59.6045 58.9967 41.6002 58.9967 19.4053H-19.0033C-19.0033 -1.46961 -2.0857 -18.3955 18.7976 -18.3955V59.6045ZM58.9967 19.4053C58.9967 -2.6559 41.1377 -20.7938 18.8008 -20.7938V57.2062C-2.21585 57.2062 -19.0033 40.1465 -19.0033 19.4053H58.9967ZM20.8645 47.028L21.4755 46.6751L-17.535 -20.8689L-18.146 -20.516L20.8645 47.028ZM21.6187 46.5919C40.0953 35.8158 46.9887 11.6594 35.5046 -7.48908L-31.3876 32.6287C-42.7345 13.709 -35.9196 -10.1468 -17.6782 -20.7857L21.6187 46.5919ZM35.7434 -7.08544C24.9681 -25.552 0.815539 -32.4513 -18.3367 -20.9627L21.7871 45.9259C2.8636 57.2773 -20.9883 50.4564 -31.6264 32.225L35.7434 -7.08544ZM-17.5652 -21.4135L-18.1795 -21.0639L20.4014 46.7263L21.0156 46.3767L-17.5652 -21.4135ZM35.6933 -5.19831C37.9304 -0.907304 39.2463 3.88306 39.4628 8.84324L-38.463 12.2448C-38.1746 18.8517 -36.4273 25.1909 -33.4714 30.8607L35.6933 -5.19831ZM0.499918 49.544H1.20569V-28.456H0.499918V49.544ZM1.20569 49.544C22.8746 49.544 40.4507 31.9761 40.4507 10.299H-37.5493C-37.5493 -11.1104 -20.1953 -28.456 1.20569 -28.456V49.544ZM40.4507 10.299C40.4507 -11.3679 22.885 -28.9461 1.20569 -28.9461V49.0539C-20.2057 49.0539 -37.5493 31.6979 -37.5493 10.299H40.4507ZM1.20569 -28.9461H0.499918V49.0539H1.20569V-28.9461ZM39.4625 11.7615C39.2459 16.7041 37.938 21.4904 35.6936 25.7956L-33.4717 -10.2622C-36.435 -4.5781 -38.1742 1.76352 -38.4627 8.34633L39.4625 11.7615ZM-18.3942 41.5387L-17.7832 41.8916L21.227 -25.6525L20.616 -26.0053L-18.3942 41.5387ZM-17.9274 41.8079C-11.4811 45.5679 -4.56926 47.1523 1.84284 47.1523V-30.8477C8.17652 -30.8477 15.0034 -29.283 21.3713 -25.5687L-17.9274 41.8079ZM1.84284 47.1523C15.1501 47.1523 28.7152 40.2422 36.0841 27.0816L-31.9737 -11.0254C-24.6962 -24.0227 -11.2946 -30.8477 1.84284 -30.8477V47.1523ZM35.7423 27.6796C46.8143 8.69969 40.1096 -15.4275 21.3167 -26.1665L-17.3827 41.5561C-35.9469 30.9478 -42.5666 7.12126 -31.6318 -11.6234L35.7423 27.6796ZM21.4717 -26.0775L20.8607 -26.4303L-18.1487 41.1142L-17.5377 41.4671L21.4717 -26.0775ZM34.193 28.3831C31.5893 32.4465 28.1338 35.9021 24.0699 38.5062L-18.012 -27.1681C-23.4222 -23.7015 -28.0147 -19.1088 -31.481 -13.6992L34.193 28.3831ZM-30.7434 25.1737L-30.3905 25.7847L37.1541 -13.2247L36.8012 -13.8357L-30.7434 25.1737ZM-30.3065 25.9294C-23.348 37.8596 -10.5129 45.4042 3.59418 45.4042V-32.5958C17.5314 -32.5958 30.203 -25.1428 37.0701 -13.3693L-30.3065 25.9294ZM3.59418 45.4042C9.40275 45.4042 17.0988 44.0815 24.6526 39.2747L-17.2225 -26.5317C-9.74048 -31.2927 -2.12943 -32.5958 3.59418 -32.5958V45.4042ZM23.3666 40.0586C41.8334 29.2859 48.7405 5.13002 37.245 -14.028L-29.6384 26.1044C-40.9966 7.17516 -34.168 -16.6801 -15.9364 -27.3156L23.3666 40.0586ZM37.5756 -13.4665L37.2227 -14.0775L-30.3219 24.9319L-29.969 25.5429L37.5756 -13.4665ZM21.4794 40.0098C17.189 42.2465 12.3988 43.5626 7.4383 43.7791L4.03694 -34.1467C-2.57037 -33.8583 -8.90929 -32.1109 -14.5785 -29.1554L21.4794 40.0098ZM-33.2624 4.81621V5.52197H44.7376V4.81621H-33.2624ZM-33.2624 5.52197C-33.2624 27.1961 -15.6894 44.767 5.98268 44.767V-33.233C27.3868 -33.233 44.7376 -15.8842 44.7376 5.52197H-33.2624ZM5.98268 44.767C27.6558 44.767 45.2277 27.195 45.2277 5.52197H-32.7723C-32.7723 -15.8832 -15.4225 -33.233 5.98268 -33.233V44.767ZM45.2277 5.52197V4.81621H-32.7723V5.52197H45.2277ZM4.52031 43.7788C-0.422339 43.5622 -5.20871 42.2543 -9.51398 40.0098L26.5439 -29.1554C20.8598 -32.1187 14.5181 -33.8579 7.93517 -34.1464L4.52031 43.7788ZM-25.2571 -14.0779L-25.61 -13.4669L41.9341 25.5433L42.287 24.9323L-25.2571 -14.0779ZM-25.5263 -13.6111C-36.5962 5.36791 -29.8922 29.4938 -11.0994 40.2328L27.6 -27.4898C46.1641 -16.8815 52.7831 6.94381 41.8504 25.6876L-25.5263 -13.6111ZM-11.3991 40.0598C-4.95408 43.819 1.95737 45.4042 8.37118 45.4042V-32.5958C14.7066 -32.5958 21.5331 -31.0302 27.8997 -27.3168L-11.3991 40.0598ZM8.37118 45.4042C21.6784 45.4042 35.2435 38.4942 42.6124 25.3335L-25.4453 -12.7735C-18.1678 -25.7708 -4.76613 -32.5958 8.37118 -32.5958V45.4042ZM42.3556 25.7851L42.7085 25.1741L-24.8356 -13.8361L-25.1885 -13.2251L42.3556 25.7851ZM-12.1047 38.506C-16.1679 35.9024 -19.6235 32.4471 -22.2276 28.3831L43.4464 -13.6992C39.9797 -19.1094 35.387 -23.7018 29.9776 -27.168L-12.1047 38.506ZM-8.89482 -26.4306L-9.50585 -26.0777L29.5026 41.4674L30.1136 41.1145L-8.89482 -26.4306ZM-9.65313 -25.9922C-28.1199 -15.2196 -35.0261 8.93503 -23.5329 28.0921L43.3531 -12.0359C54.7092 6.89245 47.8813 30.7465 29.6499 41.3819L-9.65313 -25.9922ZM-23.7763 27.6807C-16.8187 39.6067 -3.98604 47.1523 10.1225 47.1523V-30.8477C24.0612 -30.8477 36.7305 -23.3936 43.5966 -11.6245L-23.7763 27.6807ZM10.1225 47.1523C15.9211 47.1523 23.6288 45.8338 31.1975 41.0122L-10.7107 -24.773C-3.21383 -29.5489 4.40894 -30.8477 10.1225 -30.8477V47.1523ZM29.7487 41.8915L30.3597 41.5386L-8.65095 -26.0052L-9.26195 -25.6523L29.7487 41.8915ZM-23.7266 25.7988C-25.9655 21.5051 -27.2813 16.7129 -27.4976 11.7527L50.4284 8.35508C50.1403 1.7481 48.3933 -4.59284 45.4354 -10.2654L-23.7266 25.7988ZM11.4654 -28.9461H10.7597V49.0539H11.4654V-28.9461ZM10.7597 -28.9461C-10.9134 -28.9461 -28.4854 -11.3741 -28.4854 10.299H49.5146C49.5146 31.7041 32.1648 49.0539 10.7597 49.0539V-28.9461ZM-28.4854 10.299C-28.4854 31.9824 -10.9031 49.544 10.7597 49.544V-28.456C32.1545 -28.456 49.5146 -11.1166 49.5146 10.299H-28.4854ZM10.7597 49.544H11.4654V-28.456H10.7597V49.544ZM-27.4973 8.83861C-27.281 3.8961 -25.9732 -0.892628 -23.7263 -5.2015L45.4351 30.8639C48.401 25.1762 50.14 18.8323 50.4281 12.2494L-27.4973 8.83861ZM30.356 -20.9429L29.745 -21.2957L-9.25819 46.2525L-8.64719 46.6053L30.356 -20.9429ZM29.9157 -21.1965C10.9173 -32.2951 -13.2208 -25.5674 -23.9541 -6.77804L43.7744 31.9112C33.1718 50.4718 9.33433 57.1145 -9.42893 46.1533L29.9157 -21.1965ZM-23.776 -7.08651C-34.8541 11.9017 -28.1355 36.019 -9.36252 46.7548L29.3593 -20.955C47.9035 -10.35 54.5371 13.4667 43.5963 32.2197L-23.776 -7.08651ZM-9.50251 46.6744L-8.89148 47.0272L30.1103 -20.5218L29.4993 -20.8746L-9.50251 46.6744ZM-22.2278 -7.78825C-19.6244 -11.8512 -16.1692 -15.3069 -12.1047 -17.9113L29.9776 47.7627C35.3882 44.2957 39.9806 39.7028 43.4465 34.2936L-22.2278 -7.78825ZM42.7084 -4.57965L42.3555 -5.19065L-25.1883 33.82L-24.8355 34.431L42.7084 -4.57965ZM42.277 -5.32594C31.4318 -23.9307 7.45237 -30.4567 -11.3982 -19.4624L27.8988 47.9152C9.28345 58.7723 -14.4019 52.3247 -25.1098 33.9553L42.277 -5.32594ZM-11.3969 -19.4632C-29.8702 -8.68984 -36.7765 15.4728 -25.2763 34.6315L41.6004 -5.51209C52.9634 13.418 46.1355 37.2798 27.8975 47.916L-11.3969 -19.4632ZM-25.6098 34.065L-25.257 34.676L42.2869 -4.33465L41.934 -4.94565L-25.6098 34.065ZM-9.51319 -19.4123C-5.22471 -21.6479 -0.434404 -22.9649 4.52897 -23.1813L7.92651 54.7447C14.5367 54.4565 20.8758 52.7081 26.5431 49.7537L-9.51319 -19.4123ZM45.2277 15.7817V15.076H-32.7723V15.7817H45.2277ZM45.2277 15.076C45.2277 -6.59193 27.6609 -24.1691 5.98268 -24.1691V53.8309C-15.4276 53.8309 -32.7723 36.4759 -32.7723 15.076H45.2277ZM5.98268 -24.1691C-15.6945 -24.1691 -33.2624 -6.59297 -33.2624 15.076H44.7376C44.7376 36.477 27.392 53.8309 5.98268 53.8309V-24.1691ZM-33.2624 15.076V15.7817H44.7376V15.076H-33.2624ZM7.44318 -23.181C12.3887 -22.9645 17.1752 -21.6557 21.4786 -19.4123L-14.5777 49.7537C-8.89554 52.7159 -2.55374 54.4561 4.03206 54.7444L7.44318 -23.181ZM37.2226 34.6756L37.5754 34.0646L-29.9688 -4.94523L-30.3217 -4.33423L37.2226 34.6756ZM37.4882 34.2149C48.5684 15.2258 41.8489 -8.89267 23.076 -19.6285L-15.6458 48.0813C-34.1901 37.4763 -40.8246 13.6584 -29.8816 -5.09554L37.4882 34.2149ZM23.3623 -19.4632C4.37728 -30.5349 -19.748 -23.8213 -30.4824 -5.02994L37.246 33.6593C26.6423 52.2219 2.81762 58.8505 -15.9322 47.916L23.3623 -19.4632ZM-30.3903 -5.19023L-30.7432 -4.57923L36.8011 34.4306L37.1539 33.8196L-30.3903 -5.19023ZM24.0314 -17.936C28.1278 -15.318 31.6032 -11.8429 34.2219 -7.74509L-31.5034 34.2571C-28.0286 39.6945 -23.4096 44.3132 -17.9736 47.7874L24.0314 -17.936ZM50.9719 10.299C50.9719 -11.0707 36.147 -28.6961 16.5324 -33.429L-1.76356 42.3949C-16.1242 38.9297 -27.0281 26.029 -27.0281 10.299H50.9719ZM46.3844 4.48293V2.3983H-31.6156V4.48293H46.3844ZM7.38441 41.3983H18.0722V-36.6017H7.38441V41.3983ZM-20.9278 2.3983V4.82601H57.0722V2.3983H-20.9278ZM-20.9278 4.82601C-20.9278 -11.1712 -9.68366 -24.9632 6.03073 -28.1556L21.5595 48.283C42.2275 44.0842 57.0722 25.8878 57.0722 4.82601H-20.9278ZM6.1337 -28.1764C-12.6044 -24.4222 -25.4009 -7.98641 -25.4009 10.3055H52.5991C52.5991 28.3622 39.966 44.5954 21.4565 48.3038L6.1337 -28.1764ZM-25.4009 10.3055C-25.4009 29.4011 -11.9632 44.6693 5.11306 48.5686L22.4771 -27.474C39.3248 -23.6269 52.5991 -8.55489 52.5991 10.3055H-25.4009ZM6.00695 48.7618C-0.469993 47.4417 -6.35083 44.2572 -10.9495 39.6985L43.9637 -15.6959C37.8686 -21.738 30.1122 -25.9289 21.5833 -27.6672L6.00695 48.7618ZM-11.115 39.5334C-17.3608 33.2672 -20.9278 24.7224 -20.9278 15.7785H57.0722C57.0722 3.99183 52.3942 -7.23884 44.1292 -15.5308L-11.115 39.5334ZM-20.9278 15.7785V18.2062H57.0722V15.7785H-20.9278ZM18.0722 -20.7938H7.38441V57.2062H18.0722V-20.7938ZM46.3844 18.2062V16.1183H-31.6156V18.2062H46.3844ZM16.5776 54.0193C36.1442 49.2732 50.9719 31.6777 50.9719 10.299H-27.0281C-27.0281 -5.44009 -16.1214 -18.311 -1.80881 -21.7827L16.5776 54.0193Z"
							fill="white"
							mask="url(#path-2-inside-1_224_2-533113)"
						/>
						<path
							d="M7 2V4.5L8.5 5.5L10.5 7L11.5 8.5L12 11L10.5 14L7 16.5V18.5H18.5L18 14.5L17 12L15.5 11L14 10.5L16.5 9L18 7L18.5 2H7Z"
							fill="white"
						/>
					</g>
					<path
						d="M5.92142 12.0352C6.32005 12.0352 6.6566 11.7771 6.78403 11.421H8.05833C8.19229 11.421 8.30339 11.3099 8.30339 11.1759C8.30339 11.0419 8.19229 10.9309 8.05833 10.9309H6.81997C6.75789 10.6205 6.5357 10.3722 6.24817 10.2611V8.24506C6.24817 8.11109 6.13707 8 6.00311 8C5.86914 8 5.75805 8.11109 5.75805 8.24506V10.2121C5.33001 10.2905 5 10.663 5 11.1138C5.00327 11.6203 5.41497 12.0352 5.92142 12.0352ZM5.92142 10.6858C6.15668 10.6858 6.34946 10.8786 6.34946 11.1138C6.34946 11.3491 6.15668 11.5419 5.92142 11.5419C5.68617 11.5419 5.49339 11.3491 5.49339 11.1138C5.49339 10.8786 5.6829 10.6858 5.92142 10.6858Z"
						fill="white"
					/>
				</svg>
			</span>
		</>
	);
};

export const CloseEyeIcon = ({ className = "absolute right-3 top-4", width = 18, height = 18 }) => {
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
				<g clipPath="url(#clip0_95_2-845336)">
					<path
						d="M13.1042 10.271L12.1875 9.35425C12.5487 8.36814 12.3612 7.54869 11.625 6.89591C10.8889 6.24314 10.0903 6.07647 9.22921 6.39591L8.31254 5.47925C8.54865 5.32647 8.81254 5.21536 9.10421 5.14591C9.39587 5.07647 9.69449 5.04175 10 5.04175C10.9862 5.04175 11.823 5.3855 12.5105 6.073C13.198 6.7605 13.5417 7.5973 13.5417 8.58341C13.5417 8.88897 13.5035 9.19105 13.4271 9.48966C13.3507 9.78827 13.2431 10.0487 13.1042 10.271ZM15.7917 12.9585L14.9584 12.1251C15.6389 11.6251 16.2327 11.0661 16.7396 10.448C17.2466 9.82994 17.6181 9.20841 17.8542 8.58341C17.1598 7.04175 16.1181 5.823 14.7292 4.92716C13.3403 4.03133 11.8334 3.58341 10.2084 3.58341C9.62504 3.58341 9.02782 3.63897 8.41671 3.75008C7.8056 3.86119 7.32643 3.99314 6.97921 4.14591L6.02087 3.16675C6.50699 2.94452 7.12851 2.75008 7.88546 2.58341C8.6424 2.41675 9.38199 2.33341 10.1042 2.33341C12.0903 2.33341 13.9063 2.89939 15.5521 4.03133C17.198 5.16327 18.4028 6.68064 19.1667 8.58341C18.8056 9.4723 18.3403 10.2848 17.7709 11.021C17.2014 11.7571 16.5417 12.4029 15.7917 12.9585ZM17 17.6668L13.5 14.2293C13.0139 14.4237 12.4653 14.573 11.8542 14.6772C11.2431 14.7814 10.625 14.8335 10 14.8335C7.97226 14.8335 6.13199 14.2675 4.47921 13.1355C2.82643 12.0036 1.61115 10.4862 0.833374 8.58341C1.11115 7.86119 1.49657 7.15633 1.98962 6.46883C2.48268 5.78133 3.08337 5.12508 3.79171 4.50008L1.16671 1.87508L2.04171 0.979248L17.8125 16.7501L17 17.6668ZM4.64587 5.37508C4.13199 5.75008 3.63546 6.24314 3.15629 6.85425C2.67712 7.46536 2.33337 8.04175 2.12504 8.58341C2.83337 10.1251 3.89935 11.3439 5.32296 12.2397C6.74657 13.1355 8.36115 13.5835 10.1667 13.5835C10.625 13.5835 11.0764 13.5557 11.5209 13.5001C11.9653 13.4446 12.2987 13.3612 12.5209 13.2501L11.1875 11.9168C11.0348 11.9862 10.8473 12.0383 10.625 12.073C10.4028 12.1078 10.1945 12.1251 10 12.1251C9.02782 12.1251 8.19449 11.7848 7.50004 11.1043C6.8056 10.4237 6.45837 9.58341 6.45837 8.58341C6.45837 8.37508 6.47574 8.16675 6.51046 7.95841C6.54518 7.75008 6.59726 7.56258 6.66671 7.39591L4.64587 5.37508Z"
						fill="#757575"
					/>
				</g>
				<defs>
					<clipPath id="clip0_95_2-845336">
						<rect width="20" height="18" fill="white" />
					</clipPath>
				</defs>
		</svg>
	);
};

export const BtterManageMentIcon = () => {
	return (
		<svg
			width="93"
			height="94"
			viewBox="0 0 93 94"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M43.4969 57.2687H49.3094L49.6 53.0062C50.375 52.8771 51.1007 52.6038 51.777 52.1865C52.4533 51.7692 53.0516 51.2998 53.5719 50.7781L57.6406 52.1344L60.3531 47.4844L57.4469 45.1594C57.7698 44.2552 57.9312 43.3187 57.9312 42.35C57.9312 41.3812 57.7698 40.4448 57.4469 39.5406L60.3531 37.2156L57.6406 32.5656L53.5719 33.9219C53.0337 33.4251 52.4148 32.978 51.7151 32.5805C51.0154 32.1831 50.3104 31.8875 49.6 31.6937L49.3094 27.4312H43.4969L43.2062 31.6937C42.4958 31.8875 41.7908 32.1831 41.0912 32.5805C40.3915 32.978 39.7725 33.4251 39.2344 33.9219L35.1656 32.5656L32.4531 37.2156L35.3594 39.5406C35.0365 40.4448 34.875 41.3812 34.875 42.35C34.875 43.3187 35.0365 44.2552 35.3594 45.1594L32.4531 47.4844L35.1656 52.1344L39.2344 50.7781C39.7547 51.2998 40.353 51.7692 41.0293 52.1865C41.7056 52.6038 42.4312 52.8771 43.2062 53.0062L43.4969 57.2687ZM46.4146 49.1312C44.534 49.1312 42.9318 48.4731 41.6078 47.1567C40.2839 45.8403 39.6219 44.2419 39.6219 42.3614C39.6219 40.4809 40.28 38.8786 41.5964 37.5547C42.9128 36.2307 44.5112 35.5687 46.3917 35.5687C48.2722 35.5687 49.8745 36.2269 51.1984 37.5433C52.5224 38.8597 53.1844 40.4581 53.1844 42.3386C53.1844 44.2191 52.5262 45.8214 51.2099 47.1453C49.8935 48.4693 48.295 49.1312 46.4146 49.1312ZM23.25 85.75V69.0875C19.5687 65.7292 16.7109 61.8057 14.6766 57.3172C12.6422 52.8286 11.625 48.0979 11.625 43.125C11.625 33.4375 15.0156 25.2031 21.7969 18.4219C28.5781 11.6406 36.8125 8.25 46.5 8.25C54.5729 8.25 61.7255 10.6234 67.9578 15.3703C74.1901 20.1172 78.2427 26.301 80.1156 33.9219L86.3156 58.625H73.625V78H58.125V85.75H52.3125V72.1875H67.8125V52.8125H78.8562L74.4969 35.375C72.9469 29.1104 69.5562 23.9922 64.325 20.0203C59.0938 16.0484 53.1521 14.0625 46.5 14.0625C38.4271 14.0625 31.5651 16.8557 25.9141 22.4422C20.263 28.0286 17.4375 34.8435 17.4375 42.8867C17.4375 47.0469 18.2875 50.9992 19.9876 54.7434C21.6878 58.4877 24.0992 61.8159 27.2219 64.7281L29.0625 66.4719V85.75H23.25Z"
				fill="#3A52BB"
			/>
		</svg>
	);
};

export const EnevelopIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			strokeWidth="1.9"
			stroke="currentColor"
			className="absolute top-3"
			width="20"
			height="15"
			viewBox="0 0 20 21"
			fill="none"
			style={{ left: "10px", top: "17px", color: "#757575" }}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
			/>
		</svg>
	);
};

export const EmailIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			strokeWidth="1.9"
			stroke="currentColor"
			className=""
			width="20"
			height="15"
			viewBox="0 0 20 21"
			fill="none"
			style={{ color: "white" }}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
			/>
		</svg>
	);
};

export const PasswordLockIcon = () => {
	return (
		<svg
			className="absolute left-3 top-3"
			width="20"
			height="21"
			viewBox="0 0 20 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.33325 18.8332V7.29159H6.04159V5.29159C6.04159 4.19645 6.42774 3.26294 7.20004 2.49107C7.97235 1.71919 8.90638 1.33325 10.0021 1.33325C11.0979 1.33325 12.0312 1.71919 12.802 2.49107C13.5728 3.26294 13.9583 4.19645 13.9583 5.29159V7.29159H16.6666V18.8332H3.33325ZM4.58325 17.5832H15.4166V8.54159H4.58325V17.5832ZM10.0034 14.6665C10.4455 14.6665 10.8228 14.5136 11.1353 14.2076C11.4478 13.9016 11.6041 13.5337 11.6041 13.104C11.6041 12.6874 11.4467 12.3089 11.1318 11.9686C10.817 11.6284 10.4385 11.4582 9.99642 11.4582C9.55431 11.4582 9.177 11.6284 8.8645 11.9686C8.552 12.3089 8.39575 12.6909 8.39575 13.1145C8.39575 13.5381 8.55317 13.9027 8.868 14.2082C9.18284 14.5138 9.56131 14.6665 10.0034 14.6665ZM7.29159 7.29159H12.7083V5.29159C12.7083 4.53927 12.4452 3.8998 11.919 3.37319C11.3929 2.84657 10.754 2.58325 10.0024 2.58325C9.25074 2.58325 8.61103 2.84657 8.08325 3.37319C7.55547 3.8998 7.29159 4.53927 7.29159 5.29159V7.29159Z"
				fill="#757575"
			/>
		</svg>
	);
};

export const OTPIcon = () => {
	return (
		<svg
			className="absolute top-3 left-4 w-6 h-6 text-gray-400"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			viewBox="0 0 20 21"
		>
			<path d="M5.83331 13C5.13887 13 4.54859 12.7569 4.06248 12.2708C3.57637 11.7847 3.33331 11.1944 3.33331 10.5C3.33331 9.80556 3.57637 9.21528 4.06248 8.72917C4.54859 8.24306 5.13887 8 5.83331 8C6.52776 8 7.11804 8.24306 7.60415 8.72917C8.09026 9.21528 8.33331 9.80556 8.33331 10.5C8.33331 11.1944 8.09026 11.7847 7.60415 12.2708C7.11804 12.7569 6.52776 13 5.83331 13ZM5.83331 15.5C6.90276 15.5 7.86804 15.1944 8.72915 14.5833C9.59026 13.9722 10.1944 13.1667 10.5416 12.1667H10.8333L11.9166 13.25C12 13.3333 12.0903 13.3924 12.1875 13.4271C12.2847 13.4618 12.3889 13.4792 12.5 13.4792C12.6111 13.4792 12.7153 13.4618 12.8125 13.4271C12.9097 13.3924 13 13.3333 13.0833 13.25L14.1666 12.1667L15.625 13.3125C15.7083 13.3819 15.8021 13.434 15.9062 13.4688C16.0104 13.5035 16.118 13.5139 16.2291 13.5C16.3403 13.4861 16.441 13.4549 16.5312 13.4062C16.6215 13.3576 16.7014 13.2917 16.7708 13.2083L18.6458 11.0625C18.7153 10.9792 18.7673 10.8889 18.8021 10.7917C18.8368 10.6944 18.8541 10.5903 18.8541 10.4792C18.8541 10.3681 18.8333 10.2674 18.7916 10.1771C18.75 10.0868 18.6944 10.0069 18.625 9.9375L17.7708 9.08333C17.6875 9 17.5937 8.9375 17.4896 8.89583C17.3854 8.85417 17.2778 8.83333 17.1666 8.83333H10.5416C10.2083 7.88889 9.62151 7.09722 8.78123 6.45833C7.94095 5.81944 6.95831 5.5 5.83331 5.5C4.44442 5.5 3.26387 5.98611 2.29165 6.95833C1.31942 7.93056 0.833313 9.11111 0.833313 10.5C0.833313 11.8889 1.31942 13.0694 2.29165 14.0417C3.26387 15.0139 4.44442 15.5 5.83331 15.5Z"></path>
		</svg>
	)
}

export const PhoneCallIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="red"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className="w-4 h-4"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
			/>
		</svg>
	);
};

export const ImageIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 72 72"
			className="w-14 h-14"
		>
			<path
				d="M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z"
				style={{ fill: "#e3edfc" }}
			></path>
			<path
				d="M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z"
				style={{ fill: "#b7d0ea" }}
			></path>
			<path
				d="M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z"
				style={{ fill: "#c4dbf2" }}
			></path>
			<path
				d="M27.2223,43H44.7086s2.325-.2815.7357-1.897l-5.6034-5.4985s-1.5115-1.7913-3.3357.7933L33.56,40.4707a.6887.6887,0,0,1-1.0186.0486l-1.9-1.6393s-1.3291-1.5866-2.4758,0c-.6561.9079-2.0261,2.8489-2.0261,2.8489S25.4268,43,27.2223,43Z"
				style={{ fill: "#755de0" }}
			></path>
		</svg>
	);
};

export const PDfICon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 72 72"
			className="w-14 h-14"
		>
			<path
				d="M49,61H23a5.0147,5.0147,0,0,1-5-5V16a5.0147,5.0147,0,0,1,5-5H40.9091L54,22.1111V56A5.0147,5.0147,0,0,1,49,61Z"
				style={{ fill: "#e3edfc" }}
			></path>
			<path
				d="M54,22.1111H44.1818a3.3034,3.3034,0,0,1-3.2727-3.3333V11s1.8409.2083,6.9545,4.5833C52.8409,20.0972,54,22.1111,54,22.1111Z"
				style={{ fill: "#b7d0ea" }}
			></path>
			<path
				d="M19.03,59A4.9835,4.9835,0,0,0,23,61H49a4.9835,4.9835,0,0,0,3.97-2Z"
				style={{ fill: "#c4dbf2" }}
			></path>
			<rect
				x="27"
				y="31"
				width="18"
				height="2"
				rx="1"
				ry="1"
				style={{ fill: "#7e95c4" }}
			></rect>
			<rect
				x="27"
				y="35"
				width="18"
				height="2"
				rx="1"
				ry="1"
				style={{ fill: "#7e95c4" }}
			></rect>
			<rect
				x="27"
				y="39"
				width="18"
				height="2"
				rx="1"
				ry="1"
				style={{ fill: "#7e95c4" }}
			></rect>
			<rect
				x="27"
				y="43"
				width="14"
				height="2"
				rx="1"
				ry="1"
				style={{ fill: "#7e95c4" }}
			></rect>
			<rect
				x="27"
				y="47"
				width="8"
				height="2"
				rx="1"
				ry="1"
				style={{ fill: "#7e95c4" }}
			></rect>
		</svg>
	);
};

export const FolderIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 72 72"
			className="w-14 h-14"
		>
			<path
				fill="#0fac81"
				d="M57.5,31h-23c-1.4,0-2.5-1.1-2.5-2.5v-10c0-1.4,1.1-2.5,2.5-2.5h23c1.4,0,2.5,1.1,2.5,2.5v10 C60,29.9,58.9,31,57.5,31z"
			></path>
			<path
				fill="#3fbd9a"
				d="M59.8,61H12.2C8.8,61,6,58,6,54.4V17.6C6,14,8.8,11,12.2,11h18.5c1.7,0,3.3,1,4.1,2.6L38,24h21.8c3.4,0,6.2,2.4,6.2,6v24.4C66,58,63.2,61,59.8,61z"
			></path>
			<path
				display="none"
				fill="#3fbd9a"
				d="M62.1,61H9.9C7.8,61,6,59.2,6,57c0,0,0-31.5,0-42c0-2.2,1.8-4,3.9-4h19.3c1.6,0,3.2,0.2,3.9,2.3l2.7,6.8c0.5,1.1,1.6,1.9,2.8,1.9h23.5c2.2,0,3.9,1.8,3.9,4v31C66,59.2,64.2,61,62.1,61z"
			></path>
			<path
				fill="#06a57a"
				d="M7.7,59c2.2,2.4,4.7,2,6.3,2h45c1.1,0,3.2,0.1,5.3-2H7.7z"
			></path>
		</svg>
	);
};
export const PlusIcon = ({ color = "black", size = 20, style = {} }) => {
	return (
		<div style={style}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
				width={`${size}px`}
				height={`${size}px`}
			>
				<path
					fill={color}
					d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 24 13 L 24 24 L 13 24 L 13 26 L 24 26 L 24 37 L 26 37 L 26 26 L 37 26 L 37 24 L 26 24 L 26 13 L 24 13 z"
				/>
			</svg>
		</div>
	);
};
export const EyeIcon = ({ color = "black", size = 20, style = {}, className = "" }) => {
	return (
		<div className={className} style={style}>
			<svg width={size} height={size} viewBox={`0 0 24 24`} strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">  <path stroke="none"
				d="M0 0h24v24H0z" />  <circle cx="12" cy="12" r="2" />  <path d="M2 12l1.5 2a11 11 0 0 0 17 0l1.5 -2" />  <path d="M2 12l1.5 -2a11 11 0 0 1 17 0l1.5 2" /></svg>
		</div>
	);
};
export const FlagIcon = ({ color = "black", size = 20, style = {}, className = "" }) => {
	return (
		<span className={className} style={style}>
			<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M5.75 1C6.16421 1 6.5 1.33579 6.5 1.75V3.6L8.22067 3.25587C9.8712 2.92576 11.5821 3.08284 13.1449 3.70797L13.5582 3.87329C14.9831 4.44323 16.5513 4.54967 18.0401 4.17746C18.6711 4.01972 19.1778 4.7036 18.8432 5.26132L17.5647 7.39221C17.2232 7.96137 17.0524 8.24595 17.0119 8.55549C16.9951 8.68461 16.9951 8.81539 17.0119 8.94451C17.0524 9.25405 17.2232 9.53863 17.5647 10.1078L19.1253 12.7089C19.4361 13.2269 19.1582 13.898 18.5721 14.0445L18.472 14.0695C16.7024 14.5119 14.8385 14.3854 13.1449 13.708C11.5821 13.0828 9.8712 12.9258 8.22067 13.2559L6.5 13.6V21.75C6.5 22.1642 6.16421 22.5 5.75 22.5C5.33579 22.5 5 22.1642 5 21.75V1.75C5 1.33579 5.33579 1 5.75 1Z" fill={color} />
			</svg>
		</span>
	);
};
export const DocumentIcon = ({ color = "black", size = 16, style = {}, className = "" }) => {
	return (
		<div className={className} style={style}>
			<svg fill={color} height={size} width={size} xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 296.999 296.999">
				<g>
					<g>
						<g>
							<path d="M169.197,43.09H18.808c-7.176,0-13.014,5.838-13.014,13.014v227.444c0,7.176,5.838,13.014,13.014,13.014h150.389
				c7.176,0,13.014-5.838,13.014-13.014V56.105C182.211,48.928,176.373,43.09,169.197,43.09z M151.794,274.258H36.21
				c-4.479,0-8.111-3.632-8.111-8.111s3.632-8.111,8.111-8.111h115.584c4.479,0,8.111,3.632,8.111,8.111
				S156.273,274.258,151.794,274.258z M151.794,235.73H36.21c-4.479,0-8.111-3.632-8.111-8.111s3.632-8.111,8.111-8.111h115.584
				c4.479,0,8.111,3.632,8.111,8.111C159.905,232.098,156.273,235.73,151.794,235.73z M151.794,197.202H36.21
				c-4.479,0-8.111-3.632-8.111-8.111s3.632-8.111,8.111-8.111h115.584c4.479,0,8.111,3.632,8.111,8.111
				S156.273,197.202,151.794,197.202z M151.794,158.674H36.21c-4.479,0-8.111-3.632-8.111-8.111s3.632-8.111,8.111-8.111h115.584
				c4.479,0,8.111,3.632,8.111,8.111S156.273,158.674,151.794,158.674z M151.794,120.146H36.21c-4.479,0-8.111-3.632-8.111-8.111
				s3.632-8.111,8.111-8.111h115.584c4.479,0,8.111,3.632,8.111,8.111S156.273,120.146,151.794,120.146z M151.794,81.618H36.21
				c-4.479,0-8.111-3.632-8.111-8.111c0-4.479,3.632-8.111,8.111-8.111h115.584c4.479,0,8.111,3.632,8.111,8.111
				C159.905,77.986,156.273,81.618,151.794,81.618z"/>
							<path d="M213.642,0H57.336c-7.177,0-13.014,5.838-13.014,13.014v13.854h124.875c16.121,0,29.237,13.115,29.237,29.237v201.931
				h15.208c7.176,0,13.014-5.838,13.014-13.014V13.014C226.656,5.838,220.818,0,213.642,0z"/>
							<path d="M291.205,23.324C291.204,10.464,281.88,0,270.42,0c-11.461,0-20.785,10.464-20.785,23.324v13.584h41.57V23.324z" />
							<path d="M249.635,53.13v214.537h0c0,1.2,0.342,2.373,0.983,3.371l14.921,23.249c1.087,1.694,2.919,2.712,4.881,2.712
				c1.961,0,3.794-1.018,4.881-2.712l14.921-23.249c0.641-0.998,0.983-2.171,0.983-3.371V53.13H249.635z"/>
						</g>
					</g>
				</g>
			</svg>
		</div>
	);
};
export const ClosedEyeIcon = ({ color = "black", size = 20, style = {}, className = "" }) => {
	return (
		<div className={className} style={style}>
			<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M20 14.8335C21.3082 13.3317 22 12 22 12C22 12 18.3636 5 12 5C11.6588 5 11.3254 5.02013 11 5.05822C10.6578 5.09828 10.3244 5.15822 10 5.23552M12 9C12.3506 9 12.6872 9.06015 13 9.17071C13.8524 9.47199 14.528 10.1476 14.8293 11C14.9398 11.3128 15 11.6494 15 12M3 3L21 21M12 15C11.6494 15 11.3128 14.9398 11 14.8293C10.1476 14.528 9.47198 13.8524 9.1707 13C9.11386 12.8392 9.07034 12.6721 9.04147 12.5M4.14701 9C3.83877 9.34451 3.56234 9.68241 3.31864 10C2.45286 11.1282 2 12 2 12C2 12 5.63636 19 12 19C12.3412 19 12.6746 18.9799 13 18.9418" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		</div>
	);
};
export const DeleteIcon = ({ color = "black", size = 20, style = {}, className = "" }) => {
	return (
		<div className={className} style={style}>
			<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M20.5001 6H3.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
				<path d="M9.5 11L10 16" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
				<path d="M14.5 11L14 16" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
				<path d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6" stroke={color} strokeWidth="1.5" />
				<path d="M18.3735 15.3991C18.1965 18.054 18.108 19.3815 17.243 20.1907C16.378 21 15.0476 21 12.3868 21H11.6134C8.9526 21 7.6222 21 6.75719 20.1907C5.89218 19.3815 5.80368 18.054 5.62669 15.3991L5.16675 8.5M18.8334 8.5L18.6334 11.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
			</svg>
		</div>
	);
};
export const PinIcon = ({ color = "red", size = 15, style = {}, className = "" }) => {
	return (
		<div className={className} style={style}>
			<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M19.1835 7.80516L16.2188 4.83755C14.1921 2.8089 13.1788 1.79457 12.0904 2.03468C11.0021 2.2748 10.5086 3.62155 9.5217 6.31506L8.85373 8.1381C8.59063 8.85617 8.45908 9.2152 8.22239 9.49292C8.11619 9.61754 7.99536 9.72887 7.86251 9.82451C7.56644 10.0377 7.19811 10.1392 6.46145 10.3423C4.80107 10.8 3.97088 11.0289 3.65804 11.5721C3.5228 11.8069 3.45242 12.0735 3.45413 12.3446C3.45809 12.9715 4.06698 13.581 5.28476 14.8L6.69935 16.2163L2.22345 20.6964C1.92552 20.9946 1.92552 21.4782 2.22345 21.7764C2.52138 22.0746 3.00443 22.0746 3.30236 21.7764L7.77841 17.2961L9.24441 18.7635C10.4699 19.9902 11.0827 20.6036 11.7134 20.6045C11.9792 20.6049 12.2404 20.5358 12.4713 20.4041C13.0192 20.0914 13.2493 19.2551 13.7095 17.5825C13.9119 16.8472 14.013 16.4795 14.2254 16.1835C14.3184 16.054 14.4262 15.9358 14.5468 15.8314C14.8221 15.593 15.1788 15.459 15.8922 15.191L17.7362 14.4981C20.4 13.4973 21.7319 12.9969 21.9667 11.9115C22.2014 10.826 21.1954 9.81905 19.1835 7.80516Z" fill={color} />
			</svg>
		</div>
	);
};
export const PinVIcon = ({ color = "red", size = 15, style = {}, className = "" }) => {
	return (
		<div className={className} style={style}>
			<svg fill={color} width={size} height={size} viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><path d="M 14.2539 35.9688 L 25.9492 35.9688 L 25.9492 48.0156 C 25.9492 51.5781 27.4258 54.5781 28.0117 54.5781 C 28.5976 54.5781 30.0742 51.5781 30.0742 48.0156 L 30.0742 35.9688 L 41.7461 35.9688 C 43.3633 35.9688 44.5351 34.9375 44.5351 33.3672 C 44.5351 32.3828 44.2305 31.6797 43.5508 30.9532 L 36.3789 23.1719 C 35.8867 22.6563 35.5820 22.2813 35.6992 21.3203 L 36.8945 12.7657 C 36.9649 12.2735 37.0117 11.9922 37.4336 11.6875 L 43.1992 7.5157 C 44.4883 6.5781 45.0508 5.4297 45.0508 4.3750 C 45.0508 2.8047 43.7851 1.4219 41.9805 1.4219 L 14.0195 1.4219 C 12.2149 1.4219 10.9492 2.8047 10.9492 4.3750 C 10.9492 5.4297 11.5117 6.5781 12.7773 7.5157 L 18.5429 11.6875 C 18.9883 11.9922 19.0351 12.2735 19.1054 12.7657 L 20.3008 21.3203 C 20.4180 22.2813 20.1133 22.6563 19.6211 23.1719 L 12.4492 30.9532 C 11.7695 31.6797 11.4649 32.3828 11.4649 33.3672 C 11.4649 34.9375 12.6367 35.9688 14.2539 35.9688 Z" /></svg>
		</div>
	);
};


export const PrintIcons = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
			<path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z" />
		</svg>

	)
}

export function IconFilterCircleOutline(props) {
	return (
		<svg
			viewBox="0 0 21 21"
			className="text-gray-400"

			fill="currentColor"
			height="3em"
			width="3em"
			{...props}
		>
			<g
				fill="none"
				fillRule="evenodd"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M4.5 7.5h12M6.5 10.5h8M8.5 13.5h4" />
			</g>
		</svg>
	)
}

export function CollapseSidebar() {
	return (

		<svg xmlns="http://www.w3.org/2000/svg" height="1em"
			width="1em" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" /></svg>
	)
}

export function DangerIcon() {
	return (
		<svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M5.31171 10.7615C8.23007 5.58716 9.68925 3 12 3C14.3107 3 15.7699 5.58716 18.6883 10.7615L19.0519 11.4063C21.4771 15.7061 22.6897 17.856 21.5937 19.428C20.4978 21 17.7864 21 12.3637 21H11.6363C6.21356 21 3.50217 21 2.40626 19.428C1.31034 17.856 2.52291 15.7061 4.94805 11.4063L5.31171 10.7615ZM12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V8C11.25 7.58579 11.5858 7.25 12 7.25ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="red" />
		</svg>
	)
}


export function UserSLashIcon() {
	return (
		<svg fill="red" className="w-4 h-4 text-red-500" viewBox="0 -64 640 640" xmlns="http://www.w3.org/2000/svg"><path d="M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z" /></svg>
	)
}

export function DangerIcons() {
	return (
		// <svg width="20px" height="20px" className="btnnn" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		// 	<path opacity="0.5" d="M12 3C9.68925 3 8.23007 5.58716 5.31171 10.7615L4.94805 11.4063C2.52291 15.7061 1.31034 17.856 2.40626 19.428C3.50217 21 6.21356 21 11.6363 21H12.3637C17.7864 21 20.4978 21 21.5937 19.428C22.6897 17.856 21.4771 15.7061 19.0519 11.4063L18.6883 10.7615C15.7699 5.58716 14.3107 3 12 3Z" fill="red" />
		// 	<path d="M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V8C11.25 7.58579 11.5858 7.25 12 7.25Z" fill="white" />
		// 	<path d="M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="white" />
		// </svg>
		<svg width="14px" height="14px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#ff0000" d="M17.79 15.11l-7-14a2 2 0 0 0-3.58 0l-7 14a1.975 1.975 0 0 0 .09 1.94A2 2 0 0 0 2 18h14a1.994 1.994 0 0 0 1.7-.95 1.967 1.967 0 0 0 .09-1.94zM9 16a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 9 16zm.98-4.806a1 1 0 0 1-1.96 0l-.99-5A1 1 0 0 1 8.01 5h1.983a1 1 0 0 1 .98 1.194z"></path> </g></svg>
	)
}


export const MessageIcon = ({ color, size = 22 }) => {
	return (
		<svg
			version="1.1"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 512 512"
			style={{ enableBackground: 'new 0 0 512 512' }}
			xmlSpace="preserve"
			height={size}
			width={size}
			fill={color}
		>
			<g>
				<g>
					<path d="M304,96H112c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h192c8.832,0,16-7.168,16-16C320,103.168,312.832,96,304,96z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M240,160H112c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h128c8.832,0,16-7.168,16-16C256,167.168,248.832,160,240,160z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M352,0H64C28.704,0,0,28.704,0,64v320c0,6.208,3.584,11.872,9.216,14.496C11.36,399.488,13.696,400,16,400c3.68,0,7.328-1.28,10.24-3.712L117.792,320H352c35.296,0,64-28.704,64-64V64C416,28.704,387.296,0,352,0z M384,256c0,17.632-14.336,32-32,32H112c-3.744,0-7.36,1.312-10.24,3.712L32,349.856V64c0-17.632,14.336-32,32-32h288c17.664,0,32,14.368,32,32V256z" />
				</g>
			</g>
			<g>
				<g>
					<path d="M448,128c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16c17.664,0,32,14.368,32,32v270.688l-54.016-43.2c-2.816-2.24-6.368-3.488-9.984-3.488H192c-17.664,0-32-14.368-32-32v-16c0-8.832-7.168-16-16-16c-8.832,0-16,7.168-16,16v16c0,35.296,28.704,64,64,64h218.368l75.616,60.512C488.896,510.816,492.448,512,496,512c2.336,0,4.704-0.512,6.944-1.568C508.48,507.744,512,502.144,512,496V192C512,156.704,483.296,128,448,128z" />
				</g>
			</g>
		</svg>
	);
}


export const ContactIcon = ({ color }) => {
	return (
		<svg
			height="22"
			viewBox="-49 -17 560 560"
			width="22"
			xmlns="http://www.w3.org/2000/svg"
			fill={color}
		>
			<path d="m397.667969 0h-295.375c-34.511719.015625-62.488281 27.988281-62.5 62.5v27h-29.375c-6.90625 0-12.5 5.597656-12.5 12.5s5.59375 12.5 12.5 12.5h29.246093v82h-29.246093c-6.90625 0-12.5 5.59375-12.5 12.5 0 6.902344 5.59375 12.5 12.5 12.5h29.246093v82h-29.246093c-6.90625 0-12.5 5.597656-12.5 12.5 0 6.90625 5.59375 12.5 12.5 12.5h29.246093v82h-29.246093c-6.90625 0-12.5 5.597656-12.5 12.5s5.59375 12.5 12.5 12.5h29.246093v27c.015626 34.511719 27.988282 62.484375 62.5 62.5h295.375c34.511719-.015625 62.492188-27.988281 62.5-62.5v-400c.050782-34.488281-27.882812-62.4765625-62.371093-62.5zm37.5 462.5c-.0625 20.683594-16.816407 37.441406-37.5 37.5h-295.375c-20.683594-.058594-37.441407-16.816406-37.5-37.5v-27h29.246093c6.90625 0 12.5-5.597656 12.5-12.5s-5.59375-12.5-12.5-12.5h-29.246093v-82h29.246093c6.90625 0 12.5-5.59375 12.5-12.5 0-6.902344-5.59375-12.5-12.5-12.5h-29.246093v-82h29.246093c6.90625 0 12.5-5.597656 12.5-12.5 0-6.90625-5.59375-12.5-12.5-12.5h-29.246093v-82h29.246093c6.90625 0 12.5-5.597656 12.5-12.5s-5.59375-12.5-12.5-12.5h-29.246093v-27c.058593-20.683594 16.816406-37.441406 37.5-37.5h295.375c20.683593.058594 37.4375 16.816406 37.5 37.5zm0 0" />
			<path d="m249.917969 258.875c33.480469 0 60.625-27.140625 60.625-60.625s-27.144531-60.625-60.625-60.625c-33.484375 0-60.625 27.140625-60.625 60.625.03125 33.46875 27.152343 60.59375 60.625 60.625zm0-96.375c19.671875 0 35.625 15.953125 35.625 35.625s-15.953125 35.625-35.625 35.625c-19.675781 0-35.625-15.953125-35.625-35.625.035156-19.65625 15.960937-35.589844 35.625-35.625zm0 0" />
			<path d="m249.917969 279c-52 0-92.753907 42.125-92.753907 96 .019532 6.894531 5.605469 12.480469 12.5 12.5h160.503907c6.894531-.019531 12.480469-5.605469 12.5-12.5 0-53.875-40.753907-96-92.75-96zm-66.753907 83.5c5.378907-34.125 32.253907-58.5 66.753907-58.5 34.496093 0 61.5 24.375 66.75 58.5zm0 0" />
		</svg>
	);
};

export const SupportIcon = ({ color, size = 22 }) => {
	return (
		<svg
			height={size}
			viewBox="0 0 512 512"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			fill={color}
		>
			<path d="M256,8C119.033,8,8,119.033,8,256s111.033,248,248,248s248-111.033,248-248S392.967,8,256,8z M256,456c-110.532,0-200-89.451-200-200c0-110.532,89.451-200,200-200c110.532,0,200,89.451,200,200C456,366.549,366.549,456,256,456z" />
			<path d="M256,96c-55.114,0-100,44.886-100,100c0,55.114,44.886,100,100,100c55.114,0,100-44.886,100-100C356,140.886,311.114,96,256,96z M256,264c-37.555,0-68-30.445-68-68s30.445-68,68-68s68,30.445,68,68S293.555,264,256,264z" />
			<path d="M168,232h-48c-13.255,0-24,10.745-24,24s10.745,24,24,24h48c13.255,0,24-10.745,24-24S181.255,232,168,232z" />
			<path d="M392,232h-48c-13.255,0-24,10.745-24,24s10.745,24,24,24h48c13.255,0,24-10.745,24-24S405.255,232,392,232z" />
			<path d="M256,392c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S269.255,392,256,392z" />
			<path d="M256,120c-13.255,0-24,10.745-24,24s10.745,24,24,24s24-10.745,24-24S269.255,120,256,120z" />
		</svg>
	);
};

export const ChatSearchIcon = () => {
	return (
		<svg width="20" height="21" className="absolute left-6 top-3" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2_54-538021)">
				<path d="M19.6681 18.1192L16.0787 14.5544C18.8814 10.965 18.5864 5.85126 15.3657 2.63061C13.6693 0.934235 11.4075 0 8.99816 0C6.58881 0 4.32698 0.934235 2.63061 2.63061C0.934235 4.32698 0 6.58881 0 8.99816C0 11.4075 0.934235 13.6693 2.63061 15.3657C4.32698 17.0621 6.58881 17.9963 8.99816 17.9963C10.9896 17.9963 12.9564 17.3325 14.5298 16.0787L18.0947 19.6927C18.3159 19.914 18.5864 20.0123 18.8814 20.0123C19.1764 20.0123 19.4468 19.8894 19.6681 19.6927C20.1106 19.2747 20.1106 18.5618 19.6681 18.1192ZM15.7837 8.99816C15.7837 10.8175 15.0707 12.5138 13.7923 13.7923C12.5138 15.0707 10.7929 15.7837 8.99816 15.7837C7.20344 15.7837 5.48248 15.0707 4.20406 13.7923C2.92563 12.5138 2.21266 10.7929 2.21266 8.99816C2.21266 7.17886 2.92563 5.48248 4.20406 4.20406C5.48248 2.92563 7.20344 2.21266 8.99816 2.21266C10.8175 2.21266 12.5138 2.92563 13.7923 4.20406C15.0707 5.48248 15.7837 7.17886 15.7837 8.99816Z" fill="#757575"></path>
			</g>
			<defs>
				<clipPath id="clip0_2_54-538021">
					<rect width="20" height="21" fill="white"></rect>
				</clipPath>
			</defs>
		</svg>
	)
}


export const ChatGroupIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
			<path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
		</svg>
	)
}


export const CHATICON = () => {
	return (
		<svg width="25" height="25" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M6 14H14V12H6V14ZM6 11H18V9H6V11ZM6 8H18V6H6V8ZM2 22V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H6L2 22ZM5.15 16H20V4H4V17.125L5.15 16Z" fill="#FFFFFF" />
		</svg>
	)
}

export const DownwardIcon = () => {
	return (
		<svg width="12" className='text-white' height="8" viewBox="0 0 12 8" fill="white" xmlns="http://www.w3.org/2000/svg" >
			<g clipPath="url(#clip0_26_9-807815)">
				<path d="M6.08665 7.35142C6.2197 7.3309 6.34332 7.2662 6.43996 7.16651L11.7728 1.70461C11.8395 1.6446 11.8939 1.57069 11.9328 1.48743C11.9717 1.40417 11.9942 1.31332 11.999 1.22043C12.0038 1.12755 11.9908 1.03458 11.9607 0.94727C11.9306 0.85995 11.8841 0.78012 11.8241 0.71266C11.764 0.6452 11.6917 0.59155 11.6115 0.55499C11.5313 0.51843 11.445 0.49972 11.3578 0.50004C11.2706 0.50036 11.1844 0.51968 11.1045 0.55682C11.0245 0.59397 10.9525 0.64816 10.8929 0.71605L6 5.72992L1.1071 0.716049C1.0475 0.648149 0.975501 0.593969 0.895501 0.556819C0.815601 0.519679 0.729401 0.500359 0.642201 0.500039C0.555001 0.499719 0.468701 0.518429 0.388501 0.554989C0.308301 0.591549 0.236001 0.645199 0.175901 0.712659C0.115901 0.780119 0.0694005 0.859949 0.0393005 0.947269C0.00920052 1.03458 -0.00379905 1.12755 0.00100094 1.22043C0.00580093 1.31332 0.0283002 1.40417 0.0672002 1.48743C0.1061 1.57069 0.1605 1.6446 0.2272 1.70461L5.56004 7.16651C5.62921 7.23748 5.71245 7.29094 5.8036 7.32294C5.89476 7.35495 5.99149 7.36469 6.08665 7.35142Z" fill="white" />
			</g>
			<defs>
				<clipPath id="clip0_26_9-807815">
					<rect width="12" height="7" fill="white" transform="translate(0 0.5)" />
				</clipPath>
			</defs>
		</svg>
	)
}


export const UpWardIcon = () => {
	return (
		<svg width="12" className='text-white' height="8" viewBox="0 0 12 8" fill="white" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_26_9-807815)">
				<path d="M5.91335 0.648581C5.7803 0.669099 5.65668 0.733795 5.56004 0.833489L0.227169 6.29539C0.160538 6.3554 0.106104 6.42931 0.0672067 6.51257C0.0283094 6.59583 0.00576948 6.68668 0.000970184 6.77957C-0.00382911 6.87245 0.00921338 6.96542 0.0392973 7.05273C0.0693813 7.14005 0.115872 7.21988 0.175917 7.28734C0.235962 7.3548 0.308293 7.40845 0.388474 7.44501C0.468654 7.48157 0.554992 7.50028 0.642189 7.49996C0.729385 7.49964 0.815602 7.48032 0.895547 7.44318C0.975492 7.40603 1.04748 7.35184 1.10709 7.28395L6 2.27008L10.8929 7.28395C10.9525 7.35185 11.0245 7.40603 11.1045 7.44318C11.1844 7.48032 11.2706 7.49964 11.3578 7.49996C11.445 7.50028 11.5313 7.48157 11.6115 7.44501C11.6917 7.40845 11.764 7.3548 11.8241 7.28734C11.8841 7.21988 11.9306 7.14005 11.9607 7.05273C11.9908 6.96542 12.0038 6.87245 11.999 6.77957C11.9942 6.68668 11.9717 6.59583 11.9328 6.51257C11.8939 6.42931 11.8395 6.3554 11.7728 6.29539L6.43996 0.833489C6.37079 0.762519 6.28755 0.709063 6.1964 0.677056C6.10524 0.645049 6.00851 0.635309 5.91335 0.648581Z" fill="white" />
			</g>
			<defs>
				<clipPath id="clip0_26_9-807815">
					<rect width="12" height="7" fill="white" transform="translate(0 0.5)" />
				</clipPath>
			</defs>
		</svg>
	)
}

export const DownArrowIcon = () => {
	return (
		<svg
			id="Layer_1"
			enableBackground="new 0 0 128 128"
			viewBox="0 0 128 128"
			xmlns="http://www.w3.org/2000/svg"
			width='24'
			height='24'
			fill="white"
		>
			<path
				id="Down_Arrow_3_"
				d="M64 88c-1.023 0-2.047-.391-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l37.172 37.172 37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
			/>
		</svg>
	);
};

export const ChatIconComponent = () => {
	return (
		<svg
			height="24"
			viewBox="-7 0 483 483.46667"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
			fill="white"
		>
			<path d="m.234375 452.132812v-411.199218c0-22.535156 18.398437-40.933594 40.933594-40.933594h312.796875c22.535156 0 40.933594 18.398438 40.933594 40.933594v161.734375h-21.332032v-161.734375c0-10.800782-8.800781-19.601563-19.601562-19.601563h-312.796875c-10.800781 0-19.601563 8.800781-19.601563 19.601563v375.867187l82.667969-43.46875h130.664063v21.335938h-125.332032zm0 0" fill="white" />
			<path d="m469.566406 483.464844-75.601562-46.132813h-141.332032c-15.597656 0-28.398437-12.664062-28.398437-28.398437v-188.535156c0-15.597657 12.664063-28.398438 28.398437-28.398438h188.535157c15.597656 0 28.398437 12.667969 28.398437 28.398438zm-216.933594-270.132813c-3.867187 0-7.066406 3.203125-7.066406 7.066407v188.535156c0 3.867187 3.199219 7.066406 7.066406 7.066406h147.332032l48.402344 29.464844v-225.066406c0-3.863282-3.199219-7.066407-7.066407-7.066407zm0 0" fill="white" />
		</svg>
	);
};


export const BreadCrumbIcon = () => {
	return (
		<svg className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
			<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
		</svg>
	)
}



export const DownloadSheet = ({ width = 18, height = 18, fill = 'white' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 24" id="file-export">
			<path
				fill={fill}
				fillRule="evenodd"
				d="M1 4C1 2.34315 2.34315 1 4 1H11.1716C11.9672 1 12.7303 1.31607 13.2929 1.87868L17.1213 5.70711C17.6839 6.26972 18 7.03278 18 7.82843V8C18 8.55228 17.5523 9 17 9H13C11.3431 9 10 7.65685 10 6V3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H17C17.5523 21 18 21.4477 18 22C18 22.5523 17.5523 23 17 23H4C2.34315 23 1 21.6569 1 20V4ZM12 3.41421L15.5858 7H13C12.4477 7 12 6.55228 12 6V3.41421ZM22.7071 15.7071L19.7072 18.7071C19.3167 19.0976 18.6835 19.0976 18.293 18.7071C17.9024 18.3166 17.9024 17.6834 18.2929 17.2929L19.5858 16H10C9.44771 16 9 15.5523 9 15C9 14.4477 9.44771 14 10 14H19.5858L18.2929 12.7071C17.9024 12.3166 17.9024 11.6834 18.293 11.2929C18.6835 10.9024 19.3167 10.9024 19.7072 11.2929L22.7071 14.2929C23.0976 14.6834 23.0976 15.3166 22.7071 15.7071Z"
				clipRule="evenodd"
			/>
		</svg>
	);
};


export const DownloadPdf = ({ width = 18, height = 18, fill = 'white' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 24" id="file-pdf">
			<path
				fill={fill}
				fillRule="evenodd"
				d="M4 1C2.34315 1 1 2.34315 1 4v16c0 1.6569 1.34315 3 3 3h14c1.6569 0 3-1.3431 3-3V7.82843c0-.79565-.3161-1.55871-.8787-2.12132l-3.8284-3.82843C15.7303 1.31607 14.9672 1 14.1716 1H4Zm10 2H4c-.55228 0-1 .44772-1 1v16c0 .5523.44772 1 1 1h14c.5523 0 1-.4477 1-1V9h-4c-1.6569 0-3-1.34315-3-3V3h1Zm2 .41421L18.5858 7H16c-.5523 0-1-.44772-1-1V3.41421ZM6 12c0-.5523.44772-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.55228 0-1-.4477-1-1Zm0 4c0-.5523.44772-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1H7c-.55228 0-1-.4477-1-1Z"
				clipRule="evenodd"
			/>
		</svg>
	);
};

export const RestoreIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			enableBackground="new 0 0 512 512"
			viewBox="0 0 512 512"
			id="restore"
			width="18" height="18"
			fill="white"
		// {...props}
		>
			<polygon
				points="259.291 54.729 259 89.081 259 89.084 258.6 123.948 257.864 192.444 335.965 129.524"
			></polygon>
			<path
				d="M438.7,249.837l-50.979-0.509c2.277,10.144,3.376,20.555,3.272,31.035c-0.358,35.821-14.576,69.423-40.035,94.615
                c-25.439,25.174-59.149,39.037-94.919,39.037c-0.474,0.005-0.928-0.003-1.387-0.007c-36.058-0.36-69.818-14.74-95.06-40.492
                c-25.242-25.751-38.946-59.791-38.586-95.85c0.353-35.334,14.247-68.609,39.123-93.694c23.679-23.879,54.846-37.881,88.216-39.739
                l0.008-0.826l0.492-49.247C151.292,97.914,71.99,178.961,71.009,277.167c-1.019,102.004,81.14,185.819,183.143,186.838
                c0.631,0.007,1.293,0.028,1.887,0.01c100.974-0.001,183.943-82.163,184.951-183.153C441.094,270.497,440.324,260.08,438.7,249.837
                z"
			></path>
		</svg>
	)
}


export const PreviousIcon = () => {
	return (
		<svg
			className="h-4 w-4"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M15 19l-7-7 7-7"
			/>
		</svg>
	)
}


export const NextIcon = () => {
	return (
		<svg
			className="h-4 w-4"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={2}
				d="M9 5l7 7-7 7"
			/>
		</svg>
	)
}


export const ArrowsIcon = () => {
	return (
		<>
			<svg
				fill="white"
				height="12px"
				width="12px"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 330.002 330.002"
				stroke="white"
			>
				<g strokeWidth="0"></g>
				<g strokeLinecap="round" strokeLinejoin="round"></g>
				<g>
					<g>
						<path d="M315.001,180.001h-300c-6.371,0-12.046,4.024-14.154,10.035c-2.109,6.011-0.19,12.699,4.784,16.678 l150.004,120c2.739,2.191,6.055,3.287,9.37,3.287c3.316,0,6.631-1.096,9.371-3.287l149.996-120 c4.974-3.98,6.893-10.667,4.784-16.678C327.047,184.024,321.371,180.001,315.001,180.001z M165.005,295.791L57.764,210.001H272.24 L165.005,295.791z"></path>
						<path d="M15.001,150.001h300c6.371,0,12.046-4.024,14.154-10.035c2.109-6.011,0.19-12.699-4.784-16.678 l-150.004-120c-5.479-4.382-13.262-4.382-18.741,0l-149.996,120c-4.974,3.979-6.893,10.667-4.784,16.678 C2.955,145.977,8.631,150.001,15.001,150.001z M164.997,34.21l107.241,85.79H57.762L164.997,34.21z"></path>
					</g>
				</g>
			</svg>
		</>
	)
}


export const PDFIcon = ({ width = 22, height = 22 }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 56 64" fill="#000000">
		<path fill="#8C181A" d="M5.1,0C2.3,0,0,2.3,0,5.1v53.8C0,61.7,2.3,64,5.1,64h45.8c2.8,0,5.1-2.3,5.1-5.1V20.3L37.1,0H5.1z" />
		<path fill="#6B0D12" d="M56,20.4v1H43.2c0,0-6.3-1.3-6.1-6.7c0,0,0.2,5.7,6,5.7H56z" />
		<path opacity="0.5" fill="#FFFFFF" d="M37.1,0v14.6c0,1.7,1.1,5.8,6.1,5.8H56L37.1,0z" />
		<path fill="#FFFFFF" d="M14.9,49h-3.3v4.1c0,0.4-0.3,0.7-0.8,0.7c-0.4,0-0.7-0.3-0.7-0.7V42.9c0-0.6,0.5-1.1,1.1-1.1h3.7
		c2.4,0,3.8,1.7,3.8,3.6C18.7,47.4,17.3,49,14.9,49z M14.8,43.1h-3.2v4.6h3.2c1.4,0,2.4-0.9,2.4-2.3C17.2,44,16.2,43.1,14.8,43.1z
		M25.2,53.8h-3c-0.6,0-1.1-0.5-1.1-1.1v-9.8c0-0.6,0.5-1.1,1.1-1.1h3c3.7,0,6.2,2.6,6.2,6C31.4,51.2,29,53.8,25.2,53.8z
		M25.2,43.1h-2.6v9.3h2.6c2.9,0,4.6-2.1,4.6-4.7C29.9,45.2,28.2,43.1,25.2,43.1z M41.5,43.1h-5.8V47h5.7c0.4,0,0.6,0.3,0.6,0.7
		s-0.3,0.6-0.6,0.6h-5.7v4.8c0,0.4-0.3,0.7-0.8,0.7c-0.4,0-0.7-0.3-0.7-0.7V42.9c0-0.6,0.5-1.1,1.1-1.1h6.2c0.4,0,0.6,0.3,0.6,0.7
		C42.2,42.8,41.9,43.1,41.5,43.1z" />
	</svg>
);

export const PDFIcons = ({ width = 22, height = 22 }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} id="Layer_1" viewBox="0 0 512 512" data-name="Layer 1"><path d="m159.37 332.93h262.12a7.005 7.005 0 0 1 0 14.01h-262.12a7.005 7.005 0 1 1 0-14.01zm262.12 52.5h-262.12a7.005 7.005 0 1 0 0 14.01h262.12a7.005 7.005 0 0 0 0-14.01zm-308.1-196.555h-21.348v19.842h21.345a9.921 9.921 0 1 0 0-19.842zm308.1 249.055h-262.12a7 7 0 1 0 0 14h262.12a7 7 0 0 0 0-14zm-231.538-210.985v-22.445a15.652 15.652 0 0 0 -15.647-15.62h-15.648v53.717h15.648a15.665 15.665 0 0 0 15.647-15.652zm290.868-76.625v318.73a43.015 43.015 0 0 1 -42.98 42.95h-294.83a43.006 43.006 0 0 1 -42.97-42.95v-180.9h-53.92a14.961 14.961 0 0 1 -14.94-14.94v-114.95a14.954 14.954 0 0 1 14.94-14.94h53.92v-100.35a43.017 43.017 0 0 1 42.97-42.97h187.49a7.036 7.036 0 0 1 4.95 2.05l143.32 143.32a7.036 7.036 0 0 1 2.05 4.95zm-367.433 72.4a23.925 23.925 0 1 0 0-47.85h-28.347a7 7 0 0 0 -7 7v67.721a7 7 0 1 0 14 0v-26.87zm353.433-65.39h-116.34a27.024 27.024 0 0 1 -26.99-26.99v-116.34h-180.48a29.008 29.008 0 0 0 -28.97 28.97v100.35h188.45a14.954 14.954 0 0 1 14.94 14.94v114.95a14.961 14.961 0 0 1 -14.94 14.94h-188.45v180.9a29 29 0 0 0 28.97 28.95h294.83a29 29 0 0 0 28.98-28.95zm-315.165 99.27h22.65a29.685 29.685 0 0 0 29.65-29.651v-22.449a29.67 29.67 0 0 0 -29.65-29.624h-22.65a7 7 0 0 0 -7 7v67.721a7 7 0 0 0 7 7.003zm73.645-47.883v-19.842h38.268a7 7 0 1 0 0-14h-45.268a7 7 0 0 0 -7 7v67.721a7 7 0 1 0 14 0v-26.875h31.55a7 7 0 0 0 0-14z" fill="#f94852" /></svg>
);



export const PDFViewIcon = () => (
	<svg viewBox="0 0 1024 1024" fill="#000000" width="25" height="25"	>
		<path d="M917.251764 802.39026L786.571232 671.643176c-2.964148-2.993841-10.321788 0.260067-18.916281 6.447406l-10.6781-10.6781c54.596637-70.942966 51.407234-171.245844-8.531013-239.190875v-36.821988l0.130034 0.456653c0-70.649111-67.455613-136.867871-103.689891-172.419217l-8.270946-8.204393C529.76441 104.382037 485.22847 95.460924 448.830371 95.460924l-12.371606-0.063481H150.778377c-16.995473 0-47.336266 12.89174-47.336267 38.675221v756.025661c0 21.3562 17.31902 38.741773 38.675221 38.741773h567.587758c21.3562 0 38.741773-17.385573 38.741773-38.741773V753.360488c37.278641 37.308333 108.900443 108.934231 108.900443 108.934231 12.958293 12.89174 72.926232-46.882685 59.904459-59.904459z" fill="#27323A" />
		<path d="M707.231382 652.173997c-54.856704 54.890492-144.259299 54.957045-199.149791 0-54.887421-54.953973-54.887421-144.352473 0-199.242965 26.566753-26.566753 61.924584-41.151999 99.559537-41.151999 37.698434 0 73.022477 14.585246 99.58923 41.151999 54.891516 54.953973 54.891516 144.288992 0.001024 199.242965z" fill="#FFFFFF" />
		<path d="M603.214872 244.570368l8.657974 8.527941c15.171933 14.848385 36.464652 35.944518 54.53418 59.447806-35.521654-13.28184-75.11018-15.8221-110.333882-17.252468-1.10682-23.442878-5.600653-71.299278-21.486234-112.841378 18.683859 14.651799 41.14688 34.57456 68.627962 62.118099z" fill="#79CCBF" />
		<path d="M150.648343 881.633865V142.800262c0.130033-0.066553 0.650167-0.263139 0.650168-0.263138h285.03022l12.371607 0.066552c6.25082 0 14.518694 0.130033 26.436719 4.100661l5.990753 6.25082c32.36092 31.970819 44.015806 111.604524 44.015806 157.377318 0 8.400979 6.64092 15.368519 15.10538 15.692066l6.510887 0.263139c48.899739 1.887021 109.844465 4.230694 146.863039 37.764986l3.383941 3.383941c2.377462 7.487673 3.940935 14.911866 4.201002 22.269506-72.045691-41.412066-165.287856-32.100853-226.853057 29.497112-73.642952 73.642952-73.642952 193.058697 0 266.70165 61.597965 61.594893 154.84013 70.972659 226.886845 29.49404v166.23495H150.648343z" fill="#F4CE73" />
	</svg>
);

export const DownLoadedPDFIcon = () => (
	<svg
		height="25px"
		width="25px"
		viewBox="0 0 512 512"
		fill="#000000"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<g>
			<polygon
				style={{ fill: '#FFFFFF' }}
				points="73.312,508 73.312,4 328.72,4 438.688,113.968 438.688,508"
			/>
			<path
				style={{ fill: '#CCCCCC' }}
				d="M327.056,8l107.632,107.632V504H77.312V8H327.056 M330.4,0H69.312v512h373.376V112.32L330.4,0z"
			/>
			<polygon
				style={{ fill: '#222020' }}
				points="442.688,112.32 330.368,0 330.368,112.32"
			/>
			<path
				style={{ fill: '#E21B1B' }}
				d="M256,157.472c-72.088,0-130.528,58.44-130.528,130.528S183.912,418.528,256,418.528
		  S386.528,360.088,386.528,288S328.088,157.472,256,157.472L256,157.472z"
			/>
			<polygon
				style={{ fill: '#FFFFFF' }}
				points="301.392,227.76 236.064,308.336 208.6,281.232 190.496,301.176 238.184,348.24 321.504,245.48"
			/>
		</g>
	</svg>
);


export const CartIcon = () => (
	<svg
		height="24px"
		width="24px"
		version="1.1"
		id="_x32_"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 512.00 512.00"
		xmlSpace="preserve"
		fill=""
		stroke=""
		transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)"
		strokeWidth="0.00512"
	>
		<g id="SVGRepo_bgCarrier" strokeWidth="0" />
		<g
			id="SVGRepo_tracerCarrier"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<g id="SVGRepo_iconCarrier">
			<style
				type="text/css"
			>
				{'.st0{fill:white;}'}
			</style>
			<g>
				<path
					className="st0"
					d="M491.615,95.734c-5.06-6.18-12.634-9.772-20.622-9.772H123.664l-11.835-40.657v0.008 c-5.433-18.176-20.341-31.947-38.883-35.92L30.48,0.3C23.297-1.245,16.217,3.339,14.671,10.53 c-1.536,7.19,3.04,14.271,10.24,15.807l42.449,9.102c9.032,1.935,16.3,8.642,18.949,17.506l77.597,266.547 c-1.748,0.815-3.438,1.698-5.068,2.674c-8.362,4.984-15.07,11.98-19.568,20.147c-4.305,7.76-6.589,16.555-6.809,25.631h-0.034 v1.383h0.034c0.17,7.09,1.681,13.89,4.304,20.096c4.202,9.925,11.181,18.321,19.976,24.264c8.788,5.951,19.476,9.44,30.853,9.432 h249.568c7.361,0,13.32-5.96,13.32-13.312c0-7.352-5.96-13.312-13.32-13.312l-249.568-0.008c-3.974,0-7.692-0.798-11.105-2.233 c-5.102-2.156-9.492-5.79-12.565-10.358c-2.954-4.39-4.703-9.56-4.839-15.23c0.152-6.767,2.309-12.642,6.095-17.337 c1.961-2.42,4.38-4.542,7.318-6.3c2.904-1.732,6.326-3.107,10.341-3.973l250.841-40.828c16.386-2.674,29.426-15.205,32.737-31.481 l30.682-150.839v-0.016c0.356-1.749,0.527-3.532,0.527-5.298C497.626,106.499,495.536,100.54,491.615,95.734z M440.319,263.442 c-1.104,5.434-5.451,9.611-10.918,10.494l-239.669,39.02l-58.325-200.361h339.586h0.009L440.319,263.442z"
				/>
				<path
					className="st0"
					d="M218.411,444.786c-5.85-3.957-12.972-6.291-20.546-6.282c-5.052,0-9.916,1.026-14.314,2.895 c-6.605,2.793-12.191,7.436-16.156,13.303c-3.964,5.85-6.291,12.973-6.274,20.546c-0.008,5.043,1.019,9.908,2.887,14.306 c2.801,6.614,7.436,12.2,13.295,16.156c5.858,3.974,12.989,6.292,20.562,6.292c5.043,0,9.9-1.028,14.297-2.895 c6.614-2.793,12.2-7.446,16.165-13.304c3.956-5.85,6.282-12.981,6.282-20.554c0-5.042-1.036-9.898-2.895-14.305 C228.913,454.328,224.269,448.742,218.411,444.786z M211.517,481.012c-1.12,2.649-3.014,4.933-5.382,6.529 c-2.378,1.596-5.162,2.521-8.27,2.53c-2.08-0.009-4.007-0.416-5.765-1.172c-2.64-1.103-4.933-3.005-6.529-5.365 c-1.596-2.386-2.521-5.179-2.53-8.287c0.009-2.072,0.424-3.99,1.163-5.764c1.112-2.64,3.014-4.924,5.382-6.528 c2.378-1.596,5.171-2.514,8.278-2.522c2.072,0,3.99,0.417,5.756,1.163c2.649,1.112,4.924,3.006,6.52,5.383 c1.605,2.377,2.53,5.162,2.53,8.268C212.672,477.327,212.256,479.246,211.517,481.012z"
				/>
				<path
					className="st0"
					d="M419.943,444.786c-5.858-3.957-12.98-6.291-20.553-6.282c-5.043,0-9.908,1.026-14.306,2.895 c-6.613,2.793-12.2,7.436-16.164,13.303c-3.956,5.85-6.282,12.973-6.282,20.546c0,5.043,1.036,9.908,2.895,14.306 c2.793,6.614,7.446,12.2,13.304,16.165c5.85,3.965,12.981,6.283,20.554,6.283c5.042,0,9.907-1.028,14.305-2.895 c6.605-2.793,12.191-7.446,16.156-13.304c3.964-5.85,6.29-12.981,6.282-20.554c0-5.042-1.027-9.898-2.895-14.305 C430.436,454.328,425.801,448.742,419.943,444.786z M413.041,481.012c-1.113,2.649-3.014,4.933-5.374,6.529 c-2.377,1.596-5.179,2.521-8.277,2.53c-2.08-0.009-3.999-0.416-5.765-1.172c-2.649-1.103-4.924-3.005-6.52-5.365 c-1.613-2.386-2.53-5.179-2.53-8.287c0-2.072,0.408-3.99,1.155-5.764c1.12-2.64,3.013-4.924,5.382-6.528 c2.377-1.596,5.17-2.514,8.278-2.522c2.08,0,3.998,0.417,5.764,1.163c2.641,1.112,4.925,3.006,6.52,5.383 c1.596,2.377,2.522,5.162,2.531,8.268C414.204,477.327,413.788,479.246,413.041,481.012z"
				/>
				<path
					className="st0"
					d="M209.718,142.021c-2.173-7.48-10.001-11.768-17.481-9.586c-7.479,2.182-11.758,10.01-9.584,17.481 l36.523,125.055c2.19,7.471,10.018,11.767,17.489,9.577c7.471-2.174,11.767-10.01,9.577-17.489L209.718,142.021z"
				/>
				<path
					className="st0"
					d="M271.388,141.783c-2.173-7.479-10.001-11.767-17.48-9.593c-7.48,2.19-11.767,10.018-9.585,17.489 l33.874,115.988c2.19,7.48,10.018,11.767,17.489,9.585c7.471-2.182,11.767-10.009,9.577-17.489L271.388,141.783z"
				/>
				<path
					className="st0"
					d="M333.066,141.546c-2.182-7.48-10.01-11.768-17.48-9.577c-7.48,2.174-11.767,10.01-9.585,17.48l31.302,107.193 c2.182,7.48,10.018,11.767,17.489,9.586c7.471-2.182,11.767-10.019,9.576-17.49L333.066,141.546z"
				/>
				<path
					className="st0"
					d="M394.728,141.298c-2.173-7.479-10.009-11.758-17.489-9.584c-7.471,2.191-11.758,10.018-9.577,17.489 l28.56,97.812c2.191,7.48,10.018,11.767,17.489,9.585c7.471-2.19,11.767-10.009,9.585-17.489L394.728,141.298z"
				/>
			</g>
		</g>
	</svg>
);

export const RemoveCartIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
		<path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
	</svg>
);

export const MuteRxIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" clipRule="evenodd" fillRule="evenodd" height="512" className="w-4 h-4" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 1.70666 1.70666" width="512"><g id="Layer_x0020_1" fillRule="nonzero"><path d="m1.44605.0799961h-1.00373v.101701h.523114c.0112165 0 .0213543.00461811.0286181.0120591l.338575.338575.00000394-.00000394c.00781102.00780709.0117126.0180472.0117126.0282835h.00000394v.88435h.101701v-1.36496zm-1.04373-.08h1.08373c.0220906 0 .04.0179094.04.04v1.44496c0 .0220906-.0179094.04-.04.04h-.181701c-.0220906 0-.04-.0179094-.04-.04v-.907791l-.315472-.315472h-.546555c-.0220906 0-.04-.0179094-.04-.04v-.181701c0-.0220906.0179094-.04.04-.04z" /><path d="m.260618 1.62666h1.00373v-1.02605h-.298913c-.0220906 0-.04-.0179094-.04-.04v-.298913h-.664815v1.36496zm1.04373.08h-1.08373c-.0220906 0-.04-.0179094-.04-.04v-1.44496c0-.0220906.0179094-.04.04-.04h.744815c.0220906 0 .04.0179094.04.04v.298913h.298913c.0220906 0 .04.0179094.04.04v1.10605c0 .0220906-.0179094.04-.04.04z" /><path d="m1.20779.52061-.202354-.202354v.202354zm-.214075-.327193.338575.338575c.00744094.00726378.0120591.0174016.0120591.0286181 0 .0220906-.0179094.04-.04.04h-.338913c-.0220906 0-.04-.0179094-.04-.04v-.338913h.00000394c0-.0102362.00390551-.0204764.0117126-.0282835.0156181-.0156181.0409488-.0156181.0565669 0l-.00000394.00000394z" /><path d="m1.0149.869031c.0697047.0697047.104563.161067.104563.252421 0 .0913465-.0348583.182713-.104563.252417-.0697047.0697047-.161067.104563-.252421.104563-.0913465 0-.182713-.0348583-.252417-.104563-.0697047-.0697047-.104559-.161071-.104559-.252417 0-.0913543.0348543-.182717.104559-.252421.0697047-.0697047.161071-.104559.252417-.104559.0913543 0 .182717.0348543.252421.104559zm.024563.252421c0-.0708937-.0270433-.141783-.081122-.195862-.0540787-.0540787-.124969-.0811181-.195862-.0811181-.0708898 0-.14178.0270394-.195858.0811181-.0540787.0540787-.0811181.124969-.0811181.195862 0 .0708898.0270394.14178.0811181.195858.0540787.0540787.124969.081122.195858.081122.0708937 0 .141783-.0270433.195862-.081122.0540787-.0540787.081122-.124969.081122-.195858z" /><path d="m1.0149.925591c.0156181-.0156181.0156181-.0409409 0-.0565591-.0156181-.0156181-.0409409-.0156181-.0565591 0l-.44828.44828c-.0156181.0156181-.0156181.0409409 0 .0565591.0156181.0156181.0409409.0156181.0565591 0z" /></g></svg>
);

export const ExcelIcon = ({ width = 18, height = 18, color = "#22a06b" }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14 2V8H20"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8 13L11 16L16 11"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8 17L11 14L16 19"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const ZipIcon = ({ width = 18, height = 18, color = "#000000" }) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M14 2V8H20"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8 12L10 14L8 16"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12 12L14 14L12 16"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M16 12L18 14L16 16"
			stroke={color}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);



export const HeaderChangeLogIcon = ({ className = "", size = 28 }) => (
	<svg
	  className={`header-icon ${className}`}
	  width={size}
	  height={size}
	  viewBox="0 0 24 24"
	  xmlns="http://www.w3.org/2000/svg"
	  aria-hidden="true"
	>
	  <path d="M7 3.5H15.5C16.6046 3.5 17.5 4.39543 17.5 5.5V13.2C16.757 12.745 15.94 12.44 15.08 12.31V5.9H7V18.1H11.9C12.14 18.82 12.53 19.48 13.04 20H7C5.89543 20 5 19.1046 5 18V5.5C5 4.39543 5.89543 3.5 7 3.5Z" fill="white"/>
	  <path d="M8.5 8H14.5V9.6H8.5V8Z" fill="white"/>
	  <path d="M8.5 11H13.5V12.6H8.5V11Z" fill="white"/>
	  <path d="M8.5 14H11.5V15.6H8.5V14Z" fill="white"/>
  
	  <path d="M16.5 22C13.4624 22 11 19.5376 11 16.5C11 13.4624 13.4624 11 16.5 11C19.5376 11 22 13.4624 22 16.5C22 19.5376 19.5376 22 16.5 22Z" fill="white"/>
	  <path d="M16.5 13.4C16.9418 13.4 17.3 13.7582 17.3 14.2V16.2H18.7C19.1418 16.2 19.5 16.5582 19.5 17C19.5 17.4418 19.1418 17.8 18.7 17.8H16.5C16.0582 17.8 15.7 17.4418 15.7 17V14.2C15.7 13.7582 16.0582 13.4 16.5 13.4Z" fill="black"/>
	</svg>
  );
  
export const CalendarIcon = ({ width = 24, height = 24, className = "h-4 w-4 text-blue-600" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
	>
		<path d="M8 2v4"></path>
		<path d="M16 2v4"></path>
		<rect width="18" height="18" x="3" y="4" rx="2"></rect>
		<path d="M3 10h18"></path>
	</svg>
);

export const FileTextIcon = ({ width = 24, height = 24, className = "h-4 w-4" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
	>
		<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
		<path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
		<path d="M10 9H8"></path>
		<path d="M16 13H8"></path>
		<path d="M16 17H8"></path>
	</svg>
);

export const EyeIcons = ({ width = 24, height = 24, className = "h-4 w-4 mr-2" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
	>
		<path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
		<circle cx="12" cy="12" r="3"></circle>
	</svg>
);

export const ArchiveIcon = ({ width = 24, height = 24, className = "h-3.5 w-3.5 mr-1.5" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
	>
		<rect width="20" height="5" x="2" y="3" rx="1"></rect>
		<path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8"></path>
		<path d="M10 12h4"></path>
	</svg>
);

export const FileSpreadsheetIcon = ({ width = 24, height = 24, className = "h-3.5 w-3.5 mr-1.5" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
	>
		<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
		<path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
		<path d="M8 13h2"></path>
		<path d="M14 13h2"></path>
		<path d="M8 17h2"></path>
		<path d="M14 17h2"></path>
	</svg>
);
export const PrevIcons = ({ width = 24, height = 24, className = "" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" height={height} className={className} fill="#6b7280" viewBox="0 0 24 24" width={width} data-name="Layer 2"><path d="m21 11h-15.586l5.293-5.293a1 1 0 1 0 -1.414-1.414l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414l-5.293-5.293h15.586a1 1 0 0 0 0-2z" /></svg>
	)
}

export const NextIcons = ({ width = 24, height = 24, className = "" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" height={height} className={className} fill="#6b7280" viewBox="0 0 24 24" width={width} data-name="Layer 2"><path d="m22.707 11.293-7-7a1 1 0 0 0 -1.414 1.414l5.293 5.293h-17.586a1 1 0 0 0 0 2h17.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z" /></svg>
	)
}


export const EditsIcon = ({ width = 24, height = 24, className = "", fill = "", onClick = () => { } }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill={fill} onClick={onClick} id="Line" viewBox="0 0 24 24" width={width} height={height} className={className}><path d="m4.76 18.81s.08 0 .11 0l2.93-.27c.41-.04.79-.22 1.08-.51l11.06-11.06c.52-.52.81-1.21.81-1.94s-.29-1.42-.81-1.94l-.71-.71c-1.04-1.04-2.85-1.04-3.89 0l-1.41 1.41s0 0 0 0l-9.64 9.64c-.29.29-.47.67-.5 1.08l-.27 2.93c-.03.37.1.73.36 1 .24.24.55.37.88.37zm12.53-15.74c.32 0 .64.12.88.37l.71.71c.24.24.37.55.37.88s-.13.65-.37.88l-.88.88-2.47-2.47.88-.88c.24-.24.56-.37.88-.37zm-12.01 11.58c0-.06.03-.11.07-.15l9.11-9.12 2.47 2.47-9.11 9.11s-.1.07-.15.07l-2.63.24.24-2.63zm17.47 7.35c0 .41-.34.75-.75.75h-20c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h20c.41 0 .75.34.75.75z" /></svg>)
}

export const BellIcons = ({ width = 24, height = 24, className = "" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} id="magicoon-Filled" fill="#000000b5" viewBox="0 0 512 512" ><g id="bell-slash-Filled"><path id="bell-slash-Filled-2" d="m213.333 426.667h85.334c0 21.333-15.291 42.666-42.667 42.666s-42.667-21.333-42.667-42.666zm-116.906-85.75a10.686 10.686 0 0 0 7.542-3.125l238.937-238.938a10.671 10.671 0 0 0 -.958-15.937 137.986 137.986 0 0 0 -85.948-29.584c-76.458 0-138.667 62.105-138.667 138.459v56.1a95.639 95.639 0 0 1 -13.633 49.379l-16.429 27.521a10.661 10.661 0 0 0 9.156 16.125zm345.323-270.667a21.327 21.327 0 0 0 -30.167 0l-341.333 341.333a21.331 21.331 0 1 0 30.167 30.167l47.083-47.083h251.438a38.362 38.362 0 0 0 32.833-58.167l-23.49-39.271a95.615 95.615 0 0 1 -13.614-49.329v-56.1a137.24 137.24 0 0 0 -5.667-38.639l52.746-52.744a21.327 21.327 0 0 0 .004-30.167z" data-name="bell-slash-Filled" /></g></svg>
	)
}



export const FaxIcon = ({ width = 16, height = 16, className = "w-4 h-4", currentColor = "#000" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" id="fax" viewBox="0 0 512 512" width={width} height={height} className={className} fill={currentColor} ><path d="M458.36,414.59H401.6992a10,10,0,0,1,0-20H458.36a18.93,18.93,0,0,0,18.9082-18.9082V202.23A18.93,18.93,0,0,0,458.36,183.3218H53.64A18.93,18.93,0,0,0,34.7314,202.23V375.6816A18.93,18.93,0,0,0,53.64,394.59h56.6607a10,10,0,1,1,0,20H53.64a38.9526,38.9526,0,0,1-38.9087-38.9082V202.23A38.9526,38.9526,0,0,1,53.64,163.3218H458.36A38.9522,38.9522,0,0,1,497.2686,202.23V375.6816A38.9522,38.9522,0,0,1,458.36,414.59Z" /><path d="M110.3008,183.3218a10,10,0,0,1-10-10V88.9087A38.9527,38.9527,0,0,1,139.21,50H338.1006a10,10,0,0,1,0,20H139.21a18.93,18.93,0,0,0-18.9087,18.9087v84.4131A10,10,0,0,1,110.3008,183.3218Z" /><path d="M401.6992,183.3218a10,10,0,0,1-10-10V123.5986a10,10,0,0,1,20,0v49.7232A10,10,0,0,1,401.6992,183.3218Z" /><path d="M372.791,462H139.21a38.9523,38.9523,0,0,1-38.9087-38.9082V312.083a10,10,0,0,1,20,0V423.0918A18.93,18.93,0,0,0,139.21,442H372.791a18.93,18.93,0,0,0,18.9082-18.9082V312.083a10,10,0,0,1,20,0V423.0918A38.9522,38.9522,0,0,1,372.791,462Z" /><path d="M401.6992,133.5986H361.2275a33.1638,33.1638,0,0,1-33.1269-33.1264V60a10,10,0,0,1,20,0v40.4722a13.1416,13.1416,0,0,0,13.1269,13.1264h40.4717a10,10,0,0,1,0,20Z" /><path d="M401.6992,133.5986a9.969,9.969,0,0,1-7.0713-2.9287L331.0293,67.0713a10,10,0,0,1,14.1426-14.1426l63.5986,63.5986a10,10,0,0,1-7.0713,17.0713Z" /><path d="M428.2949,322.083H83.7051a10,10,0,0,1,0-20h344.59a10,10,0,0,1,0,20Z" /><path d="M352.1758,370.07H159.8242a10,10,0,0,1,0-20H352.1758a10,10,0,0,1,0,20Z" /><path d="M352.1758,414.0117H159.8242a10,10,0,0,1,0-20H352.1758a10,10,0,0,1,0,20Z" /><path d="M422.5137,266.5781a28.5015,28.5015,0,1,1,28.5009-28.5014A28.5341,28.5341,0,0,1,422.5137,266.5781Zm0-37.0029a8.5015,8.5015,0,1,0,8.5009,8.5015A8.5112,8.5112,0,0,0,422.5137,229.5752Z" /></svg>
);

export const IconEdit = ({ width = 24, height = 24, className = "" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} id="Glyph" viewBox="0 0 24 24"><path d="m20 8.6-8.38 8.38c-.29.29-.67.47-1.08.51l-2.93.27s-.08 0-.11 0c-.33 0-.65-.13-.88-.37-.26-.26-.39-.63-.36-1l.27-2.93c.04-.41.22-.79.51-1.08l8.36-8.38zm1.94-5.83-.71-.71c-1.07-1.07-2.82-1.07-3.89 0l-.88.88 4.6 4.6.88-.88c.52-.52.81-1.21.81-1.94s-.29-1.43-.81-1.94zm-1.19 16.24v-5.81c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5.81c0 1.24-1.01 2.25-2.25 2.25h-12c-1.24 0-2.25-1.01-2.25-2.25v-12.01c0-1.24 1.01-2.25 2.25-2.25h5.81c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-5.81c-2.07 0-3.75 1.68-3.75 3.75v12c0 2.07 1.68 3.75 3.75 3.75h12c2.07 0 3.75-1.68 3.75-3.75z" /></svg>)


export const InvestUnmuteIcon = ({ width = 24, height = 24, className = "" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		className={className}
		viewBox="0 0 512 512"
	>
		<defs>
			<style>
				{`
			.st0 {
			  fill: #f7d360;
			}
			.st1 {
			  fill: #e58e13;
			}
		  `}
			</style>
		</defs>
		<path className="st0" d="M446.5,356.5H64.6c17.5,0,27.4-9.2,33-24.3C124.8,258.9,52.4,45.3,255.5,45.3s130.8,213.6,157.9,286.9c5.6,15.2,15.5,24.3,33,24.3Z" />
		<path className="st1" d="M483.5,393.5c0,20.4-16.6,37-37,37H64.6c-10.2,0-19.5-4.1-26.1-10.8s-10.8-15.9-10.8-26.1c0-20.4,16.6-37,37-37h381.9c10.2,0,19.5,4.1,26.1,10.8s10.8,15.9,10.8,26.1Z" />
		<path className="st1" d="M413.5,332.2h-198.5c-21.4,0-38.5-17.7-37.8-39.1,2.8-90.5-11.6-246,76.9-247.7-243.1,1.3-87.7,311.2-189.5,311.2h381.9c-17.5,0-27.4-9.2-33-24.3Z" />
		<path className="st0" d="M483.5,393.5c0,20.4-16.6,37-37,37H171.4c-10.2,0-19.5-4.1-26.1-10.8s-10.8-15.9-10.8-26.1c0-20.4,16.6-37,37-37h275.1c10.2,0,19.5,4.1,26.1,10.8s10.8,15.9,10.8,26.1Z" />
		<path className="st1" d="M329.5,430.4c0,34-22.9,62.6-54.2,71.3-6.3,1.7-12.9,2.7-19.8,2.7-40.9,0-74-33.1-74-74h147.9Z" />
		<path className="st0" d="M325.9,453.2c-7.6,23.5-26.7,41.9-50.6,48.5-15-4.2-28.2-13-37.7-24.7-7.7-9.5-.8-23.7,11.5-23.7h76.8Z" />
		<path className="st1" d="M293.1,48.1c0-.9.1-1.9.1-2.8,0-20.8-16.9-37.7-37.7-37.7s-37.7,16.9-37.7,37.7,0,1.9.1,2.8" />
		<path d="M446.5,348.9h0c-14.7,0-23-7.6-27.8-25.5-4.9-18.3-5-44.8-5.2-72.9-.2-34-.4-72.6-8.9-107.1-1-4.1-5.1-6.6-9.2-5.6-4.1,1-6.6,5.1-5.6,9.2,8,32.8,8.3,70.4,8.5,103.5.2,29.1.3,56.5,5.7,76.7,2.3,8.8,5.7,16,10,21.6H97.1c4.3-5.6,7.7-12.9,10-21.6,5.4-20.2,5.5-47.6,5.7-76.7.3-44.4.6-94.7,18.7-133.2,20.4-43.3,61-64.4,124-64.4s62.9,6.5,84.1,19.3c18.4,11.1,31.9,26.9,41.3,48.3,1.7,3.8,6.2,5.6,10,3.9,3.8-1.7,5.6-6.2,3.9-10-10.6-24-26.5-42.6-47.4-55.2-13.3-8.1-29-13.9-46.8-17.4C298.9,18.5,279.3,0,255.5,0s-43.4,18.5-45.1,41.8c-17,3.4-32.1,8.8-45,16.3-20.8,12-36.8,29.8-47.6,52.7-19.6,41.5-19.9,93.6-20.2,139.6-.2,28.1-.3,54.6-5.2,72.9-4.8,17.9-13.1,25.5-27.8,25.5h0c-24.6,0-44.6,20-44.6,44.6s20,44.6,44.6,44.6h48.1c4.2,0,7.6-3.4,7.6-7.6s-3.4-7.6-7.6-7.6h-48.1c-16.2,0-29.4-13.2-29.4-29.4s13.2-29.4,29.4-29.4h381.9c16.2,0,29.4,13.2,29.4,29.4s-13.2,29.4-29.4,29.4H143.1c-4.2,0-7.6,3.4-7.6,7.6s3.4,7.6,7.6,7.6h31.2c3.8,41.4,38.8,74,81.2,74s77.3-32.5,81.2-74h109.8c24.6,0,44.6-20,44.6-44.6s-20-44.6-44.6-44.6ZM255.5,15.2c14.6,0,26.7,10.4,29.5,24.2-9.3-1.1-19.2-1.7-29.5-1.7s-20.2.6-29.5,1.7c2.8-13.8,14.9-24.2,29.5-24.2ZM255.5,496.8c-34,0-62.1-25.7-65.9-58.8h131.8c-3.8,33-31.9,58.8-65.9,58.8Z" />
	</svg>
)



export const InvestMuteIcon = ({ width = 24, height = 24, className = "" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		className={className}
		viewBox="0 0 512 512"
	>
		<defs>
			<style>
				{`
			.st0 {
			  fill: #f7d360;
			}
			.st1 {
			  fill: #e58e13;
			}
			.st2 {
			  fill: none;
			  stroke: red;
			  stroke-linecap: round;
			  stroke-miterlimit: 10;
			  stroke-width: 30px;
			}
		  `}
			</style>
		</defs>
		<path className="st0" d="M446.5,356.5H64.6c17.5,0,27.4-9.2,33-24.3C124.8,258.9,52.4,45.3,255.5,45.3s130.8,213.6,157.9,286.9c5.6,15.2,15.5,24.3,33,24.3Z" />
		<path className="st1" d="M483.5,393.5c0,20.4-16.6,37-37,37H64.6c-10.2,0-19.5-4.1-26.1-10.8s-10.8-15.9-10.8-26.1c0-20.4,16.6-37,37-37h381.9c10.2,0,19.5,4.1,26.1,10.8s10.8,15.9,10.8,26.1Z" />
		<path className="st1" d="M413.5,332.2h-198.5c-21.4,0-38.5-17.7-37.8-39.1,2.8-90.5-11.6-246,76.9-247.7-243.1,1.3-87.7,311.2-189.5,311.2h381.9c-17.5,0-27.4-9.2-33-24.3Z" />
		<path className="st0" d="M483.5,393.5c0,20.4-16.6,37-37,37H171.4c-10.2,0-19.5-4.1-26.1-10.8s-10.8-15.9-10.8-26.1c0-20.4,16.6-37,37-37h275.1c10.2,0,19.5,4.1,26.1,10.8s10.8,15.9,10.8,26.1Z" />
		<path className="st1" d="M329.5,430.4c0,34-22.9,62.6-54.2,71.3-6.3,1.7-12.9,2.7-19.8,2.7-40.9,0-74-33.1-74-74h147.9Z" />
		<path className="st0" d="M325.9,453.2c-7.6,23.5-26.7,41.9-50.6,48.5-15-4.2-28.2-13-37.7-24.7-7.7-9.5-.8-23.7,11.5-23.7h76.8Z" />
		<path className="st1" d="M293.1,48.1c0-.9.1-1.9.1-2.8,0-20.8-16.9-37.7-37.7-37.7s-37.7,16.9-37.7,37.7,0,1.9.1,2.8" />
		<path d="M446.5,348.9h0c-14.7,0-23-7.6-27.8-25.5-4.9-18.3-5-44.8-5.2-72.9-.2-34-.4-72.6-8.9-107.1-1-4.1-5.1-6.6-9.2-5.6-4.1,1-6.6,5.1-5.6,9.2,8,32.8,8.3,70.4,8.5,103.5.2,29.1.3,56.5,5.7,76.7,2.3,8.8,5.7,16,10,21.6H97.1c4.3-5.6,7.7-12.9,10-21.6,5.4-20.2,5.5-47.6,5.7-76.7.3-44.4.6-94.7,18.7-133.2,20.4-43.3,61-64.4,124-64.4s62.9,6.5,84.1,19.3c18.4,11.1,31.9,26.9,41.3,48.3,1.7,3.8,6.2,5.6,10,3.9,3.8-1.7,5.6-6.2,3.9-10-10.6-24-26.5-42.6-47.4-55.2-13.3-8.1-29-13.9-46.8-17.4C298.9,18.5,279.3,0,255.5,0s-43.4,18.5-45.1,41.8c-17,3.4-32.1,8.8-45,16.3-20.8,12-36.8,29.8-47.6,52.7-19.6,41.5-19.9,93.6-20.2,139.6-.2,28.1-.3,54.6-5.2,72.9-4.8,17.9-13.1,25.5-27.8,25.5h0c-24.6,0-44.6,20-44.6,44.6s20,44.6,44.6,44.6h48.1c4.2,0,7.6-3.4,7.6-7.6s-3.4-7.6-7.6-7.6h-48.1c-16.2,0-29.4-13.2-29.4-29.4s13.2-29.4,29.4-29.4h381.9c16.2,0,29.4,13.2,29.4,29.4s-13.2,29.4-29.4,29.4H143.1c-4.2,0-7.6,3.4-7.6,7.6s3.4,7.6,7.6,7.6h31.2c3.8,41.4,38.8,74,81.2,74s77.3-32.5,81.2-74h109.8c24.6,0,44.6-20,44.6-44.6s-20-44.6-44.6-44.6ZM255.5,15.2c14.6,0,26.7,10.4,29.5,24.2-9.3-1.1-19.2-1.7-29.5-1.7s-20.2.6-29.5,1.7c2.8-13.8,14.9-24.2,29.5-24.2ZM255.5,496.8c-34,0-62.1-25.7-65.9-58.8h131.8c-3.8,33-31.9,58.8-65.9,58.8Z" />
		<line className="st2" x1="37.5" y1="474.5" x2="474.5" y2="37.5" />
	</svg>
)

export const FaxStatusIcon = ({ width = 24, height = 24, className = "", currentColor = "" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" clipRule="evenodd" fillRule="evenodd" className={className} imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 2833 2833" width={width} height={height} ><g id="Layer_x0020_1"><circle cx="1417" cy="1417" fill={currentColor} r="1417" /><path d="m2107 2067h-798c3-13 4-27 4-40v-987c0-14-1-27-4-40h798c88 0 163 75 163 163v740c0 89-75 164-163 164zm-994 116h-170c-85 0-156-71-156-156v-987c0-85 71-157 156-157h170c89 0 160 71 160 157v987c0 86-71 156-160 156zm277-1223v-270c0-22 18-40 40-40h603c22 0 40 18 40 40v270zm527-78c26 0 26-40 0-40h-370c-27 0-27 40 0 40zm-40-114c26 0 26-40 0-40h-294c-26 0-26 40 0 40zm248 1169c24 0 43-19 43-44v-93c0-24-19-43-43-43h-90c-24 0-43 19-43 43v93c0 25 19 44 43 44zm-93-40v-100h96v100zm-194 40c25 0 44-19 44-44v-93c0-24-19-43-44-43h-93c-24 0-43 19-43 43v93c0 25 19 44 43 44zm-96-40v-100h100v100zm-190 40c24 0 43-19 43-44v-93c0-24-19-43-43-43h-94c-24 0-43 19-43 43v93c0 25 19 44 43 44zm-97-40v-100h100v100zm670-237c24 0 43-19 43-43v-94c0-24-19-43-43-43h-90c-24 0-43 19-43 43v94c0 24 19 43 43 43zm-93-40v-100h96v100zm-194 40c25 0 44-19 44-43v-94c0-24-19-43-44-43h-93c-24 0-43 19-43 43v94c0 24 19 43 43 43zm-96-40v-100h100v100zm-190 40c24 0 43-19 43-43v-94c0-24-19-43-43-43h-94c-24 0-43 19-43 43v94c0 24 19 43 43 43zm-97-40v-100h100v100zm623-217c38 0 70-32 70-70v-133c0-38-32-70-70-70h-573c-38 0-70 32-70 70v133c0 38 32 70 70 70zm-573-233h573c16 0 30 14 30 30v133c0 16-14 30-30 30h-573c-16 0-30-14-30-30v-133c0-16 14-30 30-30zm-754 897h-24c-89 0-164-75-164-164v-740c0-88 75-163 164-163h24c-3 13-4 26-4 40v987c0 13 1 27 4 40z" fill="#fff" /></g></svg>
)


export const CameraIcon = ({ className = "w-12 h-12 text-gray-400 mb-3" }) => (
	<svg
		className={className}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"
		/>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"
		/>
	</svg>
)

export const GalleryIcon = ({ className = "w-5 h-5 text-blue-600" }) => (
	<svg
		className={className}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
		/>
	</svg>
)

export const CloseIcon = ({ className = "w-5 h-5" }) => (
	<svg
		className={className}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M6 18L18 6M6 6l12 12"
		/>
	</svg>
)

export const ArrowRightIcon = ({ className = "w-4 h-4 text-gray-400" }) => (
	<svg
		className={className}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M9 5l7 7-7 7"
		/>
	</svg>
)

export const UserAvatarIcon = ({ className = "w-5 h-5 text-blue-600" }) => (
	<svg
		className={className}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
		/>
	</svg>
)

export const LogoutIcon = ({ className = "w-4 h-4" }) => (
	<svg
		className={className}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
		/>
	</svg>
)

export const DeleteAvatarIcon = ({ className = "w-5 h-5" }) => (
	<svg
		className={className}
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		aria-hidden="true"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			d="M6 18L18 6M6 6l12 12"
		/>
	</svg>
)


export { default as assigned_icon } from './assigned.svg'
export { default as new_icon } from './new.svg'
export { default as completed_icon } from './completed.svg'
export { default as overdue_icon } from './overdue.svg'
export { default as user_icon } from './user.svg'

// Edit Pencil Icon (for edit buttons)
export const EditPencilIcon = ({ className = "w-4 h-4", color = "currentColor" }) => {
	return (
		<svg className={className} fill="none" stroke={color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
		</svg>
	)
}

// Chevron Right Icon (for navigation/arrows)
export const ChevronRightIcon = ({ className = "w-4 h-4", color = "currentColor" }) => {
	return (
		<svg className={className} fill="none" stroke={color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
		</svg>
	)
}

// Plus Add Icon (simple plus for add buttons)
export const PlusAddIcon = ({ className = "w-4 h-4", color = "currentColor" }) => {
	return (
		<svg className={className} fill="none" stroke={color} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
		</svg>
	)
}

// Card Type Icons
export const VisaIcon = ({ className = "w-10 h-6 flex-shrink-0" }) => (
	<svg className={className} viewBox="0 -9 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="0.5" y="0.5" width="57" height="39" rx="3.5" fill="white" stroke="#F3F3F3" />
		<path d="M25.7516 27.4332H21.8901L24.3054 13.4325H28.1667L25.7516 27.4332Z" fill="#15195A" />
		<path d="M39.7499 13.7748C38.9882 13.4915 37.7802 13.1787 36.2865 13.1787C32.4731 13.1787 29.7878 15.0851 29.7713 17.8106C29.7396 19.8215 31.6939 20.9384 33.1556 21.6089C34.6495 22.2941 35.1574 22.7413 35.1574 23.352C35.1422 24.29 33.9502 24.7223 32.8384 24.7223C31.2967 24.7223 30.4707 24.4994 29.2153 23.9776L28.7069 23.7539L28.1665 26.8967C29.0722 27.2835 30.7408 27.6268 32.4731 27.6419C36.5249 27.6419 39.1627 25.765 39.1939 22.8605C39.2093 21.2667 38.1774 20.0454 35.9526 19.0475C34.602 18.4069 33.7749 17.9749 33.7749 17.3195C33.7908 16.7236 34.4745 16.1133 35.9991 16.1133C37.2544 16.0834 38.1768 16.3663 38.8755 16.6494L39.2247 16.7981L39.7499 13.7748V13.7748V13.7748Z" fill="#15195A" />
		<path fillRule="evenodd" clipRule="evenodd" d="M46.6618 13.4325H49.6486L52.7639 27.433H49.1885C49.1885 27.433 48.8386 25.8244 48.7278 25.3328H43.7699C43.6266 25.705 42.9595 27.433 42.9595 27.433H38.9078L44.6435 14.5941C45.0409 13.6855 45.7407 13.4325 46.6618 13.4325ZM46.4238 18.556C46.4238 18.556 45.2001 21.6689 44.8821 22.4732H48.0918C47.933 21.7733 47.2017 18.4219 47.2017 18.4219L46.9319 17.2156C46.8182 17.5262 46.6539 17.9533 46.543 18.2414C46.4679 18.4366 46.4173 18.568 46.4238 18.556Z" fill="#15195A" />
		<path fillRule="evenodd" clipRule="evenodd" d="M5.1589 13.4325H11.3716C12.2138 13.462 12.8971 13.7152 13.1194 14.6094L14.4696 21.0422C14.4697 21.0426 14.4699 21.043 14.47 21.0434L14.8832 22.9796L18.6649 13.4325H22.7481L16.6785 27.4184H12.5951L9.15337 15.253C7.96587 14.6021 6.6106 14.0786 5.09534 13.7154L5.1589 13.4325Z" fill="#15195A" />
	</svg>
)

export const MastercardIcon = ({ className = "w-10 h-6 flex-shrink-0" }) => (
	<svg className={className} viewBox="0 -28.5 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid">
		<g>
			<path d="M46.5392504,198.011312 L46.5392504,184.839826 C46.5392504,179.790757 43.4659038,176.497885 38.1973096,176.497885 C35.5630125,176.497885 32.7091906,177.375984 30.7334678,180.229806 C29.1967945,177.815034 27.0015469,176.497885 23.7086756,176.497885 C21.513428,176.497885 19.3181804,177.15646 17.5619824,179.571233 L17.5619824,176.936935 L12.9519625,176.936935 L12.9519625,198.011312 L17.5619824,198.011312 L17.5619824,186.3765 C17.5619824,182.644579 19.5377052,180.888381 22.6110518,180.888381 C25.6843984,180.888381 27.2210717,182.864103 27.2210717,186.3765 L27.2210717,198.011312 L31.8310916,198.011312 L31.8310916,186.3765 C31.8310916,182.644579 34.0263392,180.888381 36.880161,180.888381 C39.9535076,180.888381 41.490181,182.864103 41.490181,186.3765 L41.490181,198.011312 L46.5392504,198.011312 L46.5392504,198.011312 Z M114.81145,176.936935 L107.347608,176.936935 L107.347608,170.570717 L102.737589,170.570717 L102.737589,176.936935 L98.566618,176.936935 L98.566618,181.107905 L102.737589,181.107905 L102.737589,190.766995 C102.737589,195.59654 104.713311,198.450362 109.981906,198.450362 C111.957628,198.450362 114.152876,197.791787 115.689549,196.913688 L114.372401,192.962243 C113.055252,193.840341 111.518579,194.059866 110.420955,194.059866 C108.225708,194.059866 107.347608,192.742718 107.347608,190.54747 L107.347608,181.107905 L114.81145,181.107905 L114.81145,176.936935 L114.81145,176.936935 Z M153.886857,176.497885 C151.25256,176.497885 149.496362,177.815034 148.398738,179.571233 L148.398738,176.936935 L143.788718,176.936935 L143.788718,198.011312 L148.398738,198.011312 L148.398738,186.156975 C148.398738,182.644579 149.935411,180.668856 152.789233,180.668856 C153.667332,180.668856 154.764956,180.888381 155.643055,181.107905 L156.960204,176.71741 C156.082105,176.497885 154.764956,176.497885 153.886857,176.497885 L153.886857,176.497885 L153.886857,176.497885 Z M94.834697,178.693133 C92.6394495,177.15646 89.566103,176.497885 86.2732315,176.497885 C81.0046375,176.497885 77.492241,179.132183 77.492241,183.303153 C77.492241,186.81555 80.1265385,188.791272 84.736558,189.449847 L86.931806,189.669371 C89.346578,190.10842 90.6637265,190.766995 90.6637265,191.864619 C90.6637265,193.401292 88.9075285,194.498916 85.834182,194.498916 C82.7608355,194.498916 80.346063,193.401292 78.8093895,192.303668 L76.614142,195.816065 C79.0289145,197.572262 82.321786,198.450362 85.614657,198.450362 C91.7613505,198.450362 95.2737465,195.59654 95.2737465,191.645094 C95.2737465,187.913173 92.4199245,185.937451 88.0294295,185.278876 L85.834182,185.059351 C83.858459,184.839826 82.321786,184.400777 82.321786,183.083629 C82.321786,181.546955 83.858459,180.668856 86.2732315,180.668856 C88.9075285,180.668856 91.5418255,181.76648 92.858974,182.425054 L94.834697,178.693133 L94.834697,178.693133 Z M217.329512,176.497885 C214.695215,176.497885 212.939017,177.815034 211.841393,179.571233 L211.841393,176.936935 L207.231373,176.936935 L207.231373,198.011312 L211.841393,198.011312 L211.841393,186.156975 C211.841393,182.644579 213.378066,180.668856 216.231888,180.668856 C217.109987,180.668856 218.207611,180.888381 219.08571,181.107905 L220.402859,176.71741 C219.52476,176.497885 218.207611,176.497885 217.329512,176.497885 L217.329512,176.497885 L217.329512,176.497885 Z M158.496877,187.474123 C158.496877,193.840341 162.887372,198.450362 169.69264,198.450362 C172.765986,198.450362 174.961234,197.791787 177.156481,196.035589 L174.961234,192.303668 C173.205036,193.620817 171.448838,194.279391 169.473115,194.279391 C165.741194,194.279391 163.106897,191.645094 163.106897,187.474123 C163.106897,183.522678 165.741194,180.888381 169.473115,180.668856 C171.448838,180.668856 173.205036,181.32743 174.961234,182.644579 L177.156481,178.912658 C174.961234,177.15646 172.765986,176.497885 169.69264,176.497885 C162.887372,176.497885 158.496877,181.107905 158.496877,187.474123 L158.496877,187.474123 L158.496877,187.474123 Z M201.08468,187.474123 L201.08468,176.936935 L196.47466,176.936935 L196.47466,179.571233 C194.937987,177.595509 192.742739,176.497885 189.888917,176.497885 C183.961749,176.497885 179.351729,181.107905 179.351729,187.474123 C179.351729,193.840341 183.961749,198.450362 189.888917,198.450362 C192.962264,198.450362 195.157512,197.352737 196.47466,195.377015 L196.47466,198.011312 L201.08468,198.011312 L201.08468,187.474123 Z M184.181274,187.474123 C184.181274,183.742202 186.596046,180.668856 190.547492,180.668856 C194.279413,180.668856 196.91371,183.522678 196.91371,187.474123 C196.91371,191.206044 194.279413,194.279391 190.547492,194.279391 C186.596046,194.059866 184.181274,191.206044 184.181274,187.474123 L184.181274,187.474123 Z M129.080559,176.497885 C122.933866,176.497885 118.543371,180.888381 118.543371,187.474123 C118.543371,194.059866 122.933866,198.450362 129.300084,198.450362 C132.373431,198.450362 135.446777,197.572262 137.861549,195.59654 L135.666302,192.303668 C133.910104,193.620817 131.714856,194.498916 129.519609,194.498916 C126.665787,194.498916 123.811965,193.181768 123.153391,189.449847 L138.739648,189.449847 L138.739648,187.693648 C138.959173,180.888381 135.007727,176.497885 129.080559,176.497885 L129.080559,176.497885 L129.080559,176.497885 Z M129.080559,180.449331 C131.934381,180.449331 133.910104,182.20553 134.349153,185.498401 L123.372916,185.498401 C123.811965,182.644579 125.787688,180.449331 129.080559,180.449331 L129.080559,180.449331 Z M243.452958,187.474123 L243.452958,168.594995 L238.842938,168.594995 L238.842938,179.571233 C237.306265,177.595509 235.111017,176.497885 232.257196,176.497885 C226.330027,176.497885 221.720007,181.107905 221.720007,187.474123 C221.720007,193.840341 226.330027,198.450362 232.257196,198.450362 C235.330542,198.450362 237.52579,197.352737 238.842938,195.377015 L238.842938,198.011312 L243.452958,198.011312 L243.452958,187.474123 Z M226.549552,187.474123 C226.549552,183.742202 228.964324,180.668856 232.91577,180.668856 C236.647691,180.668856 239.281988,183.522678 239.281988,187.474123 C239.281988,191.206044 236.647691,194.279391 232.91577,194.279391 C228.964324,194.059866 226.549552,191.206044 226.549552,187.474123 L226.549552,187.474123 Z M72.443172,187.474123 L72.443172,176.936935 L67.833152,176.936935 L67.833152,179.571233 C66.2964785,177.595509 64.101231,176.497885 61.247409,176.497885 C55.3202405,176.497885 50.7102205,181.107905 50.7102205,187.474123 C50.7102205,193.840341 55.3202405,198.450362 61.247409,198.450362 C64.3207555,198.450362 66.5160035,197.352737 67.833152,195.377015 L67.833152,198.011312 L72.443172,198.011312 L72.443172,187.474123 Z M55.3202405,187.474123 C55.3202405,183.742202 57.735013,180.668856 61.6864585,180.668856 C65.4183795,180.668856 68.0526765,183.522678 68.0526765,187.474123 C68.0526765,191.206044 65.4183795,194.279391 61.6864585,194.279391 C57.735013,194.059866 55.3202405,191.206044 55.3202405,187.474123 Z" fill="#000000"></path>
			<rect fill="#FF5F00" x="93.2980455" y="16.9034088" width="69.1502985" height="124.251009"></rect>
			<path d="M97.688519,79.0288935 C97.688519,53.783546 109.542856,31.3920209 127.763411,16.9033869 C114.3724,6.3661985 97.468994,-1.94737475e-05 79.0289145,-1.94737475e-05 C35.3434877,-1.94737475e-05 1.7258174e-06,35.3434665 1.7258174e-06,79.0288935 C1.7258174e-06,122.71432 35.3434877,158.057806 79.0289145,158.057806 C97.468994,158.057806 114.3724,151.691588 127.763411,141.1544 C109.542856,126.88529 97.688519,104.274241 97.688519,79.0288935 Z" fill="#EB001B"></path>
			<path d="M255.746345,79.0288935 C255.746345,122.71432 220.402859,158.057806 176.717432,158.057806 C158.277352,158.057806 141.373945,151.691588 127.982936,141.1544 C146.423015,126.665766 158.057827,104.274241 158.057827,79.0288935 C158.057827,53.783546 146.20349,31.3920209 127.982936,16.9033869 C141.373945,6.3661985 158.277352,-1.94737475e-05 176.717432,-1.94737475e-05 C220.402859,-1.94737475e-05 255.746345,35.5629913 255.746345,79.0288935 Z" fill="#F79E1B"></path>
		</g>
	</svg>
)

export const BankIcon = ({ className = "w-6 h-6 flex-shrink-0" }) => (
	<svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle fill="#231F20" cx="32" cy="14" r="3" />
		<path fill="#231F20" d="M4,25h56c1.794,0,3.368-1.194,3.852-2.922c0.484-1.728-0.242-3.566-1.775-4.497l-28-17C33.438,0.193,32.719,0,32,0s-1.438,0.193-2.076,0.581l-28,17c-1.533,0.931-2.26,2.77-1.775,4.497C0.632,23.806,2.206,25,4,25z M32,9c2.762,0,5,2.238,5,5s-2.238,5-5,5s-5-2.238-5-5S29.238,9,32,9z" />
		<rect x="34" y="27" fill="#231F20" width="8" height="25" />
		<rect x="46" y="27" fill="#231F20" width="8" height="25" />
		<rect x="22" y="27" fill="#231F20" width="8" height="25" />
		<rect x="10" y="27" fill="#231F20" width="8" height="25" />
		<path fill="#231F20" d="M4,58h56c0-2.209-1.791-4-4-4H8C5.791,54,4,55.791,4,58z" />
		<path fill="#231F20" d="M63.445,60H0.555C0.211,60.591,0,61.268,0,62v2h64v-2C64,61.268,63.789,60.591,63.445,60z" />
	</svg>
)

export const VerifiedBadgeIcon = () => (
	<svg className="w-3 h-3 text-green-800" fill="currentColor" viewBox="0 0 20 20" title="Verified">
		<path
			fillRule="evenodd"
			d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
			clipRule="evenodd"
		/>
	</svg>
)

export const NotVerifiedBadgeIcon = () => (
	<svg className="w-3 h-3 text-yellow-400" fill="currentColor" viewBox="0 0 20 20" title="Not Verified">
		<path
			fillRule="evenodd"
			d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
			clipRule="evenodd"
		/>
	</svg>
)

export const VitalsHeartIcon = ({ width = 20, height = 20, className = "", fill = "currentColor" }) => (
	<svg 
		width={width} 
		height={height} 
		viewBox="0 0 24 24" 
		className={className}
		fill="none" 
		xmlns="http://www.w3.org/2000/svg"
	>
		{/* Heart shape */}
		<path 
			d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" 
			fill={fill}
		/>
		{/* ECG/Heartbeat line inside heart - classic pulse waveform */}
		<path 
			d="M7 12 L8.5 12 L8.5 9 L10 9 L10 15 L11.5 15 L11.5 13 L13 13 L13 15 L14.5 15 L14.5 9 L16 9 L16 12 L17 12" 
			stroke="white" 
			strokeWidth="1.8" 
			strokeLinecap="round" 
			strokeLinejoin="round" 
			fill="none"
		/>
	</svg>
)

export const StatusNoIcon = ({ width = 16, height = 16 }) => (
	<svg width={width} height={height} viewBox="0 0 455.111 455.111" xmlns="http://www.w3.org/2000/svg">
		<circle fill="#E24C4B" cx="227.556" cy="227.556" r="227.556" />
		<path fill="#D1403F" d="M455.111,227.556c0,125.156-102.4,227.556-227.556,227.556c-72.533,0-136.533-32.711-177.778-85.333c38.4,31.289,88.178,49.778,142.222,49.778c125.156,0,227.556-102.4,227.556-227.556c0-54.044-18.489-103.822-49.778-142.222C422.4,91.022,455.111,155.022,455.111,227.556z" />
		<path fill="#FFFFFF" d="M331.378,331.378c-8.533,8.533-22.756,8.533-31.289,0l-72.533-72.533l-72.533,72.533c-8.533,8.533-22.756,8.533-31.289,0c-8.533-8.533-8.533-22.756,0-31.289l72.533-72.533l-72.533-72.533c-8.533-8.533-8.533-22.756,0-31.289c8.533-8.533,22.756-8.533,31.289,0l72.533,72.533l72.533-72.533c8.533-8.533,22.756-8.533,31.289,0c8.533,8.533,8.533,22.756,0,31.289l-72.533,72.533l72.533,72.533C339.911,308.622,339.911,322.844,331.378,331.378z" />
	</svg>
)

export const StatusYesIcon = ({ width = 16, height = 16 }) => (
	<svg width={width} height={height} viewBox="0 0 2.54 2.54" xmlns="http://www.w3.org/2000/svg">
		<circle cx="1.27" cy="1.27" fill="#48b02c" r="1.27" />
		<path d="m1.90275 1.03316c-.00108.00116-.00218.00232-.00331.00345l-.73054.73054c-.01562.01562-.03445.0263-.05446.03203-.0435.01299-.09299.00255-.12689-.03134l-.43143-.43143c-.049-.04901-.04945-.13014 0-.1796l.00001-.00001c.04946-.04945.13014-.04945.1796 0l.34209.34209.7265-.7265c.04945-.04946.13041-.04918.17959 0l.00001.00001c.04918.04918.04918.13041 0 .17959z" fill="#fff" />
	</svg>
)

export const FaxMachineIcon = ({ width = 16, height = 16, bgColor = "#1d81ce", iconColor = "#fff" }) => (
	<svg width={width} height={height} viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
		<rect fill={bgColor} x="6" y="6" width="500" height="500" rx="29.9" ry="29.9" />
		<path fill={iconColor} fillRule="evenodd" d="M371.5,280.1h-29c-10.2,0-10.2-15.4,0-15.4h29c10,0,10,15.4,0,15.4ZM385.5,401.8h-192.7c-2.1,10.2-11.3,17.9-22.3,17.9h-49.1c-12.7,0-22.8-10.2-22.8-22.8v-225.8c0-12.5,10.2-22.8,22.8-22.8h49.1c10.9,0,20.2,7.9,22.3,18h26.5v-66.4c0-4.2,3.3-7.7,7.5-7.7h137.8c4.4,0,7.7,3.5,7.7,7.7v66.4h13.2c15.4,0,28,12.5,28,28v179.5c0,15.4-12.7,28-28,28ZM178,171.1c0-4-3.3-7.5-7.5-7.5h-49.1c-4.2,0-7.5,3.5-7.5,7.5v225.8c0,4.2,3.3,7.5,7.5,7.5h49.1c4.2,0,7.5-3.3,7.5-7.5v-225.8ZM193.3,386.4h192.2c6.9,0,12.7-5.8,12.7-12.7v-179.5c0-6.9-5.8-12.7-12.7-12.7h-192.2v204.8ZM234.4,166.3h122.5v-58.7h-122.5v58.7ZM372,245.7h-152.6c-6.7,0-12.3-5.4-12.3-12.3v-21.7c0-6.7,5.6-12.3,12.3-12.3h152.6c6.7,0,12.3,5.6,12.3,12.3v21.7c0,6.9-5.6,12.3-12.3,12.3ZM222.5,230.6h146.5v-15.7h-146.5v15.7ZM326.2,131.7h-61c-10,0-10-15.4,0-15.4h61c10.2,0,10.2,15.4,0,15.4ZM326.2,157.6h-61c-10,0-10-15.4,0-15.4h61c10.2,0,10.2,15.4,0,15.4ZM249,368.6h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4ZM310.2,368.6h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4ZM371.5,368.6h-29c-10.2,0-10.2-15.4,0-15.4h29c10,0,10,15.4,0,15.4ZM249,339h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4ZM310.2,339h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4ZM371.5,339h-29c-10.2,0-10.2-15.4,0-15.4h29c10,0,10,15.4,0,15.4ZM249,309.7h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4ZM310.2,309.7h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4ZM371.5,309.7h-29c-10.2,0-10.2-15.4,0-15.4h29c10,0,10,15.4,0,15.4ZM249,280.1h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4ZM310.2,280.1h-29c-10.2,0-10.2-15.4,0-15.4h29c10.2,0,10.2,15.4,0,15.4Z" />
	</svg>
)

// Spread Icon for Expand All (arrows pointing outward)
export const SpreadIcon = ({ className = "w-5 h-5", fill = "currentColor" }) => (
	<svg 
		id="fi_8367642" 
		enableBackground="new 0 0 491.5 491.5" 
		height="512" 
		viewBox="0 0 491.5 491.5" 
		width="512" 
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		fill={fill}
	>
		<g>
			<path d="m159.2 30.7h-128.5v128.5l47.3-47.3 99.4 99.4 33.9-33.9-99.4-99.4z"></path>
			<path d="m177.4 280.2-99.4 99.4-47.3-47.3v128.5h128.5c-3-5-40.1-40.1-47.3-47.3l99.4-99.4z"></path>
			<path d="m413.5 379.6-99.4-99.4-33.9 33.9 99.4 99.4-47.3 47.3h128.5s0-117.8 0-128.5z"></path>
			<path d="m314.1 211.3 99.4-99.4 47.3 47.3v-128.5h-128.5l47.3 47.3-99.4 99.4c2.8 2.9 33.9 33.9 33.9 33.9z"></path>
		</g>
	</svg>
)

// Collapse Icon for Compress All (arrows pointing inward - reversed spread)
export const CollapseIcon = ({ className = "w-5 h-5", fill = "currentColor" }) => (
	<svg 
		enableBackground="new 0 0 491.5 491.5" 
		height="512" 
		viewBox="0 0 491.5 491.5" 
		width="512" 
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		fill={fill}
	>
		<g>
			<path d="m332.3 460.8h128.5v-128.5l-47.3 47.3-99.4-99.4-33.9 33.9 99.4 99.4z"></path>
			<path d="m314.1 211.3 99.4-99.4 47.3 47.3v-128.5h-128.5c3 5 40.1 40.1 47.3 47.3l-99.4 99.4z"></path>
			<path d="m78 111.9 99.4 99.4 33.9-33.9-99.4-99.4 47.3-47.3h-128.5s0 117.8 0 128.5z"></path>
			<path d="m177.4 280.2-99.4-99.4-47.3-47.3v128.5h128.5l-47.3-47.3 99.4-99.4c-2.8-2.9-33.9-33.9-33.9-33.9z"></path>
		</g>
	</svg>
)

export const AttendanceIcon = ({ className = "size-6 btnnn text-orange-500" }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 105 119"
			fill="none"
			className={className}
		>
			<rect x="13.5" y="27.5" width="78" height="76" rx="7.5" stroke="currentColor" strokeWidth="3" fill="white" />
			<rect x="13.5" y="37.5" width="78" height="66" stroke="currentColor" strokeWidth="3" fill="white" />
			<circle cx="52.5" cy="70.5" r="22" stroke="currentColor" strokeWidth="3" />
			<path d="M42.5 71.5L50.25 79.25L63.5 64.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
			<rect x="25" y="13" width="6" height="18" rx="3" stroke="currentColor" strokeWidth="3" fill="white" />
			<rect x="47" y="13" width="6" height="18" rx="3" stroke="currentColor" strokeWidth="3" fill="white" />
			<rect x="69" y="13" width="6" height="18" rx="3" stroke="currentColor" strokeWidth="3" fill="white" />
			<rect x="74" y="89" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="3" fill="white" />
			<path d="M81.3223 101.553L74 105l3.447-7.322" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
		</svg>
	);
};

export const HeaderMessageIcon = ({ className = "", width = 25, height = 25 }) => {
	return (
		<svg 
			width={width} 
			height={height} 
			viewBox="0 0 24 24" 
			fill="none" 
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path 
				d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z" 
				stroke="white" 
				strokeWidth="1.5" 
				strokeMiterlimit="10" 
				strokeLinecap="round" 
				strokeLinejoin="round" 
			/>
			<path 
				d="M7 8H17M7 13H13" 
				stroke="white" 
				strokeWidth="1.5" 
				strokeLinecap="round" 
				strokeLinejoin="round" 
			/>
		</svg>
	);
};

export const HeaderFileManagerIcon = ({ className = "", width = 25, height = 25 }) => {
	return (
		<svg 
			width={width} 
			height={height} 
			viewBox="0 0 16 16" 
			fill="none" 
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path 
				d="M0 1H6L9 4H16V14H0V1Z" 
				fill="white" 
			/>
		</svg>
	);
};

export const HeaderMenuIcon = ({ className = "", width = 24, height = 24 }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M23 19V16.5H15.6667V19H23ZM23 12.75V10.25H15.6667H8.33333V12.75H15.6667H23ZM23 6.5V4H1V6.5H23Z"
				fill="white"
			/>
		</svg>
	);
};

export const ChevronDownIcon = ({ className = "w-2.5 h-2.5 ml-2.5" }) => {
	return (
		<svg
			className={className}
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 10 6"
		>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="m1 1 4 4 4-4"
			/>
		</svg>
	);
};

export const WarningIcon = ({ className = "mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200" }) => {
	return (
		<svg 
			className={className} 
			aria-hidden="true" 
			xmlns="http://www.w3.org/2000/svg"
			fill="none" 
			viewBox="0 0 20 20"
		>
			<path 
				stroke="currentColor" 
				strokeLinecap="round" 
				strokeLinejoin="round" 
				strokeWidth="2" 
				d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" 
			/>
		</svg>
	);
};

// export const PillIcon = ({ color = "currentColor", width = 20, height = 20, className = "flex-shrink-0" }) => (
// 	<svg
// 		xmlns="http://www.w3.org/2000/svg"
// 		width={width}
// 		height={height}
// 		viewBox="0 0 24 24"
// 		fill="none"
// 		stroke={color}
// 		strokeWidth="2"
// 		strokeLinecap="round"
// 		strokeLinejoin="round"
// 		className={`lucide lucide-pill ${className}`}
// 	>
// 		<path d="m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z"></path>
// 		<path d="m8.5 8.5 7 7"></path>
// 	</svg>
// );

/** AI / Sparkles icon for AI actions (e.g. investigation page Map Drug RX / AI button) */
export const AIIcon = ({ className = "w-4 h-4", strokeWidth = 2 }) => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className}>
		<path d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
	</svg>
);

// Video call icons (match DriverAppReact)
export const MicIcon = ({ className = "w-5 h-5", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 435.149 435.149" xmlns="http://www.w3.org/2000/svg" fill={color}>
		<path d="M356.992,224.922c0-8.483-6.877-15.36-15.36-15.36s-15.36,6.877-15.36,15.36c-0.009,60.032-48.682,108.69-108.714,108.681 c-60.019-0.009-108.672-48.662-108.681-108.681c0-8.483-6.877-15.36-15.36-15.36s-15.36,6.877-15.36,15.36 c0.081,71.019,53.479,130.653,124.058,138.547v40.96h-55.859c-8.483,0-15.36,6.877-15.36,15.36s6.877,15.36,15.36,15.36h142.438 c8.483,0,15.36-6.877,15.36-15.36s-6.877-15.36-15.36-15.36h-55.859v-40.96C303.513,355.575,356.911,295.941,356.992,224.922z" />
		<path d="M217.574,0c-47.307,0-85.658,38.35-85.658,85.658v138.701c0.056,47.284,38.374,85.601,85.658,85.658 c47.284-0.056,85.601-38.374,85.658-85.658V85.658C303.232,38.35,264.882,0,217.574,0z" />
	</svg>
);

export const MicOffIcon = ({ className = "w-5 h-5", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill={color}>
		<path d="m23.292 20.293a.986.986 0 0 1 -.411-.089 1 1 0 0 1 -.5-1.323 6.949 6.949 0 0 0 .619-2.881 1 1 0 0 1 2 0 8.933 8.933 0 0 1 -.8 3.7 1 1 0 0 1 -.908.593z" />
		<path d="m11 8a5 5 0 0 1 10 0v8a1 1 0 0 1 -1 1z" />
		<path d="m26.707 25.293-20-20a1 1 0 0 0 -1.414 1.414l5.707 5.707v3.586a5 5 0 0 0 7.757 4.171l1.43 1.43a6.991 6.991 0 0 1 -11.187-5.601 1 1 0 0 0 -2 0 9.01 9.01 0 0 0 8 8.941v2.059h-3a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2h-3v-2.059a8.913 8.913 0 0 0 4.615-1.912l3.678 3.678a1 1 0 0 0 1.414-1.414z" />
	</svg>
);

export const VideoIcon = ({ className = "w-5 h-5", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 467.968 467.968" xmlns="http://www.w3.org/2000/svg" fill={color}>
		<path d="M264.704,96.512H51.2c-28.16,0-51.2,23.04-51.2,51.2v172.544c0,28.16,23.04,51.2,51.2,51.2h213.504 c28.16,0,51.2-23.04,51.2-51.2V147.712C315.904,119.04,292.864,96.512,264.704,96.512z" />
		<path d="M430.08,124.672c-3.072,0.512-6.144,2.048-8.704,3.584l-79.872,46.08V293.12l80.384,46.08 c14.848,8.704,33.28,3.584,41.984-11.264c2.56-4.608,4.096-9.728,4.096-15.36V154.368 C467.968,135.424,450.048,120.064,430.08,124.672z" />
	</svg>
);

export const VideoOffIcon = ({ className = "w-5 h-5", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill={color}>
		<path d="m.98 12.9 9.86-9.86c-.11-.03-.22-.04-.34-.04h-9c-.83 0-1.5.67-1.5 1.5v7c0 .65.41 1.2.98 1.4z" />
		<path d="m15.28 4.05-3.28 1.64v-.983l3.854-3.854c.195-.195.195-.512 0-.707s-.512-.195-.707 0l-15 15c-.195.195-.195.512 0 .707s.512.195.707 0l2.853-2.853h6.793c.83 0 1.5-.67 1.5-1.5v-1.19l3.28 1.64c.185.079.356.058.48-.02.15-.1.24-.26.24-.43v-7c0-.17-.09-.33-.24-.43-.14-.09-.33-.1-.48-.02z" />
	</svg>
);

export const CallEndedIcon = ({ className = "w-5 h-5", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipRule="evenodd" fill={color} fillRule="evenodd">
			<path d="m23.1931 26.8105c-2.1672-1.0388-4.136-2.5242-5.7309-4.3341l1.8757-1.6528c1.3689 1.5534 3.0625 2.8326 4.924 3.7268.0355.0154.1018.0329.1882.0329.0627 0 .121-.0092.1917-.0358l2.8346-1.4667.0177-.0084c.6017-.2878 1.2277-.3776 1.8207-.3548l.0239.0009.0239.0019c.6359.0489 1.2194.2457 1.7401.5534l.0434.0256 3.1908 2.2505c.5385.3557.9833.8275 1.3096 1.3869.3141.5385.5252 1.138.596 1.7752l.0025.0228.0017.0229c.0468.6315-.047 1.2685-.2487 1.8512l-.0069.02-.0076.0198c-.2275.5914-.5741 1.1296-1.0432 1.5789l-2.7475 2.7475-.0259.0231c-.8497.7603-1.9514 1.2123-3.1261 1.2349l-.0347.0007-.0346-.0013c-2.7396-.0993-7.8887-1.6653-15.7387-9.5153l1.7678-1.7677c7.5671 7.5671 12.1412 8.7026 14.0247 8.7832.5363-.018 1.0461-.2238 1.4513-.577l2.7176-2.7176.0116-.011c.1865-.1772.3332-.395.4366-.6562.0906-.2698.1283-.5497.1127-.8057-.0318-.2555-.1199-.5148-.2681-.7687-.1362-.2335-.3175-.4234-.5364-.5661l-.0191-.0124-3.1386-2.2137c-.1933-.1079-.3904-.1701-.599-.1894-.2537-.0068-.4494.0338-.6069.1061l-2.8862 1.4933-.0417.0179c-.3808.1632-.7811.2511-1.209.2511-.4097 0-.8414-.0809-1.2405-.2651z" />
			<path d="m11.0244 6.26325c-.2952-.02186-.5566.01276-.7923.10341-.26992.10384-.49414.25311-.67575.44428l-.01103.01161-2.71139 2.71139c-.3507.41505-.55227.92966-.58272 1.47156.06845 1.6115.90937 5.1831 5.87529 10.8907.4531.5208.3983 1.3103-.1225 1.7635-.5209.4531-1.3104.3983-1.7636-.1226-5.25091-6.0351-6.41008-10.1494-6.48958-12.4948l-.00155-.0457.00179-.0456c.04429-1.12946.46582-2.22 1.22347-3.08906l.0281-.03223 2.75324-2.75325c.44932-.4691.98742-.8157 1.57883-1.04316.6304-.24246 1.2684-.3079 1.8727-.26334.6835.0491 1.2994.26877 1.8392.58365.5594.32632 1.0312.77111 1.3869 1.30956l2.2505 3.19082.0256.04337c.2902.49115.5189 1.0745.5701 1.74014l.0037.0478v.048c0 .5594-.0859 1.1542-.337 1.7317l-.0168.0387-1.4839 2.868c-.0143.0372-.0289.0993-.0289.1783 0 .0281.0061.0881.0591.2443.2957.6272.6525 1.2363 1.0476 1.829.3829.5744.2277 1.3505-.3467 1.7334s-1.3505.2277-1.7335-.3467c-.46-.6901-.8939-1.4293-1.2599-2.2162l-.0243-.0523-.0195-.0544c-.0969-.2714-.2228-.6681-.2228-1.1371 0-.4097.0809-.8413.2651-1.2405l.0118-.0255 1.4735-2.848c.0694-.1725.1109-.3847.1157-.65-.0205-.1779-.0846-.3683-.203-.5778l-2.2144-3.13966-.0125-.01904c-.1427-.21892-.3326-.40026-.5661-.53644-.2597-.15153-.51-.23177-.7592-.24957z" />
			<path d="m31.7839 8.24942c.4882.48815.4882 1.27961 0 1.76778l-21.7332 21.7334c-.4882.4881-1.27966.4881-1.76782 0-.48815-.4882-.48816-1.2796 0-1.7678l21.73332-21.73338c.4881-.48815 1.2796-.48816 1.7677 0z" />
		</g>
	</svg>
);

/** Video call patient info: PHN (id card) */
export const VideoCallPhnIcon = ({ className = "w-4 h-4", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<rect width="18" height="14" x="3" y="5" rx="2" />
		<path d="M3 10h18" />
		<path d="M7 15h2" />
		<path d="M12 15h6" />
	</svg>
);

/** Video call patient info: Gender */
export const VideoCallGenderIcon = ({ className = "w-4 h-4", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<circle cx="12" cy="8" r="4" />
		<path d="M12 12v8" />
		<path d="M8 20h8" />
	</svg>
);

/** Video call patient info: DOB (calendar) */
export const VideoCallDobIcon = ({ className = "w-4 h-4", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<path d="M8 2v4" />
		<path d="M16 2v4" />
		<rect width="18" height="18" x="3" y="4" rx="2" />
		<path d="M3 10h18" />
	</svg>
);

/** Video call patient info: Address */
export const VideoCallAddressIcon = ({ className = "w-4 h-4", color = "currentColor" }) => (
	<svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<path d="M12 21s-6-4.35-6-10a6 6 0 1 1 12 0c0 5.65-6 10-6 10Z" />
		<circle cx="12" cy="11" r="2.5" />
	</svg>
);

export const CheckCircleSvgIcon = ({ className = "w-5 h-5" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		className={className}
	>
		<circle cx="10" cy="10" r="10" fill="#000" />
		<path
			d="M5.5 10.2L8.5 13.2L14.5 7.5"
			fill="none"
			stroke="#fff"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
